/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1);
	
	__webpack_require__(2);
	
	__webpack_require__(3);
	
	__webpack_require__(4);
	
	__webpack_require__(5);
	
	__webpack_require__(6);
	
	__webpack_require__(7);
	
	__webpack_require__(8);
	
	__webpack_require__(9);
	
	__webpack_require__(10);
	
	__webpack_require__(11);
	
	__webpack_require__(12);
	
	__webpack_require__(13);
	
	__webpack_require__(14);
	
	__webpack_require__(15);
	
	__webpack_require__(16);
	
	__webpack_require__(17);
	
	__webpack_require__(18);
	
	__webpack_require__(19);
	
	__webpack_require__(20);
	
	__webpack_require__(21);
	
	__webpack_require__(22);
	
	__webpack_require__(23);
	
	__webpack_require__(24);
	
	__webpack_require__(25);
	
	__webpack_require__(26);
	
	__webpack_require__(27);
	
	__webpack_require__(28);
	
	__webpack_require__(29);
	
	__webpack_require__(30);
	
	__webpack_require__(31);
	
	__webpack_require__(32);
	
	__webpack_require__(33);
	
	__webpack_require__(34);
	
	__webpack_require__(35);
	
	__webpack_require__(36);
	
	__webpack_require__(37);
	
	__webpack_require__(38);
	
	__webpack_require__(39);
	
	__webpack_require__(40);
	
	__webpack_require__(41);
	
	__webpack_require__(42);
	
	__webpack_require__(43);
	
	__webpack_require__(44);
	
	__webpack_require__(45);
	
	__webpack_require__(46);
	
	__webpack_require__(47);
	
	__webpack_require__(48);
	
	__webpack_require__(49);
	
	__webpack_require__(50);
	
	__webpack_require__(51);
	
	__webpack_require__(52);
	
	__webpack_require__(53);
	
	__webpack_require__(54);
	
	__webpack_require__(55);
	
	__webpack_require__(56);
	
	__webpack_require__(57);
	
	__webpack_require__(58);
	
	__webpack_require__(59);

/***/ },
/* 1 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Licensed to the Apache Software Foundation (ASF) under one or more
	 * contributor license agreements.  See the NOTICE file distributed with
	 * this work for additional information regarding copyright ownership.
	 * The ASF licenses this file to You under the Apache License, Version 2.0
	 * (the "License"); you may not use this file except in compliance with
	 * the License.  You may obtain a copy of the License at
	 *
	 *    http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	var zeppelinWebApp = angular.module('zeppelinWebApp', ['ngCookies', 'ngAnimate', 'ngRoute', 'ngSanitize', 'angular-websocket', 'ui.ace', 'ui.bootstrap', 'as.sortable', 'ngTouch', 'ngDragDrop', 'angular.filter', 'monospaced.elastic', 'puElasticInput', 'xeditable', 'ngToast', 'focus-if', 'ngResource', 'ngclipboard']).filter('breakFilter', function () {
	  return function (text) {
	    if (!!text) {
	      return text.replace(/\n/g, '<br />');
	    }
	  };
	}).config(["$httpProvider", "$routeProvider", "ngToastProvider", function ($httpProvider, $routeProvider, ngToastProvider) {
	  // withCredentials when running locally via grunt
	  $httpProvider.defaults.withCredentials = true;
	
	  var visBundleLoad = {
	    load: ['heliumService', function (heliumService) {
	      return heliumService.load;
	    }]
	  };
	
	  $routeProvider.when('/', {
	    templateUrl: 'app/home/home.html'
	  }).when('/notebook/:noteId', {
	    templateUrl: 'app/notebook/notebook.html',
	    controller: 'NotebookCtrl',
	    resolve: visBundleLoad
	  }).when('/notebook/:noteId/paragraph?=:paragraphId', {
	    templateUrl: 'app/notebook/notebook.html',
	    controller: 'NotebookCtrl',
	    resolve: visBundleLoad
	  }).when('/notebook/:noteId/paragraph/:paragraphId?', {
	    templateUrl: 'app/notebook/notebook.html',
	    controller: 'NotebookCtrl',
	    resolve: visBundleLoad
	  }).when('/notebook/:noteId/revision/:revisionId', {
	    templateUrl: 'app/notebook/notebook.html',
	    controller: 'NotebookCtrl',
	    resolve: visBundleLoad
	  }).when('/jobmanager', {
	    templateUrl: 'app/jobmanager/jobmanager.html',
	    controller: 'JobmanagerCtrl'
	  }).when('/interpreter', {
	    templateUrl: 'app/interpreter/interpreter.html',
	    controller: 'InterpreterCtrl'
	  }).when('/notebookRepos', {
	    templateUrl: 'app/notebookRepos/notebookRepos.html',
	    controller: 'NotebookReposCtrl',
	    controllerAs: 'noterepo'
	  }).when('/credential', {
	    templateUrl: 'app/credential/credential.html',
	    controller: 'CredentialCtrl'
	  }).when('/helium', {
	    templateUrl: 'app/helium/helium.html',
	    controller: 'HeliumCtrl'
	  }).when('/configuration', {
	    templateUrl: 'app/configuration/configuration.html',
	    controller: 'ConfigurationCtrl'
	  }).when('/search/:searchTerm', {
	    templateUrl: 'app/search/result-list.html',
	    controller: 'SearchResultCtrl'
	  }).otherwise({
	    redirectTo: '/'
	  });
	
	  ngToastProvider.configure({
	    dismissButton: true,
	    dismissOnClick: false,
	    combineDuplications: true,
	    timeout: 6000
	  });
	}])
	
	//handel logout on API failure
	.config(["$httpProvider", "$provide", function ($httpProvider, $provide) {
	  $provide.factory('httpInterceptor', ["$q", "$rootScope", function ($q, $rootScope) {
	    return {
	      'responseError': function responseError(rejection) {
	        if (rejection.status === 405) {
	          var data = {};
	          data.info = '';
	          $rootScope.$broadcast('session_logout', data);
	        }
	        $rootScope.$broadcast('httpResponseError', rejection);
	        return $q.reject(rejection);
	      }
	    };
	  }]);
	  $httpProvider.interceptors.push('httpInterceptor');
	}]).constant('TRASH_FOLDER_ID', '~Trash');
	
	function auth() {
	  var $http = angular.injector(['ng']).get('$http');
	  var baseUrlSrv = angular.injector(['zeppelinWebApp']).get('baseUrlSrv');
	  // withCredentials when running locally via grunt
	  $http.defaults.withCredentials = true;
	  jQuery.ajaxSetup({
	    dataType: 'json',
	    xhrFields: {
	      withCredentials: true
	    },
	    crossDomain: true
	  });
	  return $http.get(baseUrlSrv.getRestApiBase() + '/security/ticket').then(function (response) {
	    zeppelinWebApp.run(["$rootScope", function ($rootScope) {
	      $rootScope.ticket = angular.fromJson(response.data).body;
	    }]);
	  }, function (errorResponse) {
	    // Handle error case
	  });
	}
	
	function bootstrapApplication() {
	  zeppelinWebApp.run(["$rootScope", "$location", function ($rootScope, $location) {
	    $rootScope.$on('$routeChangeStart', function (event, next, current) {
	      if (!$rootScope.ticket && next.$$route && !next.$$route.publicAccess) {
	        $location.path('/');
	      }
	    });
	  }]);
	  angular.bootstrap(document, ['zeppelinWebApp']);
	}
	
	angular.element(document).ready(function () {
	  auth().then(bootstrapApplication);
	});

/***/ },
/* 2 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').controller('MainCtrl', MainCtrl);
	
	MainCtrl.$inject = ['$scope', '$rootScope', '$window', 'arrayOrderingSrv'];
	
	function MainCtrl($scope, $rootScope, $window, arrayOrderingSrv) {
	  $scope.looknfeel = 'default';
	
	  var init = function init() {
	    $scope.asIframe = $window.location.href.indexOf('asIframe') > -1 ? true : false;
	  };
	
	  init();
	
	  $rootScope.$on('setIframe', function (event, data) {
	    if (!event.defaultPrevented) {
	      $scope.asIframe = data;
	      event.preventDefault();
	    }
	  });
	
	  $rootScope.$on('setLookAndFeel', function (event, data) {
	    if (!event.defaultPrevented && data && data !== '' && data !== $scope.looknfeel) {
	      $scope.looknfeel = data;
	      event.preventDefault();
	    }
	  });
	
	  // Set The lookAndFeel to default on every page
	  $rootScope.$on('$routeChangeStart', function (event, next, current) {
	    $rootScope.$broadcast('setLookAndFeel', 'default');
	  });
	
	  $rootScope.noteName = function (note) {
	    if (!_.isEmpty(note)) {
	      return arrayOrderingSrv.getNoteName(note);
	    }
	  };
	
	  BootstrapDialog.defaultOptions.onshown = function () {
	    angular.element('#' + this.id).find('.btn:last').focus();
	  };
	
	  // Remove BootstrapDialog animation
	  BootstrapDialog.configDefaultOptions({ animate: false });
	}

/***/ },
/* 3 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').controller('HomeCtrl', HomeCtrl);
	
	HomeCtrl.$inject = ['$scope', 'noteListDataFactory', 'websocketMsgSrv', '$rootScope', 'arrayOrderingSrv', 'ngToast', 'noteActionSrv', 'TRASH_FOLDER_ID'];
	
	function HomeCtrl($scope, noteListDataFactory, websocketMsgSrv, $rootScope, arrayOrderingSrv, ngToast, noteActionSrv, TRASH_FOLDER_ID) {
	  ngToast.dismiss();
	  var vm = this;
	  vm.notes = noteListDataFactory;
	  vm.websocketMsgSrv = websocketMsgSrv;
	  vm.arrayOrderingSrv = arrayOrderingSrv;
	
	  vm.notebookHome = false;
	  vm.noteCustomHome = true;
	  if ($rootScope.ticket !== undefined) {
	    vm.staticHome = false;
	  } else {
	    vm.staticHome = true;
	  }
	
	  $scope.isReloading = false;
	  $scope.TRASH_FOLDER_ID = TRASH_FOLDER_ID;
	  $scope.query = { q: '' };
	
	  $scope.initHome = function () {
	    websocketMsgSrv.getHomeNote();
	    vm.noteCustomHome = false;
	  };
	
	  $scope.reloadNoteList = function () {
	    websocketMsgSrv.reloadAllNotesFromRepo();
	    $scope.isReloadingNotes = true;
	  };
	
	  $scope.toggleFolderNode = function (node) {
	    node.hidden = !node.hidden;
	  };
	
	  angular.element('#loginModal').on('hidden.bs.modal', function (e) {
	    $rootScope.$broadcast('initLoginValues');
	  });
	
	  /*
	   ** $scope.$on functions below
	   */
	
	  $scope.$on('setNoteMenu', function (event, notes) {
	    $scope.isReloadingNotes = false;
	  });
	
	  $scope.$on('setNoteContent', function (event, note) {
	    if (vm.noteCustomHome) {
	      return;
	    }
	
	    if (note) {
	      vm.note = note;
	
	      // initialize look And Feel
	      $rootScope.$broadcast('setLookAndFeel', 'home');
	
	      // make it read only
	      vm.viewOnly = true;
	
	      vm.notebookHome = true;
	      vm.staticHome = false;
	    } else {
	      vm.staticHome = true;
	      vm.notebookHome = false;
	    }
	  });
	
	  $scope.renameNote = function (nodeId, nodePath) {
	    noteActionSrv.renameNote(nodeId, nodePath);
	  };
	
	  $scope.moveNoteToTrash = function (noteId) {
	    noteActionSrv.moveNoteToTrash(noteId, false);
	  };
	
	  $scope.moveFolderToTrash = function (folderId) {
	    noteActionSrv.moveFolderToTrash(folderId);
	  };
	
	  $scope.restoreNote = function (noteId) {
	    websocketMsgSrv.restoreNote(noteId);
	  };
	
	  $scope.restoreFolder = function (folderId) {
	    websocketMsgSrv.restoreFolder(folderId);
	  };
	
	  $scope.restoreAll = function () {
	    noteActionSrv.restoreAll();
	  };
	
	  $scope.renameFolder = function (node) {
	    noteActionSrv.renameFolder(node.id);
	  };
	
	  $scope.removeNote = function (noteId) {
	    noteActionSrv.removeNote(noteId, false);
	  };
	
	  $scope.removeFolder = function (folderId) {
	    noteActionSrv.removeFolder(folderId);
	  };
	
	  $scope.emptyTrash = function () {
	    noteActionSrv.emptyTrash();
	  };
	
	  $scope.clearAllParagraphOutput = function (noteId) {
	    noteActionSrv.clearAllParagraphOutput(noteId);
	  };
	
	  $scope.isFilterNote = function (note) {
	    if (!$scope.query.q) {
	      return true;
	    }
	
	    var noteName = note.name;
	    if (noteName.toLowerCase().indexOf($scope.query.q.toLowerCase()) > -1) {
	      return true;
	    }
	    return false;
	  };
	
	  $scope.getNoteName = function (note) {
	    return arrayOrderingSrv.getNoteName(note);
	  };
	}

/***/ },
/* 4 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/**
	 * HandsonHelper class
	 */
	var HandsonHelper = function () {
	  function HandsonHelper(columns, rows, comment) {
	    _classCallCheck(this, HandsonHelper);
	
	    this.columns = columns || [];
	    this.rows = rows || [];
	    this.comment = comment || '';
	    this._numericValidator = this._numericValidator.bind(this);
	  }
	
	  _createClass(HandsonHelper, [{
	    key: 'getHandsonTableConfig',
	    value: function getHandsonTableConfig(columns, columnNames, resultRows) {
	      var self = this;
	      return {
	        colHeaders: columnNames,
	        data: resultRows,
	        rowHeaders: false,
	        stretchH: 'all',
	        sortIndicator: true,
	        columns: columns,
	        columnSorting: true,
	        contextMenu: false,
	        manualColumnResize: true,
	        manualRowResize: true,
	        readOnly: true,
	        readOnlyCellClassName: '',
	        fillHandle: false,
	        fragmentSelection: true,
	        disableVisualSelection: true,
	        cells: function cells(ro, co, pro) {
	          var cellProperties = {};
	          var colType = columns[co].type;
	          cellProperties.renderer = function (instance, td, row, col, prop, value, cellProperties) {
	            self._cellRenderer(instance, td, row, col, prop, value, cellProperties, colType);
	          };
	          return cellProperties;
	        },
	        afterGetColHeader: function afterGetColHeader(col, TH) {
	          var instance = this;
	          var menu = self._buildDropDownMenu(columns[col].type);
	          var button = self._buildTypeSwitchButton();
	
	          self._addButtonMenuEvent(button, menu);
	
	          Handsontable.Dom.addEvent(menu, 'click', function (event) {
	            if (event.target.nodeName === 'LI') {
	              self._setColumnType(columns, event.target.data.colType, instance, col);
	            }
	          });
	          if (TH.firstChild.lastChild.nodeName === 'BUTTON') {
	            TH.firstChild.removeChild(TH.firstChild.lastChild);
	          }
	          TH.firstChild.appendChild(button);
	          TH.style['white-space'] = 'normal';
	        }
	      };
	    }
	  }, {
	    key: '_addButtonMenuEvent',
	
	
	    /*
	    ** Private Service Functions
	    */
	
	    value: function _addButtonMenuEvent(button, menu) {
	      Handsontable.Dom.addEvent(button, 'click', function (event) {
	        var changeTypeMenu;
	        var position;
	        var removeMenu;
	
	        document.body.appendChild(menu);
	
	        event.preventDefault();
	        event.stopImmediatePropagation();
	
	        changeTypeMenu = document.querySelectorAll('.changeTypeMenu');
	
	        for (var i = 0, len = changeTypeMenu.length; i < len; i++) {
	          changeTypeMenu[i].style.display = 'none';
	        }
	        menu.style.display = 'block';
	        position = button.getBoundingClientRect();
	
	        menu.style.top = position.top + (window.scrollY || window.pageYOffset) + 2 + 'px';
	        menu.style.left = position.left + 'px';
	
	        removeMenu = function removeMenu(event) {
	          if (menu.parentNode) {
	            menu.parentNode.removeChild(menu);
	          }
	        };
	        Handsontable.Dom.removeEvent(document, 'click', removeMenu);
	        Handsontable.Dom.addEvent(document, 'click', removeMenu);
	      });
	    }
	  }, {
	    key: '_buildDropDownMenu',
	    value: function _buildDropDownMenu(activeCellType) {
	      var menu = document.createElement('UL');
	      var types = ['text', 'numeric', 'date'];
	      var item;
	
	      menu.className = 'changeTypeMenu';
	
	      for (var i = 0, len = types.length; i < len; i++) {
	        item = document.createElement('LI');
	        if ('innerText' in item) {
	          item.innerText = types[i];
	        } else {
	          item.textContent = types[i];
	        }
	
	        item.data = { 'colType': types[i] };
	
	        if (activeCellType === types[i]) {
	          item.className = 'active';
	        }
	        menu.appendChild(item);
	      }
	
	      return menu;
	    }
	  }, {
	    key: '_buildTypeSwitchButton',
	    value: function _buildTypeSwitchButton() {
	      var button = document.createElement('BUTTON');
	
	      button.innerHTML = '\u25BC';
	      button.className = 'changeType';
	
	      return button;
	    }
	  }, {
	    key: '_isNumeric',
	    value: function _isNumeric(value) {
	      if (!isNaN(value)) {
	        if (value.length !== 0) {
	          if (Number(value) <= Number.MAX_SAFE_INTEGER && Number(value) >= Number.MIN_SAFE_INTEGER) {
	            return true;
	          }
	        }
	      }
	      return false;
	    }
	  }, {
	    key: '_cellRenderer',
	    value: function _cellRenderer(instance, td, row, col, prop, value, cellProperties, colType) {
	      if (colType === 'numeric' && this._isNumeric(value)) {
	        cellProperties.format = '0,0.[00000]';
	        td.style.textAlign = 'left';
	        Handsontable.renderers.NumericRenderer.apply(this, arguments);
	      } else if (value.length > '%html'.length && '%html ' === value.substring(0, '%html '.length)) {
	        td.innerHTML = value.substring('%html'.length);
	      } else {
	        Handsontable.renderers.TextRenderer.apply(this, arguments);
	      }
	    }
	  }, {
	    key: '_dateValidator',
	    value: function _dateValidator(value, callback) {
	      var d = moment(value);
	      return callback(d.isValid());
	    }
	  }, {
	    key: '_numericValidator',
	    value: function _numericValidator(value, callback) {
	      return callback(this._isNumeric(value));
	    }
	  }, {
	    key: '_setColumnType',
	    value: function _setColumnType(columns, type, instance, col) {
	      columns[col].type = type;
	      this._setColumnValidator(columns, col);
	      instance.updateSettings({ columns: columns });
	      instance.validateCells(null);
	      if (this._isColumnSorted(instance, col)) {
	        instance.sort(col, instance.sortOrder);
	      }
	    }
	  }, {
	    key: '_isColumnSorted',
	    value: function _isColumnSorted(instance, col) {
	      return instance.sortingEnabled && instance.sortColumn === col;
	    }
	  }, {
	    key: '_setColumnValidator',
	    value: function _setColumnValidator(columns, col) {
	      if (columns[col].type === 'numeric') {
	        columns[col].validator = this._numericValidator;
	      } else if (columns[col].type === 'date') {
	        columns[col].validator = this._dateValidator;
	      } else {
	        columns[col].validator = null;
	      }
	    }
	  }]);
	
	  return HandsonHelper;
	}();
	
	exports.default = HandsonHelper;

/***/ },
/* 5 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').controller('NotebookCtrl', NotebookCtrl);
	
	NotebookCtrl.$inject = ['$scope', '$route', '$routeParams', '$location', '$rootScope', '$http', 'websocketMsgSrv', 'baseUrlSrv', '$timeout', 'saveAsService', 'ngToast', 'noteActionSrv', 'noteVarShareService', 'TRASH_FOLDER_ID'];
	
	function NotebookCtrl($scope, $route, $routeParams, $location, $rootScope, $http, websocketMsgSrv, baseUrlSrv, $timeout, saveAsService, ngToast, noteActionSrv, noteVarShareService, TRASH_FOLDER_ID) {
	
	  ngToast.dismiss();
	
	  $scope.note = null;
	  $scope.moment = moment;
	  $scope.editorToggled = false;
	  $scope.tableToggled = false;
	  $scope.viewOnly = false;
	  $scope.showSetting = false;
	  $scope.looknfeelOption = ['default', 'simple', 'report'];
	  $scope.cronOption = [{ name: 'None', value: undefined }, { name: '1m', value: '0 0/1 * * * ?' }, { name: '5m', value: '0 0/5 * * * ?' }, { name: '1h', value: '0 0 0/1 * * ?' }, { name: '3h', value: '0 0 0/3 * * ?' }, { name: '6h', value: '0 0 0/6 * * ?' }, { name: '12h', value: '0 0 0/12 * * ?' }, { name: '1d', value: '0 0 0 * * ?' }];
	
	  $scope.interpreterSettings = [];
	  $scope.interpreterBindings = [];
	  $scope.isNoteDirty = null;
	  $scope.saveTimer = null;
	
	  var connectedOnce = false;
	  var isRevisionPath = function isRevisionPath(path) {
	    var pattern = new RegExp('^.*\/notebook\/[a-zA-Z0-9_]*\/revision\/[a-zA-Z0-9_]*');
	    return pattern.test(path);
	  };
	
	  $scope.noteRevisions = [];
	  $scope.currentRevision = 'Head';
	  $scope.revisionView = isRevisionPath($location.path());
	
	  $scope.$on('setConnectedStatus', function (event, param) {
	    if (connectedOnce && param) {
	      initNotebook();
	    }
	    connectedOnce = true;
	  });
	
	  $scope.getCronOptionNameFromValue = function (value) {
	    if (!value) {
	      return '';
	    }
	
	    for (var o in $scope.cronOption) {
	      if ($scope.cronOption[o].value === value) {
	        return $scope.cronOption[o].name;
	      }
	    }
	    return value;
	  };
	
	  $scope.blockAnonUsers = function () {
	    var zeppelinVersion = $rootScope.zeppelinVersion;
	    var url = 'https://zeppelin.apache.org/docs/' + zeppelinVersion + '/security/notebook_authorization.html';
	    var content = 'Only authenticated user can set the permission.' + '<a data-toggle="tooltip" data-placement="top" title="Learn more" target="_blank" href=' + url + '>' + '<i class="icon-question" />' + '</a>';
	    BootstrapDialog.show({
	      closable: false,
	      closeByBackdrop: false,
	      closeByKeyboard: false,
	      title: 'No permission',
	      message: content,
	      buttons: [{
	        label: 'Close',
	        action: function action(dialog) {
	          dialog.close();
	        }
	      }]
	    });
	  };
	
	  /** Init the new controller */
	  var initNotebook = function initNotebook() {
	    noteVarShareService.clear();
	    if ($routeParams.revisionId) {
	      websocketMsgSrv.getNoteByRevision($routeParams.noteId, $routeParams.revisionId);
	    } else {
	      websocketMsgSrv.getNote($routeParams.noteId);
	    }
	    websocketMsgSrv.listRevisionHistory($routeParams.noteId);
	    var currentRoute = $route.current;
	    if (currentRoute) {
	      setTimeout(function () {
	        var routeParams = currentRoute.params;
	        var $id = angular.element('#' + routeParams.paragraph + '_container');
	
	        if ($id.length > 0) {
	          // adjust for navbar
	          var top = $id.offset().top - 103;
	          angular.element('html, body').scrollTo({ top: top, left: 0 });
	        }
	      }, 1000);
	    }
	  };
	
	  initNotebook();
	
	  // force notebook reload on user change
	  $scope.$on('setNoteMenu', function (event, note) {
	    initNotebook();
	  });
	
	  $scope.focusParagraphOnClick = function (clickEvent) {
	    if (!$scope.note) {
	      return;
	    }
	    for (var i = 0; i < $scope.note.paragraphs.length; i++) {
	      var paragraphId = $scope.note.paragraphs[i].id;
	      if (jQuery.contains(angular.element('#' + paragraphId + '_container')[0], clickEvent.target)) {
	        $scope.$broadcast('focusParagraph', paragraphId, 0, true);
	        break;
	      }
	    }
	  };
	
	  // register mouseevent handler for focus paragraph
	  document.addEventListener('click', $scope.focusParagraphOnClick);
	
	  $scope.keyboardShortcut = function (keyEvent) {
	    // handle keyevent
	    if (!$scope.viewOnly && !$scope.revisionView) {
	      $scope.$broadcast('keyEvent', keyEvent);
	    }
	  };
	
	  // register mouseevent handler for focus paragraph
	  document.addEventListener('keydown', $scope.keyboardShortcut);
	
	  $scope.paragraphOnDoubleClick = function (paragraphId) {
	    $scope.$broadcast('doubleClickParagraph', paragraphId);
	  };
	
	  // Move the note to trash and go back to the main page
	  $scope.moveNoteToTrash = function (noteId) {
	    noteActionSrv.moveNoteToTrash(noteId, true);
	  };
	
	  // Remove the note permanently if it's in the trash
	  $scope.removeNote = function (noteId) {
	    noteActionSrv.removeNote(noteId, true);
	  };
	
	  $scope.isTrash = function (note) {
	    return note ? note.name.split('/')[0] === TRASH_FOLDER_ID : false;
	  };
	
	  //Export notebook
	  $scope.exportNote = function () {
	    var jsonContent = JSON.stringify($scope.note);
	    saveAsService.saveAs(jsonContent, $scope.note.name, 'json');
	  };
	
	  //Clone note
	  $scope.cloneNote = function (noteId) {
	    BootstrapDialog.confirm({
	      closable: true,
	      title: '',
	      message: 'Do you want to clone this note?',
	      callback: function callback(result) {
	        if (result) {
	          websocketMsgSrv.cloneNote(noteId);
	          $location.path('/');
	        }
	      }
	    });
	  };
	
	  // checkpoint/commit notebook
	  $scope.checkpointNote = function (commitMessage) {
	    BootstrapDialog.confirm({
	      closable: true,
	      title: '',
	      message: 'Commit note to current repository?',
	      callback: function callback(result) {
	        if (result) {
	          websocketMsgSrv.checkpointNote($routeParams.noteId, commitMessage);
	        }
	      }
	    });
	    document.getElementById('note.checkpoint.message').value = '';
	  };
	
	  // set notebook head to given revision
	  $scope.setNoteRevision = function () {
	    BootstrapDialog.confirm({
	      closable: true,
	      title: '',
	      message: 'Set notebook head to current revision?',
	      callback: function callback(result) {
	        if (result) {
	          websocketMsgSrv.setNoteRevision($routeParams.noteId, $routeParams.revisionId);
	        }
	      }
	    });
	  };
	
	  $scope.$on('listRevisionHistory', function (event, data) {
	    console.log('received list of revisions %o', data);
	    $scope.noteRevisions = data.revisionList;
	    $scope.noteRevisions.splice(0, 0, {
	      id: 'Head',
	      message: 'Head'
	    });
	    if ($routeParams.revisionId) {
	      var index = _.findIndex($scope.noteRevisions, { 'id': $routeParams.revisionId });
	      if (index > -1) {
	        $scope.currentRevision = $scope.noteRevisions[index].message;
	      }
	    }
	  });
	
	  $scope.$on('noteRevision', function (event, data) {
	    console.log('received note revision %o', data);
	    if (data.note) {
	      $scope.note = data.note;
	      initializeLookAndFeel();
	    } else {
	      $location.path('/');
	    }
	  });
	
	  $scope.$on('setNoteRevisionResult', function (event, data) {
	    console.log('received set note revision result %o', data);
	    if (data.status) {
	      $location.path('/notebook/' + $routeParams.noteId);
	    }
	  });
	
	  $scope.visitRevision = function (revision) {
	    if (revision.id) {
	      if (revision.id === 'Head') {
	        $location.path('/notebook/' + $routeParams.noteId);
	      } else {
	        $location.path('/notebook/' + $routeParams.noteId + '/revision/' + revision.id);
	      }
	    } else {
	      ngToast.danger({ content: 'There is a problem with this Revision',
	        verticalPosition: 'top', dismissOnTimeout: false });
	    }
	  };
	
	  $scope.runAllParagraphs = function (noteId) {
	    BootstrapDialog.confirm({
	      closable: true,
	      title: '',
	      message: 'Run all paragraphs?',
	      callback: function callback(result) {
	        if (result) {
	          var paragraphs = $scope.note.paragraphs.map(function (p) {
	            return {
	              id: p.id,
	              title: p.title,
	              paragraph: p.text,
	              config: p.config,
	              params: p.settings.params
	            };
	          });
	          websocketMsgSrv.runAllParagraphs(noteId, paragraphs);
	        }
	      }
	    });
	  };
	
	  $scope.saveNote = function () {
	    if ($scope.note && $scope.note.paragraphs) {
	      _.forEach($scope.note.paragraphs, function (par) {
	        angular.element('#' + par.id + '_paragraphColumn_main').scope().saveParagraph(par);
	      });
	      $scope.isNoteDirty = null;
	    }
	  };
	
	  $scope.clearAllParagraphOutput = function (noteId) {
	    noteActionSrv.clearAllParagraphOutput(noteId);
	  };
	
	  $scope.toggleAllEditor = function () {
	    if ($scope.editorToggled) {
	      $scope.$broadcast('openEditor');
	    } else {
	      $scope.$broadcast('closeEditor');
	    }
	    $scope.editorToggled = !$scope.editorToggled;
	  };
	
	  $scope.showAllEditor = function () {
	    $scope.$broadcast('openEditor');
	  };
	
	  $scope.hideAllEditor = function () {
	    $scope.$broadcast('closeEditor');
	  };
	
	  $scope.toggleAllTable = function () {
	    if ($scope.tableToggled) {
	      $scope.$broadcast('openTable');
	    } else {
	      $scope.$broadcast('closeTable');
	    }
	    $scope.tableToggled = !$scope.tableToggled;
	  };
	
	  $scope.showAllTable = function () {
	    $scope.$broadcast('openTable');
	  };
	
	  $scope.hideAllTable = function () {
	    $scope.$broadcast('closeTable');
	  };
	
	  $scope.isNoteRunning = function () {
	    if (!$scope.note) {
	      return false;
	    }
	    for (var i = 0; i < $scope.note.paragraphs.length; i++) {
	      var status = $scope.note.paragraphs[i].status;
	      if (status === 'PENDING' || status === 'RUNNING') {
	        return true;
	      }
	    }
	    return false;
	  };
	
	  $scope.killSaveTimer = function () {
	    if ($scope.saveTimer) {
	      $timeout.cancel($scope.saveTimer);
	      $scope.saveTimer = null;
	    }
	  };
	
	  $scope.startSaveTimer = function () {
	    $scope.killSaveTimer();
	    $scope.isNoteDirty = true;
	    //console.log('startSaveTimer called ' + $scope.note.id);
	    $scope.saveTimer = $timeout(function () {
	      $scope.saveNote();
	    }, 10000);
	  };
	
	  angular.element(window).on('beforeunload', function (e) {
	    $scope.killSaveTimer();
	    $scope.saveNote();
	  });
	
	  $scope.setLookAndFeel = function (looknfeel) {
	    $scope.note.config.looknfeel = looknfeel;
	    if ($scope.revisionView === true) {
	      $rootScope.$broadcast('setLookAndFeel', $scope.note.config.looknfeel);
	    } else {
	      $scope.setConfig();
	    }
	  };
	
	  /** Set cron expression for this note **/
	  $scope.setCronScheduler = function (cronExpr) {
	    if (cronExpr) {
	      if (!$scope.note.config.cronExecutingUser) {
	        $scope.note.config.cronExecutingUser = $rootScope.ticket.principal;
	      }
	    } else {
	      $scope.note.config.cronExecutingUser = '';
	    }
	    $scope.note.config.cron = cronExpr;
	    $scope.setConfig();
	  };
	
	  /** Set the username of the user to be used to execute all notes in notebook **/
	  $scope.setCronExecutingUser = function (cronExecutingUser) {
	    $scope.note.config.cronExecutingUser = cronExecutingUser;
	    $scope.setConfig();
	  };
	
	  /** Set release resource for this note **/
	  $scope.setReleaseResource = function (value) {
	    $scope.note.config.releaseresource = value;
	    $scope.setConfig();
	  };
	
	  /** Update note config **/
	  $scope.setConfig = function (config) {
	    if (config) {
	      $scope.note.config = config;
	    }
	    websocketMsgSrv.updateNote($scope.note.id, $scope.note.name, $scope.note.config);
	  };
	
	  /** Update the note name */
	  $scope.updateNoteName = function (newName) {
	    var trimmedNewName = newName.trim();
	    if (trimmedNewName.length > 0 && $scope.note.name !== trimmedNewName) {
	      $scope.note.name = trimmedNewName;
	      websocketMsgSrv.renameNote($scope.note.id, $scope.note.name);
	    }
	  };
	
	  var initializeLookAndFeel = function initializeLookAndFeel() {
	    if (!$scope.note.config.looknfeel) {
	      $scope.note.config.looknfeel = 'default';
	    } else {
	      $scope.viewOnly = $scope.note.config.looknfeel === 'report' ? true : false;
	    }
	
	    if ($scope.note.paragraphs && $scope.note.paragraphs[0]) {
	      $scope.note.paragraphs[0].focus = true;
	    }
	    $rootScope.$broadcast('setLookAndFeel', $scope.note.config.looknfeel);
	  };
	
	  var cleanParagraphExcept = function cleanParagraphExcept(paragraphId, note) {
	    var noteCopy = {};
	    noteCopy.id = note.id;
	    noteCopy.name = note.name;
	    noteCopy.config = note.config;
	    noteCopy.info = note.info;
	    noteCopy.paragraphs = [];
	    for (var i = 0; i < note.paragraphs.length; i++) {
	      if (note.paragraphs[i].id === paragraphId) {
	        noteCopy.paragraphs[0] = note.paragraphs[i];
	        if (!noteCopy.paragraphs[0].config) {
	          noteCopy.paragraphs[0].config = {};
	        }
	        noteCopy.paragraphs[0].config.editorHide = true;
	        noteCopy.paragraphs[0].config.tableHide = false;
	        break;
	      }
	    }
	    return noteCopy;
	  };
	
	  var addPara = function addPara(paragraph, index) {
	    $scope.note.paragraphs.splice(index, 0, paragraph);
	    _.each($scope.note.paragraphs, function (para) {
	      if (para.id === paragraph.id) {
	        para.focus = true;
	        $scope.$broadcast('focusParagraph', para.id, 0, false);
	      }
	    });
	  };
	
	  var removePara = function removePara(paragraphId) {
	    var removeIdx;
	    _.each($scope.note.paragraphs, function (para, idx) {
	      if (para.id === paragraphId) {
	        removeIdx = idx;
	      }
	    });
	    return $scope.note.paragraphs.splice(removeIdx, 1);
	  };
	
	  $scope.$on('addParagraph', function (event, paragraph, index) {
	    if ($scope.paragraphUrl) {
	      return;
	    }
	    addPara(paragraph, index);
	  });
	
	  $scope.$on('removeParagraph', function (event, paragraphId) {
	    if ($scope.paragraphUrl) {
	      return;
	    }
	    removePara(paragraphId);
	  });
	
	  $scope.$on('moveParagraph', function (event, paragraphId, newIdx) {
	    var removedPara = removePara(paragraphId);
	    if (removedPara && removedPara.length === 1) {
	      addPara(removedPara[0], newIdx);
	    }
	  });
	
	  $scope.$on('updateNote', function (event, name, config, info) {
	    /** update Note name */
	    if (name !== $scope.note.name) {
	      console.log('change note name to : %o', $scope.note.name);
	      $scope.note.name = name;
	    }
	    $scope.note.config = config;
	    $scope.note.info = info;
	    initializeLookAndFeel();
	  });
	
	  var getInterpreterBindings = function getInterpreterBindings() {
	    websocketMsgSrv.getInterpreterBindings($scope.note.id);
	  };
	
	  $scope.$on('interpreterBindings', function (event, data) {
	    $scope.interpreterBindings = data.interpreterBindings;
	    $scope.interpreterBindingsOrig = angular.copy($scope.interpreterBindings); // to check dirty
	
	    var selected = false;
	    var key;
	    var setting;
	
	    for (key in $scope.interpreterBindings) {
	      setting = $scope.interpreterBindings[key];
	      if (setting.selected) {
	        selected = true;
	        break;
	      }
	    }
	
	    if (!selected) {
	      // make default selection
	      var selectedIntp = {};
	      for (key in $scope.interpreterBindings) {
	        setting = $scope.interpreterBindings[key];
	        if (!selectedIntp[setting.name]) {
	          setting.selected = true;
	          selectedIntp[setting.name] = true;
	        }
	      }
	      $scope.showSetting = true;
	    }
	  });
	
	  $scope.interpreterSelectionListeners = {
	    accept: function accept(sourceItemHandleScope, destSortableScope) {
	      return true;
	    },
	    itemMoved: function itemMoved(event) {},
	    orderChanged: function orderChanged(event) {}
	  };
	
	  $scope.openSetting = function () {
	    $scope.showSetting = true;
	    getInterpreterBindings();
	  };
	
	  $scope.closeSetting = function () {
	    if (isSettingDirty()) {
	      BootstrapDialog.confirm({
	        closable: true,
	        title: '',
	        message: 'Interpreter setting changes will be discarded.',
	        callback: function callback(result) {
	          if (result) {
	            $scope.$apply(function () {
	              $scope.showSetting = false;
	            });
	          }
	        }
	      });
	    } else {
	      $scope.showSetting = false;
	    }
	  };
	
	  $scope.saveSetting = function () {
	    var selectedSettingIds = [];
	    for (var no in $scope.interpreterBindings) {
	      var setting = $scope.interpreterBindings[no];
	      if (setting.selected) {
	        selectedSettingIds.push(setting.id);
	      }
	    }
	    websocketMsgSrv.saveInterpreterBindings($scope.note.id, selectedSettingIds);
	    console.log('Interpreter bindings %o saved', selectedSettingIds);
	
	    _.forEach($scope.note.paragraphs, function (n, key) {
	      var regExp = /^\s*%/g;
	      if (n.text && !regExp.exec(n.text)) {
	        $scope.$broadcast('saveInterpreterBindings', n.id);
	      }
	    });
	
	    $scope.showSetting = false;
	  };
	
	  $scope.toggleSetting = function () {
	    if ($scope.showSetting) {
	      $scope.closeSetting();
	    } else {
	      $scope.openSetting();
	      $scope.closePermissions();
	    }
	  };
	
	  var getPermissions = function getPermissions(callback) {
	    $http.get(baseUrlSrv.getRestApiBase() + '/notebook/' + $scope.note.id + '/permissions').success(function (data, status, headers, config) {
	      $scope.permissions = data.body;
	      $scope.permissionsOrig = angular.copy($scope.permissions); // to check dirty
	
	      var selectJson = {
	        tokenSeparators: [',', ' '],
	        ajax: {
	          url: function url(params) {
	            if (!params.term) {
	              return false;
	            }
	            return baseUrlSrv.getRestApiBase() + '/security/userlist/' + params.term;
	          },
	          delay: 250,
	          processResults: function processResults(data, params) {
	            var results = [];
	
	            if (data.body.users.length !== 0) {
	              var users = [];
	              for (var len = 0; len < data.body.users.length; len++) {
	                users.push({
	                  'id': data.body.users[len],
	                  'text': data.body.users[len]
	                });
	              }
	              results.push({
	                'text': 'Users :',
	                'children': users
	              });
	            }
	            if (data.body.roles.length !== 0) {
	              var roles = [];
	              for (var len = 0; len < data.body.roles.length; len++) {
	                roles.push({
	                  'id': data.body.roles[len],
	                  'text': data.body.roles[len]
	                });
	              }
	              results.push({
	                'text': 'Roles :',
	                'children': roles
	              });
	            }
	            return {
	              results: results,
	              pagination: {
	                more: false
	              }
	            };
	          },
	          cache: false
	        },
	        width: ' ',
	        tags: true,
	        minimumInputLength: 3
	      };
	
	      $scope.setIamOwner();
	      angular.element('#selectOwners').select2(selectJson);
	      angular.element('#selectReaders').select2(selectJson);
	      angular.element('#selectWriters').select2(selectJson);
	      if (callback) {
	        callback();
	      }
	    }).error(function (data, status, headers, config) {
	      if (status !== 0) {
	        console.log('Error %o %o', status, data.message);
	      }
	    });
	  };
	
	  $scope.openPermissions = function () {
	    $scope.showPermissions = true;
	    getPermissions();
	  };
	
	  $scope.closePermissions = function () {
	    if (isPermissionsDirty()) {
	      BootstrapDialog.confirm({
	        closable: true,
	        title: '',
	        message: 'Changes will be discarded.',
	        callback: function callback(result) {
	          if (result) {
	            $scope.$apply(function () {
	              $scope.showPermissions = false;
	            });
	          }
	        }
	      });
	    } else {
	      $scope.showPermissions = false;
	    }
	  };
	
	  function convertPermissionsToArray() {
	    $scope.permissions.owners = angular.element('#selectOwners').val();
	    $scope.permissions.readers = angular.element('#selectReaders').val();
	    $scope.permissions.writers = angular.element('#selectWriters').val();
	  }
	
	  $scope.restartInterpreter = function (interpeter) {
	    var thisConfirm = BootstrapDialog.confirm({
	      closable: false,
	      closeByBackdrop: false,
	      closeByKeyboard: false,
	      title: '',
	      message: 'Do you want to restart ' + interpeter.name + ' interpreter?',
	      callback: function callback(result) {
	        if (result) {
	          var payload = {
	            'noteId': $scope.note.id
	          };
	
	          thisConfirm.$modalFooter.find('button').addClass('disabled');
	          thisConfirm.$modalFooter.find('button:contains("OK")').html('<i class="fa fa-circle-o-notch fa-spin"></i> Saving Setting');
	
	          $http.put(baseUrlSrv.getRestApiBase() + '/interpreter/setting/restart/' + interpeter.id, payload).success(function (data, status, headers, config) {
	            var index = _.findIndex($scope.interpreterSettings, { 'id': interpeter.id });
	            $scope.interpreterSettings[index] = data.body;
	            thisConfirm.close();
	          }).error(function (data, status, headers, config) {
	            thisConfirm.close();
	            console.log('Error %o %o', status, data.message);
	            BootstrapDialog.show({
	              title: 'Error restart interpreter.',
	              message: data.message
	            });
	          });
	          return false;
	        }
	      }
	    });
	  };
	
	  $scope.savePermissions = function () {
	    convertPermissionsToArray();
	    $http.put(baseUrlSrv.getRestApiBase() + '/notebook/' + $scope.note.id + '/permissions', $scope.permissions, { withCredentials: true }).success(function (data, status, headers, config) {
	      getPermissions(function () {
	        console.log('Note permissions %o saved', $scope.permissions);
	        BootstrapDialog.alert({
	          closable: true,
	          title: 'Permissions Saved Successfully!!!',
	          message: 'Owners : ' + $scope.permissions.owners + '\n\n' + 'Readers : ' + $scope.permissions.readers + '\n\n' + 'Writers  : ' + $scope.permissions.writers
	        });
	        $scope.showPermissions = false;
	      });
	    }).error(function (data, status, headers, config) {
	      console.log('Error %o %o', status, data.message);
	      BootstrapDialog.show({
	        closable: false,
	        closeByBackdrop: false,
	        closeByKeyboard: false,
	        title: 'Insufficient privileges',
	        message: data.message,
	        buttons: [{
	          label: 'Login',
	          action: function action(dialog) {
	            dialog.close();
	            angular.element('#loginModal').modal({
	              show: 'true'
	            });
	          }
	        }, {
	          label: 'Cancel',
	          action: function action(dialog) {
	            dialog.close();
	            $location.path('/');
	          }
	        }]
	      });
	    });
	  };
	
	  $scope.togglePermissions = function () {
	    var principal = $rootScope.ticket.principal;
	    $scope.isAnonymous = principal === 'anonymous' ? true : false;
	    if (!!principal && $scope.isAnonymous) {
	      $scope.blockAnonUsers();
	    } else {
	      if ($scope.showPermissions) {
	        $scope.closePermissions();
	        angular.element('#selectOwners').select2({});
	        angular.element('#selectReaders').select2({});
	        angular.element('#selectWriters').select2({});
	      } else {
	        $scope.openPermissions();
	        $scope.closeSetting();
	      }
	    }
	  };
	
	  $scope.setIamOwner = function () {
	    if ($scope.permissions.owners.length > 0 && _.indexOf($scope.permissions.owners, $rootScope.ticket.principal) < 0) {
	      $scope.isOwner = false;
	      return false;
	    }
	    $scope.isOwner = true;
	    return true;
	  };
	
	  $scope.toggleNotePersonalizedMode = function () {
	    var personalizedMode = $scope.note.config.personalizedMode;
	    if ($scope.isOwner) {
	      BootstrapDialog.confirm({
	        closable: true,
	        title: 'Setting the result display',
	        message: function message(dialog) {
	          var modeText = $scope.note.config.personalizedMode === 'true' ? 'collaborate' : 'personalize';
	          return 'Do you want to <span class="text-info">' + modeText + '</span> your analysis?';
	        },
	        callback: function callback(result) {
	          if (result) {
	            if ($scope.note.config.personalizedMode === undefined) {
	              $scope.note.config.personalizedMode = 'false';
	            }
	            $scope.note.config.personalizedMode = personalizedMode === 'true' ? 'false' : 'true';
	            websocketMsgSrv.updatePersonalizedMode($scope.note.id, $scope.note.config.personalizedMode);
	          }
	        }
	      });
	    }
	  };
	
	  var isSettingDirty = function isSettingDirty() {
	    if (angular.equals($scope.interpreterBindings, $scope.interpreterBindingsOrig)) {
	      return false;
	    } else {
	      return true;
	    }
	  };
	
	  var isPermissionsDirty = function isPermissionsDirty() {
	    if (angular.equals($scope.permissions, $scope.permissionsOrig)) {
	      return false;
	    } else {
	      return true;
	    }
	  };
	
	  angular.element(document).click(function () {
	    angular.element('.ace_autocomplete').hide();
	  });
	
	  /*
	   ** $scope.$on functions below
	   */
	
	  $scope.$on('setConnectedStatus', function (event, param) {
	    if (connectedOnce && param) {
	      initNotebook();
	    }
	    connectedOnce = true;
	  });
	
	  $scope.$on('moveParagraphUp', function (event, paragraph) {
	    var newIndex = -1;
	    for (var i = 0; i < $scope.note.paragraphs.length; i++) {
	      if ($scope.note.paragraphs[i].id === paragraph.id) {
	        newIndex = i - 1;
	        break;
	      }
	    }
	    if (newIndex < 0 || newIndex >= $scope.note.paragraphs.length) {
	      return;
	    }
	    // save dirtyText of moving paragraphs.
	    var prevParagraph = $scope.note.paragraphs[newIndex];
	    angular.element('#' + paragraph.id + '_paragraphColumn_main').scope().saveParagraph(paragraph);
	    angular.element('#' + prevParagraph.id + '_paragraphColumn_main').scope().saveParagraph(prevParagraph);
	    websocketMsgSrv.moveParagraph(paragraph.id, newIndex);
	  });
	
	  $scope.$on('moveParagraphDown', function (event, paragraph) {
	    var newIndex = -1;
	    for (var i = 0; i < $scope.note.paragraphs.length; i++) {
	      if ($scope.note.paragraphs[i].id === paragraph.id) {
	        newIndex = i + 1;
	        break;
	      }
	    }
	
	    if (newIndex < 0 || newIndex >= $scope.note.paragraphs.length) {
	      return;
	    }
	    // save dirtyText of moving paragraphs.
	    var nextParagraph = $scope.note.paragraphs[newIndex];
	    angular.element('#' + paragraph.id + '_paragraphColumn_main').scope().saveParagraph(paragraph);
	    angular.element('#' + nextParagraph.id + '_paragraphColumn_main').scope().saveParagraph(nextParagraph);
	    websocketMsgSrv.moveParagraph(paragraph.id, newIndex);
	  });
	
	  $scope.$on('moveFocusToPreviousParagraph', function (event, currentParagraphId) {
	    var focus = false;
	    for (var i = $scope.note.paragraphs.length - 1; i >= 0; i--) {
	      if (focus === false) {
	        if ($scope.note.paragraphs[i].id === currentParagraphId) {
	          focus = true;
	          continue;
	        }
	      } else {
	        $scope.$broadcast('focusParagraph', $scope.note.paragraphs[i].id, -1);
	        break;
	      }
	    }
	  });
	
	  $scope.$on('moveFocusToNextParagraph', function (event, currentParagraphId) {
	    var focus = false;
	    for (var i = 0; i < $scope.note.paragraphs.length; i++) {
	      if (focus === false) {
	        if ($scope.note.paragraphs[i].id === currentParagraphId) {
	          focus = true;
	          continue;
	        }
	      } else {
	        $scope.$broadcast('focusParagraph', $scope.note.paragraphs[i].id, 0);
	        break;
	      }
	    }
	  });
	
	  $scope.$on('insertParagraph', function (event, paragraphId, position) {
	    var newIndex = -1;
	    for (var i = 0; i < $scope.note.paragraphs.length; i++) {
	      if ($scope.note.paragraphs[i].id === paragraphId) {
	        //determine position of where to add new paragraph; default is below
	        if (position === 'above') {
	          newIndex = i;
	        } else {
	          newIndex = i + 1;
	        }
	        break;
	      }
	    }
	
	    if (newIndex < 0 || newIndex > $scope.note.paragraphs.length) {
	      return;
	    }
	    websocketMsgSrv.insertParagraph(newIndex);
	  });
	
	  $scope.$on('setNoteContent', function (event, note) {
	    if (note === undefined) {
	      $location.path('/');
	    }
	
	    $scope.note = note;
	
	    $scope.paragraphUrl = $routeParams.paragraphId;
	    $scope.asIframe = $routeParams.asIframe;
	    if ($scope.paragraphUrl) {
	      $scope.note = cleanParagraphExcept($scope.paragraphUrl, note);
	      $scope.$broadcast('$unBindKeyEvent', $scope.$unBindKeyEvent);
	      $rootScope.$broadcast('setIframe', $scope.asIframe);
	    }
	
	    initializeLookAndFeel();
	    //open interpreter binding setting when there're none selected
	    getInterpreterBindings();
	    getPermissions();
	    var isPersonalized = $scope.note.config.personalizedMode;
	    isPersonalized = isPersonalized === undefined ? 'false' : isPersonalized;
	    $scope.note.config.personalizedMode = isPersonalized;
	  });
	
	  $scope.$on('$destroy', function () {
	    angular.element(window).off('beforeunload');
	    $scope.killSaveTimer();
	    $scope.saveNote();
	
	    document.removeEventListener('click', $scope.focusParagraphOnClick);
	    document.removeEventListener('keydown', $scope.keyboardShortcut);
	  });
	
	  $scope.$on('$unBindKeyEvent', function () {
	    document.removeEventListener('click', $scope.focusParagraphOnClick);
	    document.removeEventListener('keydown', $scope.keyboardShortcut);
	  });
	
	  angular.element(window).bind('resize', function () {
	    var actionbarHeight = document.getElementById('actionbar').lastElementChild.clientHeight;
	    angular.element(document.getElementById('content')).css('padding-top', actionbarHeight - 20);
	  });
	}

/***/ },
/* 6 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/**
	 * Create table data object from paragraph table type result
	 */
	var TableData = function () {
	  function TableData(columns, rows, comment) {
	    _classCallCheck(this, TableData);
	
	    this.columns = columns || [];
	    this.rows = rows || [];
	    this.comment = comment || '';
	  }
	
	  _createClass(TableData, [{
	    key: 'loadParagraphResult',
	    value: function loadParagraphResult(paragraphResult) {
	      if (!paragraphResult || paragraphResult.type !== 'TABLE') {
	        console.log('Can not load paragraph result');
	        return;
	      }
	
	      var columnNames = [];
	      var rows = [];
	      var array = [];
	      var textRows = paragraphResult.msg.split('\n');
	      var comment = '';
	      var commentRow = false;
	
	      for (var i = 0; i < textRows.length; i++) {
	        var textRow = textRows[i];
	
	        if (commentRow) {
	          comment += textRow;
	          continue;
	        }
	
	        if (textRow === '' || textRow === '<!--TABLE_COMMENT-->') {
	          if (rows.length > 0) {
	            commentRow = true;
	          }
	          continue;
	        }
	        var textCols = textRow.split('\t');
	        var cols = [];
	        var cols2 = [];
	        for (var j = 0; j < textCols.length; j++) {
	          var col = textCols[j];
	          if (i === 0) {
	            columnNames.push({ name: col, index: j, aggr: 'sum' });
	          } else {
	            cols.push(col);
	            cols2.push({ key: columnNames[i] ? columnNames[i].name : undefined, value: col });
	          }
	        }
	        if (i !== 0) {
	          rows.push(cols);
	          array.push(cols2);
	        }
	      }
	      this.comment = comment;
	      this.columns = columnNames;
	      this.rows = rows;
	    }
	  }]);
	
	  return TableData;
	}();
	
	exports.default = TableData;

/***/ },
/* 7 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/**
	 * Base class for visualization
	 */
	var Transformation = function () {
	  function Transformation(config) {
	    _classCallCheck(this, Transformation);
	
	    this.config = config;
	    this._emitter;
	  }
	
	  _createClass(Transformation, [{
	    key: 'getSetting',
	
	
	    /**
	     * return {
	     *   template : angular template string or url (url should end with .html),
	     *   scope : an object to bind to template scope
	     * }
	     */
	    value: function getSetting() {
	      // override this
	    }
	  }, {
	    key: 'transform',
	
	
	    /**
	     * Method will be invoked when tableData or config changes
	     */
	    value: function transform(tableData) {
	      // override this
	    }
	  }, {
	    key: 'renderSetting',
	
	
	    /**
	     * render setting
	     */
	    value: function renderSetting(targetEl) {
	      var setting = this.getSetting();
	      if (!setting) {
	        return;
	      }
	
	      // already readered
	      if (this._scope) {
	        var self = this;
	        this._scope.$apply(function () {
	          for (var k in setting.scope) {
	            self._scope[k] = setting.scope[k];
	          }
	
	          for (var k in self._prevSettingScope) {
	            if (!setting.scope[k]) {
	              self._scope[k] = setting.scope[k];
	            }
	          }
	        });
	        return;
	      } else {
	        this._prevSettingScope = setting.scope;
	      }
	
	      var scope = this._createNewScope();
	      for (var k in setting.scope) {
	        scope[k] = setting.scope[k];
	      }
	      var template = setting.template;
	
	      if (template.split('\n').length === 1 && template.endsWith('.html')) {
	        // template is url
	        var self = this;
	        this._templateRequest(template).then(function (t) {
	          self._render(targetEl, t, scope);
	        });
	      } else {
	        this._render(targetEl, template, scope);
	      }
	    }
	  }, {
	    key: '_render',
	    value: function _render(targetEl, template, scope) {
	      this._targetEl = targetEl;
	      targetEl.html(template);
	      this._compile(targetEl.contents())(scope);
	      this._scope = scope;
	    }
	  }, {
	    key: 'setConfig',
	    value: function setConfig(config) {
	      this.config = config;
	    }
	  }, {
	    key: 'emitConfig',
	
	
	    /**
	     * Emit config. config will sent to server and saved.
	     */
	    value: function emitConfig(config) {
	      this._emitter(config);
	    }
	  }]);
	
	  return Transformation;
	}();
	
	exports.default = Transformation;

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformation = __webpack_require__(7);
	
	var _transformation2 = _interopRequireDefault(_transformation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	/**
	 * pivot table data and return d3 chart data
	 */
	var PivotTransformation = function (_Transformation) {
	  _inherits(PivotTransformation, _Transformation);
	
	  function PivotTransformation(config) {
	    _classCallCheck(this, PivotTransformation);
	
	    return _possibleConstructorReturn(this, (PivotTransformation.__proto__ || Object.getPrototypeOf(PivotTransformation)).call(this, config));
	  }
	
	  _createClass(PivotTransformation, [{
	    key: 'getSetting',
	    value: function getSetting() {
	      var self = this;
	
	      var configObj = self.config;
	      console.log('getSetting', configObj);
	      return {
	        template: 'app/tabledata/pivot_settings.html',
	        scope: {
	          config: configObj.common.pivot,
	          tableDataColumns: self.tableDataColumns,
	          save: function save() {
	            self.emitConfig(configObj);
	          },
	          removeKey: function removeKey(idx) {
	            configObj.common.pivot.keys.splice(idx, 1);
	            self.emitConfig(configObj);
	          },
	          removeGroup: function removeGroup(idx) {
	            configObj.common.pivot.groups.splice(idx, 1);
	            self.emitConfig(configObj);
	          },
	          removeValue: function removeValue(idx) {
	            configObj.common.pivot.values.splice(idx, 1);
	            self.emitConfig(configObj);
	          },
	          setValueAggr: function setValueAggr(idx, aggr) {
	            configObj.common.pivot.values[idx].aggr = aggr;
	            self.emitConfig(configObj);
	          }
	        }
	      };
	    }
	  }, {
	    key: 'transform',
	
	
	    /**
	     * Method will be invoked when tableData or config changes
	     */
	    value: function transform(tableData) {
	      this.tableDataColumns = tableData.columns;
	      this.config.common = this.config.common || {};
	      this.config.common.pivot = this.config.common.pivot || {};
	      var config = this.config.common.pivot;
	      var firstTime = !config.keys && !config.groups && !config.values;
	
	      config.keys = config.keys || [];
	      config.groups = config.groups || [];
	      config.values = config.values || [];
	
	      this.removeUnknown();
	      if (firstTime) {
	        this.selectDefault();
	      }
	      return this.pivot(tableData, config.keys, config.groups, config.values);
	    }
	  }, {
	    key: 'removeUnknown',
	    value: function removeUnknown() {
	      var config = this.config.common.pivot;
	      var tableDataColumns = this.tableDataColumns;
	      var unique = function unique(list) {
	        for (var i = 0; i < list.length; i++) {
	          for (var j = i + 1; j < list.length; j++) {
	            if (angular.equals(list[i], list[j])) {
	              list.splice(j, 1);
	            }
	          }
	        }
	      };
	
	      var removeUnknown = function removeUnknown(list) {
	        for (var i = 0; i < list.length; i++) {
	          // remove non existing column
	          var found = false;
	          for (var j = 0; j < tableDataColumns.length; j++) {
	            var a = list[i];
	            var b = tableDataColumns[j];
	            if (a.index === b.index && a.name === b.name) {
	              found = true;
	              break;
	            }
	          }
	          if (!found) {
	            list.splice(i, 1);
	          }
	        }
	      };
	
	      unique(config.keys);
	      removeUnknown(config.keys);
	      unique(config.groups);
	      removeUnknown(config.groups);
	      removeUnknown(config.values);
	    }
	  }, {
	    key: 'selectDefault',
	    value: function selectDefault() {
	      var config = this.config.common.pivot;
	      if (config.keys.length === 0 && config.groups.length === 0 && config.values.length === 0) {
	        if (config.keys.length === 0 && this.tableDataColumns.length > 0) {
	          config.keys.push(this.tableDataColumns[0]);
	        }
	
	        if (config.values.length === 0 && this.tableDataColumns.length > 1) {
	          config.values.push(this.tableDataColumns[1]);
	        }
	      }
	    }
	  }, {
	    key: 'pivot',
	    value: function pivot(data, keys, groups, values) {
	      var aggrFunc = {
	        sum: function sum(a, b) {
	          var varA = a !== undefined ? isNaN(a) ? 1 : parseFloat(a) : 0;
	          var varB = b !== undefined ? isNaN(b) ? 1 : parseFloat(b) : 0;
	          return varA + varB;
	        },
	        count: function count(a, b) {
	          var varA = a !== undefined ? parseInt(a) : 0;
	          var varB = b !== undefined ? 1 : 0;
	          return varA + varB;
	        },
	        min: function min(a, b) {
	          var varA = a !== undefined ? isNaN(a) ? 1 : parseFloat(a) : 0;
	          var varB = b !== undefined ? isNaN(b) ? 1 : parseFloat(b) : 0;
	          return Math.min(varA, varB);
	        },
	        max: function max(a, b) {
	          var varA = a !== undefined ? isNaN(a) ? 1 : parseFloat(a) : 0;
	          var varB = b !== undefined ? isNaN(b) ? 1 : parseFloat(b) : 0;
	          return Math.max(varA, varB);
	        },
	        avg: function avg(a, b, c) {
	          var varA = a !== undefined ? isNaN(a) ? 1 : parseFloat(a) : 0;
	          var varB = b !== undefined ? isNaN(b) ? 1 : parseFloat(b) : 0;
	          return varA + varB;
	        }
	      };
	
	      var aggrFuncDiv = {
	        sum: false,
	        count: false,
	        min: false,
	        max: false,
	        avg: true
	      };
	
	      var schema = {};
	      var rows = {};
	
	      for (var i = 0; i < data.rows.length; i++) {
	        var row = data.rows[i];
	        var s = schema;
	        var p = rows;
	
	        for (var k = 0; k < keys.length; k++) {
	          var key = keys[k];
	
	          // add key to schema
	          if (!s[key.name]) {
	            s[key.name] = {
	              order: k,
	              index: key.index,
	              type: 'key',
	              children: {}
	            };
	          }
	          s = s[key.name].children;
	
	          // add key to row
	          var keyKey = row[key.index];
	          if (!p[keyKey]) {
	            p[keyKey] = {};
	          }
	          p = p[keyKey];
	        }
	
	        for (var g = 0; g < groups.length; g++) {
	          var group = groups[g];
	          var groupKey = row[group.index];
	
	          // add group to schema
	          if (!s[groupKey]) {
	            s[groupKey] = {
	              order: g,
	              index: group.index,
	              type: 'group',
	              children: {}
	            };
	          }
	          s = s[groupKey].children;
	
	          // add key to row
	          if (!p[groupKey]) {
	            p[groupKey] = {};
	          }
	          p = p[groupKey];
	        }
	
	        for (var v = 0; v < values.length; v++) {
	          var value = values[v];
	          var valueKey = value.name + '(' + value.aggr + ')';
	
	          // add value to schema
	          if (!s[valueKey]) {
	            s[valueKey] = {
	              type: 'value',
	              order: v,
	              index: value.index
	            };
	          }
	
	          // add value to row
	          if (!p[valueKey]) {
	            p[valueKey] = {
	              value: value.aggr !== 'count' ? row[value.index] : 1,
	              count: 1
	            };
	          } else {
	            p[valueKey] = {
	              value: aggrFunc[value.aggr](p[valueKey].value, row[value.index], p[valueKey].count + 1),
	              count: aggrFuncDiv[value.aggr] ? p[valueKey].count + 1 : p[valueKey].count
	            };
	          }
	        }
	      }
	
	      //console.log('schema=%o, rows=%o', schema, rows);
	      return {
	        keys: keys,
	        groups: groups,
	        values: values,
	        schema: schema,
	        rows: rows
	      };
	    }
	  }]);
	
	  return PivotTransformation;
	}(_transformation2.default);
	
	exports.default = PivotTransformation;

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformation = __webpack_require__(7);
	
	var _transformation2 = _interopRequireDefault(_transformation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	/**
	 * passthough the data
	 */
	var PassthroughTransformation = function (_Transformation) {
	  _inherits(PassthroughTransformation, _Transformation);
	
	  function PassthroughTransformation(config) {
	    _classCallCheck(this, PassthroughTransformation);
	
	    return _possibleConstructorReturn(this, (PassthroughTransformation.__proto__ || Object.getPrototypeOf(PassthroughTransformation)).call(this, config));
	  }
	
	  _createClass(PassthroughTransformation, [{
	    key: 'transform',
	
	
	    /**
	     * Method will be invoked when tableData or config changes
	     */
	    value: function transform(tableData) {
	      return tableData;
	    }
	  }]);
	
	  return PassthroughTransformation;
	}(_transformation2.default);
	
	exports.default = PassthroughTransformation;

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _transformation = __webpack_require__(7);
	
	var _transformation2 = _interopRequireDefault(_transformation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	/**
	 * select columns
	 * - columnSelectorProp
	 *   [
	 *     {
	 *       "name":
	 *       "tooltip":
	 *     },
	 *     ...
	 *   ]
	 */
	var ColumnselectorTransformation = function (_Transformation) {
	  _inherits(ColumnselectorTransformation, _Transformation);
	
	  function ColumnselectorTransformation(config, columnSelectorProp) {
	    _classCallCheck(this, ColumnselectorTransformation);
	
	    var _this = _possibleConstructorReturn(this, (ColumnselectorTransformation.__proto__ || Object.getPrototypeOf(ColumnselectorTransformation)).call(this, config));
	
	    _this.props = columnSelectorProp;
	    return _this;
	  }
	
	  _createClass(ColumnselectorTransformation, [{
	    key: 'getSetting',
	    value: function getSetting() {
	      var self = this;
	      var configObj = self.config;
	      return {
	        template: 'app/tabledata/columnselector_settings.html',
	        scope: {
	          config: self.config,
	          props: self.props,
	          tableDataColumns: self.tableDataColumns,
	          save: function save() {
	            self.emitConfig(configObj);
	          },
	          remove: function remove(selectorName) {
	            configObj[selectorName] = null;
	            self.emitConfig(configObj);
	          }
	        }
	      };
	    }
	  }, {
	    key: 'transform',
	
	
	    /**
	     * Method will be invoked when tableData or config changes
	     */
	    value: function transform(tableData) {
	      this.tableDataColumns = tableData.columns;
	      this.removeUnknown();
	      return tableData;
	    }
	  }, {
	    key: 'removeUnknown',
	    value: function removeUnknown() {
	      var fields = this.config;
	      for (var f in fields) {
	        if (fields[f]) {
	          var found = false;
	          for (var i = 0; i < this.tableDataColumns.length; i++) {
	            var a = fields[f];
	            var b = this.tableDataColumns[i];
	            if (a.index === b.index && a.name === b.name) {
	              found = true;
	              break;
	            }
	          }
	          if (!found && fields[f] instanceof Object && !(fields[f] instanceof Array)) {
	            fields[f] = null;
	          }
	        }
	      }
	    }
	  }]);
	
	  return ColumnselectorTransformation;
	}(_transformation2.default);
	
	exports.default = ColumnselectorTransformation;

/***/ },
/* 11 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/**
	 * Base class for visualization
	 */
	var Visualization = function () {
	  function Visualization(targetEl, config) {
	    _classCallCheck(this, Visualization);
	
	    this.targetEl = targetEl;
	    this.config = config;
	    this._dirty = false;
	    this._active = false;
	    this._emitter;
	  }
	
	  _createClass(Visualization, [{
	    key: 'getTransformation',
	
	
	    /**
	     * get transformation
	     */
	    value: function getTransformation() {
	      // override this
	    }
	  }, {
	    key: 'render',
	
	
	    /**
	     * Method will be invoked when data or configuration changed
	     */
	    value: function render(tableData) {
	      // override this
	    }
	  }, {
	    key: 'refresh',
	
	
	    /**
	     * Refresh visualization.
	     */
	    value: function refresh() {
	      // override this
	    }
	  }, {
	    key: 'destroy',
	
	
	    /**
	     * method will be invoked when visualization need to be destroyed.
	     * Don't need to destroy this.targetEl.
	     */
	    value: function destroy() {
	      // override this
	    }
	  }, {
	    key: 'getSetting',
	
	
	    /**
	     * return {
	     *   template : angular template string or url (url should end with .html),
	     *   scope : an object to bind to template scope
	     * }
	     */
	    value: function getSetting() {
	      // override this
	    }
	  }, {
	    key: 'activate',
	
	
	    /**
	     * Activate. invoked when visualization is selected
	     */
	    value: function activate() {
	      if (!this._active || this._dirty) {
	        this.refresh();
	        this._dirty = false;
	      }
	      this._active = true;
	    }
	  }, {
	    key: 'deactivate',
	
	
	    /**
	     * Activate. invoked when visualization is de selected
	     */
	    value: function deactivate() {
	      this._active = false;
	    }
	  }, {
	    key: 'isActive',
	
	
	    /**
	     * Is active
	     */
	    value: function isActive() {
	      return this._active;
	    }
	  }, {
	    key: 'resize',
	
	
	    /**
	     * When window or paragraph is resized
	     */
	    value: function resize() {
	      if (this.isActive()) {
	        this.refresh();
	      } else {
	        this._dirty = true;
	      }
	    }
	  }, {
	    key: 'setConfig',
	
	
	    /**
	     * Set new config
	     */
	    value: function setConfig(config) {
	      this.config = config;
	      if (this.isActive()) {
	        this.refresh();
	      } else {
	        this._dirty = true;
	      }
	    }
	  }, {
	    key: 'emitConfig',
	
	
	    /**
	     * Emit config. config will sent to server and saved.
	     */
	    value: function emitConfig(config) {
	      this._emitter(config);
	    }
	  }, {
	    key: 'renderSetting',
	
	
	    /**
	     * render setting
	     */
	    value: function renderSetting(targetEl) {
	      var _this = this;
	
	      var setting = this.getSetting();
	      if (!setting) {
	        return;
	      }
	
	      // already readered
	      if (this._scope) {
	        var self = this;
	        this._scope.$apply(function () {
	          for (var k in setting.scope) {
	            self._scope[k] = setting.scope[k];
	          }
	
	          for (var k in self._prevSettingScope) {
	            if (!setting.scope[k]) {
	              self._scope[k] = setting.scope[k];
	            }
	          }
	        });
	        return;
	      } else {
	        this._prevSettingScope = setting.scope;
	      }
	
	      var scope = this._createNewScope();
	      for (var k in setting.scope) {
	        scope[k] = setting.scope[k];
	      }
	      var template = setting.template;
	
	      if (template.split('\n').length === 1 && template.endsWith('.html')) {
	        // template is url
	        this._templateRequest(template).then(function (t) {
	          return _renderSetting(_this, targetEl, t, scope);
	        });
	      } else {
	        _renderSetting(this, targetEl, template, scope);
	      }
	    }
	  }]);
	
	  return Visualization;
	}();
	
	exports.default = Visualization;
	
	
	function _renderSetting(instance, targetEl, template, scope) {
	  instance._targetEl = targetEl;
	  targetEl.html(template);
	  instance._compile(targetEl.contents())(scope);
	  instance._scope = scope;
	};

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _visualization = __webpack_require__(11);
	
	var _visualization2 = _interopRequireDefault(_visualization);
	
	var _passthrough = __webpack_require__(9);
	
	var _passthrough2 = _interopRequireDefault(_passthrough);
	
	var _handsonHelper = __webpack_require__(4);
	
	var _handsonHelper2 = _interopRequireDefault(_handsonHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	/**
	 * Visualize data in table format
	 */
	var TableVisualization = function (_Visualization) {
	  _inherits(TableVisualization, _Visualization);
	
	  function TableVisualization(targetEl, config) {
	    _classCallCheck(this, TableVisualization);
	
	    var _this = _possibleConstructorReturn(this, (TableVisualization.__proto__ || Object.getPrototypeOf(TableVisualization)).call(this, targetEl, config));
	
	    console.log('Init table viz');
	    targetEl.addClass('table');
	    _this.passthrough = new _passthrough2.default(config);
	    return _this;
	  }
	
	  _createClass(TableVisualization, [{
	    key: 'refresh',
	    value: function refresh() {
	      this.hot.render();
	    }
	  }, {
	    key: 'render',
	    value: function render(tableData) {
	      var height = this.targetEl.height();
	      var container = this.targetEl.css('height', height).get(0);
	      var resultRows = tableData.rows;
	      var columnNames = _.pluck(tableData.columns, 'name');
	      var columns = Array.apply(null, Array(tableData.columns.length)).map(function () {
	        return { type: 'text' };
	      });
	
	      if (this.hot) {
	        this.hot.destroy();
	      }
	
	      var handsonHelper = new _handsonHelper2.default();
	      this.hot = new Handsontable(container, handsonHelper.getHandsonTableConfig(columns, columnNames, resultRows));
	      this.hot.validateCells(null);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      if (this.hot) {
	        this.hot.destroy();
	      }
	    }
	  }, {
	    key: 'getTransformation',
	    value: function getTransformation() {
	      return this.passthrough;
	    }
	  }]);
	
	  return TableVisualization;
	}(_visualization2.default);
	
	exports.default = TableVisualization;

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _visualization = __webpack_require__(11);
	
	var _visualization2 = _interopRequireDefault(_visualization);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	/**
	 * Visualize data in table format
	 */
	var Nvd3ChartVisualization = function (_Visualization) {
	  _inherits(Nvd3ChartVisualization, _Visualization);
	
	  function Nvd3ChartVisualization(targetEl, config) {
	    _classCallCheck(this, Nvd3ChartVisualization);
	
	    var _this = _possibleConstructorReturn(this, (Nvd3ChartVisualization.__proto__ || Object.getPrototypeOf(Nvd3ChartVisualization)).call(this, targetEl, config));
	
	    _this.targetEl.append('<svg></svg>');
	    return _this;
	  }
	
	  _createClass(Nvd3ChartVisualization, [{
	    key: 'refresh',
	    value: function refresh() {
	      if (this.chart) {
	        this.chart.update();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render(data) {
	      var type = this.type();
	      var d3g = data.d3g;
	
	      if (!this.chart) {
	        this.chart = nv.models[type]();
	      }
	
	      this.configureChart(this.chart);
	
	      var animationDuration = 300;
	      var numberOfDataThreshold = 150;
	      var height = this.targetEl.height();
	
	      // turn off animation when dataset is too large. (for performance issue)
	      // still, since dataset is large, the chart content sequentially appears like animated.
	      try {
	        if (d3g[0].values.length > numberOfDataThreshold) {
	          animationDuration = 0;
	        }
	      } catch (ignoreErr) {}
	
	      d3.select('#' + this.targetEl[0].id + ' svg').attr('height', height).datum(d3g).transition().duration(animationDuration).call(this.chart);
	      d3.select('#' + this.targetEl[0].id + ' svg').style.height = height + 'px';
	    }
	  }, {
	    key: 'type',
	    value: function type() {
	      // override this and return chart type
	    }
	  }, {
	    key: 'configureChart',
	    value: function configureChart(chart) {
	      // override this to configure chart
	    }
	  }, {
	    key: 'groupedThousandsWith3DigitsFormatter',
	    value: function groupedThousandsWith3DigitsFormatter(x) {
	      return d3.format(',')(d3.round(x, 3));
	    }
	  }, {
	    key: 'customAbbrevFormatter',
	    value: function customAbbrevFormatter(x) {
	      var s = d3.format('.3s')(x);
	      switch (s[s.length - 1]) {
	        case 'G':
	          return s.slice(0, -1) + 'B';
	      }
	      return s;
	    }
	  }, {
	    key: 'xAxisTickFormat',
	    value: function xAxisTickFormat(d, xLabels) {
	      if (xLabels[d] && (isNaN(parseFloat(xLabels[d])) || !isFinite(xLabels[d]))) {
	        // to handle string type xlabel
	        return xLabels[d];
	      } else {
	        return d;
	      }
	    }
	  }, {
	    key: 'yAxisTickFormat',
	    value: function yAxisTickFormat(d) {
	      if (Math.abs(d) >= Math.pow(10, 6)) {
	        return this.customAbbrevFormatter(d);
	      }
	      return this.groupedThousandsWith3DigitsFormatter(d);
	    }
	  }, {
	    key: 'd3DataFromPivot',
	    value: function d3DataFromPivot(schema, rows, keys, groups, values, allowTextXAxis, fillMissingValues, multiBarChart) {
	      // construct table data
	      var d3g = [];
	
	      var concat = function concat(o, n) {
	        if (!o) {
	          return n;
	        } else {
	          return o + '.' + n;
	        }
	      };
	
	      var getSchemaUnderKey = function getSchemaUnderKey(key, s) {
	        for (var c in key.children) {
	          s[c] = {};
	          getSchemaUnderKey(key.children[c], s[c]);
	        }
	      };
	
	      var traverse = function traverse(sKey, s, rKey, r, func, rowName, rowValue, colName) {
	        //console.log("TRAVERSE sKey=%o, s=%o, rKey=%o, r=%o, rowName=%o, rowValue=%o, colName=%o", sKey, s, rKey, r, rowName, rowValue, colName);
	
	        if (s.type === 'key') {
	          rowName = concat(rowName, sKey);
	          rowValue = concat(rowValue, rKey);
	        } else if (s.type === 'group') {
	          colName = concat(colName, rKey);
	        } else if (s.type === 'value' && sKey === rKey || valueOnly) {
	          colName = concat(colName, rKey);
	          func(rowName, rowValue, colName, r);
	        }
	
	        for (var c in s.children) {
	          if (fillMissingValues && s.children[c].type === 'group' && r[c] === undefined) {
	            var cs = {};
	            getSchemaUnderKey(s.children[c], cs);
	            traverse(c, s.children[c], c, cs, func, rowName, rowValue, colName);
	            continue;
	          }
	
	          for (var j in r) {
	            if (s.children[c].type === 'key' || c === j) {
	              traverse(c, s.children[c], j, r[j], func, rowName, rowValue, colName);
	            }
	          }
	        }
	      };
	
	      var valueOnly = keys.length === 0 && groups.length === 0 && values.length > 0;
	      var noKey = keys.length === 0;
	      var isMultiBarChart = multiBarChart;
	
	      var sKey = Object.keys(schema)[0];
	
	      var rowNameIndex = {};
	      var rowIdx = 0;
	      var colNameIndex = {};
	      var colIdx = 0;
	      var rowIndexValue = {};
	
	      for (var k in rows) {
	        traverse(sKey, schema[sKey], k, rows[k], function (rowName, rowValue, colName, value) {
	          //console.log("RowName=%o, row=%o, col=%o, value=%o", rowName, rowValue, colName, value);
	          if (rowNameIndex[rowValue] === undefined) {
	            rowIndexValue[rowIdx] = rowValue;
	            rowNameIndex[rowValue] = rowIdx++;
	          }
	
	          if (colNameIndex[colName] === undefined) {
	            colNameIndex[colName] = colIdx++;
	          }
	          var i = colNameIndex[colName];
	          if (noKey && isMultiBarChart) {
	            i = 0;
	          }
	
	          if (!d3g[i]) {
	            d3g[i] = {
	              values: [],
	              key: noKey && isMultiBarChart ? 'values' : colName
	            };
	          }
	
	          var xVar = isNaN(rowValue) ? allowTextXAxis ? rowValue : rowNameIndex[rowValue] : parseFloat(rowValue);
	          var yVar = 0;
	          if (xVar === undefined) {
	            xVar = colName;
	          }
	          if (value !== undefined) {
	            yVar = isNaN(value.value) ? 0 : parseFloat(value.value) / parseFloat(value.count);
	          }
	          d3g[i].values.push({
	            x: xVar,
	            y: yVar
	          });
	        });
	      }
	
	      // clear aggregation name, if possible
	      var namesWithoutAggr = {};
	      var colName;
	      var withoutAggr;
	      // TODO - This part could use som refactoring - Weird if/else with similar actions and variable names
	      for (colName in colNameIndex) {
	        withoutAggr = colName.substring(0, colName.lastIndexOf('('));
	        if (!namesWithoutAggr[withoutAggr]) {
	          namesWithoutAggr[withoutAggr] = 1;
	        } else {
	          namesWithoutAggr[withoutAggr]++;
	        }
	      }
	
	      if (valueOnly) {
	        for (var valueIndex = 0; valueIndex < d3g[0].values.length; valueIndex++) {
	          colName = d3g[0].values[valueIndex].x;
	          if (!colName) {
	            continue;
	          }
	
	          withoutAggr = colName.substring(0, colName.lastIndexOf('('));
	          if (namesWithoutAggr[withoutAggr] <= 1) {
	            d3g[0].values[valueIndex].x = withoutAggr;
	          }
	        }
	      } else {
	        for (var d3gIndex = 0; d3gIndex < d3g.length; d3gIndex++) {
	          colName = d3g[d3gIndex].key;
	          withoutAggr = colName.substring(0, colName.lastIndexOf('('));
	          if (namesWithoutAggr[withoutAggr] <= 1) {
	            d3g[d3gIndex].key = withoutAggr;
	          }
	        }
	
	        // use group name instead of group.value as a column name, if there're only one group and one value selected.
	        if (groups.length === 1 && values.length === 1) {
	          for (d3gIndex = 0; d3gIndex < d3g.length; d3gIndex++) {
	            colName = d3g[d3gIndex].key;
	            colName = colName.split('.').slice(0, -1).join('.');
	            d3g[d3gIndex].key = colName;
	          }
	        }
	      }
	
	      return {
	        xLabels: rowIndexValue,
	        d3g: d3g
	      };
	    }
	  }, {
	    key: 'destroy',
	
	
	    /**
	     * method will be invoked when visualization need to be destroyed.
	     * Don't need to destroy this.targetEl.
	     */
	    value: function destroy() {
	      if (this.chart) {
	        d3.selectAll('#' + this.targetEl[0].id + ' svg > *').remove();
	        this.chart = undefined;
	      }
	    }
	  }]);
	
	  return Nvd3ChartVisualization;
	}(_visualization2.default);
	
	exports.default = Nvd3ChartVisualization;

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _visualizationNvd3chart = __webpack_require__(13);
	
	var _visualizationNvd3chart2 = _interopRequireDefault(_visualizationNvd3chart);
	
	var _pivot = __webpack_require__(8);
	
	var _pivot2 = _interopRequireDefault(_pivot);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	/**
	 * Visualize data in bar char
	 */
	var BarchartVisualization = function (_Nvd3ChartVisualizati) {
	  _inherits(BarchartVisualization, _Nvd3ChartVisualizati);
	
	  function BarchartVisualization(targetEl, config) {
	    _classCallCheck(this, BarchartVisualization);
	
	    var _this = _possibleConstructorReturn(this, (BarchartVisualization.__proto__ || Object.getPrototypeOf(BarchartVisualization)).call(this, targetEl, config));
	
	    _this.pivot = new _pivot2.default(config);
	    return _this;
	  }
	
	  _createClass(BarchartVisualization, [{
	    key: 'type',
	    value: function type() {
	      return 'multiBarChart';
	    }
	  }, {
	    key: 'getTransformation',
	    value: function getTransformation() {
	      return this.pivot;
	    }
	  }, {
	    key: 'render',
	    value: function render(pivot) {
	      var d3Data = this.d3DataFromPivot(pivot.schema, pivot.rows, pivot.keys, pivot.groups, pivot.values, true, true, true);
	
	      _get(BarchartVisualization.prototype.__proto__ || Object.getPrototypeOf(BarchartVisualization.prototype), 'render', this).call(this, d3Data);
	    }
	  }, {
	    key: 'setConfig',
	
	
	    /**
	     * Set new config
	     */
	    value: function setConfig(config) {
	      _get(BarchartVisualization.prototype.__proto__ || Object.getPrototypeOf(BarchartVisualization.prototype), 'setConfig', this).call(this, config);
	      this.pivot.setConfig(config);
	    }
	  }, {
	    key: 'configureChart',
	    value: function configureChart(chart) {
	      var self = this;
	      chart.yAxis.axisLabelDistance(50);
	      chart.yAxis.tickFormat(function (d) {
	        return self.yAxisTickFormat(d);
	      });
	
	      this.chart.stacked(this.config.stacked);
	
	      var self = this;
	      this.chart.dispatch.on('stateChange', function (s) {
	        self.config.stacked = s.stacked;
	
	        // give some time to animation finish
	        setTimeout(function () {
	          self.emitConfig(self.config);
	        }, 500);
	      });
	    }
	  }]);
	
	  return BarchartVisualization;
	}(_visualizationNvd3chart2.default);
	
	exports.default = BarchartVisualization;

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _visualizationNvd3chart = __webpack_require__(13);
	
	var _visualizationNvd3chart2 = _interopRequireDefault(_visualizationNvd3chart);
	
	var _pivot = __webpack_require__(8);
	
	var _pivot2 = _interopRequireDefault(_pivot);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	/**
	 * Visualize data in pie chart
	 */
	var PiechartVisualization = function (_Nvd3ChartVisualizati) {
	  _inherits(PiechartVisualization, _Nvd3ChartVisualizati);
	
	  function PiechartVisualization(targetEl, config) {
	    _classCallCheck(this, PiechartVisualization);
	
	    var _this = _possibleConstructorReturn(this, (PiechartVisualization.__proto__ || Object.getPrototypeOf(PiechartVisualization)).call(this, targetEl, config));
	
	    _this.pivot = new _pivot2.default(config);
	    return _this;
	  }
	
	  _createClass(PiechartVisualization, [{
	    key: 'type',
	    value: function type() {
	      return 'pieChart';
	    }
	  }, {
	    key: 'getTransformation',
	    value: function getTransformation() {
	      return this.pivot;
	    }
	  }, {
	    key: 'render',
	    value: function render(pivot) {
	      // [ZEPPELIN-2253] New chart function will be created each time inside super.render()
	      this.chart = null;
	      var d3Data = this.d3DataFromPivot(pivot.schema, pivot.rows, pivot.keys, pivot.groups, pivot.values, true, false, false);
	      var d = d3Data.d3g;
	
	      var generateLabel = void 0;
	      // data is grouped
	      if (pivot.groups && pivot.groups.length > 0) {
	        generateLabel = function generateLabel(suffix, prefix) {
	          return prefix + '.' + suffix;
	        };
	      } else {
	        // data isn't grouped
	        generateLabel = function generateLabel(suffix) {
	          return suffix;
	        };
	      }
	
	      var d3g = d.map(function (group) {
	        return group.values.map(function (row) {
	          return {
	            label: generateLabel(row.x, group.key),
	            value: row.y
	          };
	        });
	      });
	      // the map function returns d3g as a nested array
	      // [].concat flattens it, http://stackoverflow.com/a/10865042/5154397
	      d3g = [].concat.apply([], d3g);
	      _get(PiechartVisualization.prototype.__proto__ || Object.getPrototypeOf(PiechartVisualization.prototype), 'render', this).call(this, { d3g: d3g });
	    }
	  }, {
	    key: 'setConfig',
	
	
	    /**
	     * Set new config
	     */
	    value: function setConfig(config) {
	      _get(PiechartVisualization.prototype.__proto__ || Object.getPrototypeOf(PiechartVisualization.prototype), 'setConfig', this).call(this, config);
	      this.pivot.setConfig(config);
	    }
	  }, {
	    key: 'configureChart',
	    value: function configureChart(chart) {
	      chart.x(function (d) {
	        return d.label;
	      }).y(function (d) {
	        return d.value;
	      }).showLabels(false).showTooltipPercent(true);
	    }
	  }]);
	
	  return PiechartVisualization;
	}(_visualizationNvd3chart2.default);
	
	exports.default = PiechartVisualization;

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _visualizationNvd3chart = __webpack_require__(13);
	
	var _visualizationNvd3chart2 = _interopRequireDefault(_visualizationNvd3chart);
	
	var _pivot = __webpack_require__(8);
	
	var _pivot2 = _interopRequireDefault(_pivot);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	/**
	 * Visualize data in area chart
	 */
	var AreachartVisualization = function (_Nvd3ChartVisualizati) {
	  _inherits(AreachartVisualization, _Nvd3ChartVisualizati);
	
	  function AreachartVisualization(targetEl, config) {
	    _classCallCheck(this, AreachartVisualization);
	
	    var _this = _possibleConstructorReturn(this, (AreachartVisualization.__proto__ || Object.getPrototypeOf(AreachartVisualization)).call(this, targetEl, config));
	
	    _this.pivot = new _pivot2.default(config);
	    _this.xLables = [];
	    return _this;
	  }
	
	  _createClass(AreachartVisualization, [{
	    key: 'type',
	    value: function type() {
	      return 'stackedAreaChart';
	    }
	  }, {
	    key: 'getTransformation',
	    value: function getTransformation() {
	      return this.pivot;
	    }
	  }, {
	    key: 'render',
	    value: function render(pivot) {
	      var d3Data = this.d3DataFromPivot(pivot.schema, pivot.rows, pivot.keys, pivot.groups, pivot.values, false, true, false);
	
	      this.xLabels = d3Data.xLabels;
	      _get(AreachartVisualization.prototype.__proto__ || Object.getPrototypeOf(AreachartVisualization.prototype), 'render', this).call(this, d3Data);
	    }
	  }, {
	    key: 'setConfig',
	
	
	    /**
	     * Set new config
	     */
	    value: function setConfig(config) {
	      _get(AreachartVisualization.prototype.__proto__ || Object.getPrototypeOf(AreachartVisualization.prototype), 'setConfig', this).call(this, config);
	      this.pivot.setConfig(config);
	    }
	  }, {
	    key: 'configureChart',
	    value: function configureChart(chart) {
	      var self = this;
	      chart.xAxis.tickFormat(function (d) {
	        return self.xAxisTickFormat(d, self.xLabels);
	      });
	      chart.yAxis.tickFormat(function (d) {
	        return self.yAxisTickFormat(d);
	      });
	      chart.yAxis.axisLabelDistance(50);
	      chart.useInteractiveGuideline(true); // for better UX and performance issue. (https://github.com/novus/nvd3/issues/691)
	
	      this.chart.style(this.config.style || 'stack');
	
	      var self = this;
	      this.chart.dispatch.on('stateChange', function (s) {
	        self.config.style = s.style;
	
	        // give some time to animation finish
	        setTimeout(function () {
	          self.emitConfig(self.config);
	        }, 500);
	      });
	    }
	  }]);
	
	  return AreachartVisualization;
	}(_visualizationNvd3chart2.default);
	
	exports.default = AreachartVisualization;

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _visualizationNvd3chart = __webpack_require__(13);
	
	var _visualizationNvd3chart2 = _interopRequireDefault(_visualizationNvd3chart);
	
	var _pivot = __webpack_require__(8);
	
	var _pivot2 = _interopRequireDefault(_pivot);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	/**
	 * Visualize data in line chart
	 */
	var LinechartVisualization = function (_Nvd3ChartVisualizati) {
	  _inherits(LinechartVisualization, _Nvd3ChartVisualizati);
	
	  function LinechartVisualization(targetEl, config) {
	    _classCallCheck(this, LinechartVisualization);
	
	    var _this = _possibleConstructorReturn(this, (LinechartVisualization.__proto__ || Object.getPrototypeOf(LinechartVisualization)).call(this, targetEl, config));
	
	    _this.pivot = new _pivot2.default(config);
	    _this.xLables = [];
	    return _this;
	  }
	
	  _createClass(LinechartVisualization, [{
	    key: 'type',
	    value: function type() {
	      if (this.config.lineWithFocus) {
	        return 'lineWithFocusChart';
	      } else {
	        return 'lineChart';
	      }
	    }
	  }, {
	    key: 'getTransformation',
	    value: function getTransformation() {
	      return this.pivot;
	    }
	  }, {
	    key: 'render',
	    value: function render(pivot) {
	      var d3Data = this.d3DataFromPivot(pivot.schema, pivot.rows, pivot.keys, pivot.groups, pivot.values, false, true, false);
	
	      this.xLabels = d3Data.xLabels;
	      _get(LinechartVisualization.prototype.__proto__ || Object.getPrototypeOf(LinechartVisualization.prototype), 'render', this).call(this, d3Data);
	    }
	  }, {
	    key: 'setConfig',
	
	
	    /**
	     * Set new config
	     */
	    value: function setConfig(config) {
	      _get(LinechartVisualization.prototype.__proto__ || Object.getPrototypeOf(LinechartVisualization.prototype), 'setConfig', this).call(this, config);
	      this.pivot.setConfig(config);
	
	      // change mode
	      if (this.currentMode !== config.lineWithFocus) {
	        _get(LinechartVisualization.prototype.__proto__ || Object.getPrototypeOf(LinechartVisualization.prototype), 'destroy', this).call(this);
	        this.currentMode = config.lineWithFocus;
	      }
	    }
	  }, {
	    key: 'configureChart',
	    value: function configureChart(chart) {
	      var self = this;
	      chart.xAxis.tickFormat(function (d) {
	        return self.xAxisTickFormat(d, self.xLabels);
	      });
	      chart.yAxis.tickFormat(function (d) {
	        return self.yAxisTickFormat(d, self.xLabels);
	      });
	      chart.yAxis.axisLabelDistance(50);
	      if (chart.useInteractiveGuideline) {
	        // lineWithFocusChart hasn't got useInteractiveGuideline
	        chart.useInteractiveGuideline(true); // for better UX and performance issue. (https://github.com/novus/nvd3/issues/691)
	      }
	      if (this.config.forceY) {
	        chart.forceY([0]); // force y-axis minimum to 0 for line chart.
	      } else {
	        chart.forceY([]);
	      }
	    }
	  }, {
	    key: 'getSetting',
	    value: function getSetting(chart) {
	      var self = this;
	      var configObj = self.config;
	
	      return {
	        template: '<div>\n        <label>\n          <input type="checkbox"\n               ng-model="config.forceY"\n               ng-click="save()" />\n          force Y to 0\n        </label>\n        <br/>\n\n        <label>\n          <input type="checkbox"\n               ng-model="config.lineWithFocus"\n               ng-click="save()" />\n          show line chart with focus\n        </label>\n      </div>',
	        scope: {
	          config: configObj,
	          save: function save() {
	            self.emitConfig(configObj);
	          }
	        }
	      };
	    }
	  }]);
	
	  return LinechartVisualization;
	}(_visualizationNvd3chart2.default);
	
	exports.default = LinechartVisualization;

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _visualizationNvd3chart = __webpack_require__(13);
	
	var _visualizationNvd3chart2 = _interopRequireDefault(_visualizationNvd3chart);
	
	var _columnselector = __webpack_require__(10);
	
	var _columnselector2 = _interopRequireDefault(_columnselector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * you may not use this file except in compliance with the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * You may obtain a copy of the License at
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Unless required by applicable law or agreed to in writing, software
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * See the License for the specific language governing permissions and
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * limitations under the License.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	/**
	 * Visualize data in scatter char
	 */
	var ScatterchartVisualization = function (_Nvd3ChartVisualizati) {
	  _inherits(ScatterchartVisualization, _Nvd3ChartVisualizati);
	
	  function ScatterchartVisualization(targetEl, config) {
	    _classCallCheck(this, ScatterchartVisualization);
	
	    var _this = _possibleConstructorReturn(this, (ScatterchartVisualization.__proto__ || Object.getPrototypeOf(ScatterchartVisualization)).call(this, targetEl, config));
	
	    _this.columnselectorProps = [{
	      name: 'xAxis'
	    }, {
	      name: 'yAxis'
	    }, {
	      name: 'group'
	    }, {
	      name: 'size',
	      tooltip: '<li>Size option is valid only when you drop numeric field here.</li>\n                  <li>When data in each axis are discrete,\n                  \'number of values in corresponding coordinate\' will be used as size.</li>\n                  <li>Zeppelin consider values as discrete when the values contain string value\n                  or the number of distinct values are bigger than 5% of total number of values.</li>\n                  <li>Size field button turns to grey when the option you chose is not valid.</li>'
	    }];
	    _this.columnselector = new _columnselector2.default(config, _this.columnselectorProps);
	    return _this;
	  }
	
	  _createClass(ScatterchartVisualization, [{
	    key: 'type',
	    value: function type() {
	      return 'scatterChart';
	    }
	  }, {
	    key: 'getTransformation',
	    value: function getTransformation() {
	      return this.columnselector;
	    }
	  }, {
	    key: 'render',
	    value: function render(tableData) {
	      this.tableData = tableData;
	      this.selectDefault();
	      var d3Data = this.setScatterChart(tableData, true);
	      this.xLabels = d3Data.xLabels;
	      this.yLabels = d3Data.yLabels;
	
	      _get(ScatterchartVisualization.prototype.__proto__ || Object.getPrototypeOf(ScatterchartVisualization.prototype), 'render', this).call(this, d3Data);
	    }
	  }, {
	    key: 'configureChart',
	    value: function configureChart(chart) {
	      var self = this;
	
	      chart.xAxis.tickFormat(function (d) {
	        // TODO remove round after bump to nvd3 > 1.8.5
	        return self.xAxisTickFormat(Math.round(d * 1e3) / 1e3, self.xLabels);
	      });
	
	      chart.yAxis.tickFormat(function (d) {
	        // TODO remove round after bump to nvd3 > 1.8.5
	        return self.yAxisTickFormat(Math.round(d * 1e3) / 1e3, self.yLabels);
	      });
	
	      chart.showDistX(true).showDistY(true);
	      //handle the problem of tooltip not showing when muliple points have same value.
	    }
	  }, {
	    key: 'yAxisTickFormat',
	    value: function yAxisTickFormat(d, yLabels) {
	      if (yLabels[d] && (isNaN(parseFloat(yLabels[d])) || !isFinite(yLabels[d]))) {
	        // to handle string type xlabel
	        return yLabels[d];
	      } else {
	        return _get(ScatterchartVisualization.prototype.__proto__ || Object.getPrototypeOf(ScatterchartVisualization.prototype), 'yAxisTickFormat', this).call(this, d);
	      }
	    }
	  }, {
	    key: 'selectDefault',
	    value: function selectDefault() {
	      if (!this.config.xAxis && !this.config.yAxis) {
	        if (this.tableData.columns.length > 1) {
	          this.config.xAxis = this.tableData.columns[0];
	          this.config.yAxis = this.tableData.columns[1];
	        } else if (this.tableData.columns.length === 1) {
	          this.config.xAxis = this.tableData.columns[0];
	        }
	      }
	    }
	  }, {
	    key: 'setScatterChart',
	    value: function setScatterChart(data, refresh) {
	      var xAxis = this.config.xAxis;
	      var yAxis = this.config.yAxis;
	      var group = this.config.group;
	      var size = this.config.size;
	
	      var xValues = [];
	      var yValues = [];
	      var rows = {};
	      var d3g = [];
	
	      var rowNameIndex = {};
	      var colNameIndex = {};
	      var grpNameIndex = {};
	      var rowIndexValue = {};
	      var colIndexValue = {};
	      var grpIndexValue = {};
	      var rowIdx = 0;
	      var colIdx = 0;
	      var grpIdx = 0;
	      var grpName = '';
	
	      var xValue;
	      var yValue;
	      var row;
	
	      if (!xAxis && !yAxis) {
	        return {
	          d3g: []
	        };
	      }
	
	      for (var i = 0; i < data.rows.length; i++) {
	        row = data.rows[i];
	        if (xAxis) {
	          xValue = row[xAxis.index];
	          xValues[i] = xValue;
	        }
	        if (yAxis) {
	          yValue = row[yAxis.index];
	          yValues[i] = yValue;
	        }
	      }
	
	      var isAllDiscrete = xAxis && yAxis && this.isDiscrete(xValues) && this.isDiscrete(yValues) || !xAxis && this.isDiscrete(yValues) || !yAxis && this.isDiscrete(xValues);
	
	      if (isAllDiscrete) {
	        rows = this.setDiscreteScatterData(data);
	      } else {
	        rows = data.rows;
	      }
	
	      if (!group && isAllDiscrete) {
	        grpName = 'count';
	      } else if (!group && !size) {
	        if (xAxis && yAxis) {
	          grpName = '(' + xAxis.name + ', ' + yAxis.name + ')';
	        } else if (xAxis && !yAxis) {
	          grpName = xAxis.name;
	        } else if (!xAxis && yAxis) {
	          grpName = yAxis.name;
	        }
	      } else if (!group && size) {
	        grpName = size.name;
	      }
	
	      var epsilon = 1e-4; // TODO remove after bump to nvd3 > 1.8.5
	
	      for (i = 0; i < rows.length; i++) {
	        row = rows[i];
	        if (xAxis) {
	          xValue = row[xAxis.index];
	        }
	        if (yAxis) {
	          yValue = row[yAxis.index];
	        }
	        if (group) {
	          grpName = row[group.index];
	        }
	        var sz = isAllDiscrete ? row[row.length - 1] : size ? row[size.index] : 1;
	
	        if (grpNameIndex[grpName] === undefined) {
	          grpIndexValue[grpIdx] = grpName;
	          grpNameIndex[grpName] = grpIdx++;
	        }
	
	        if (xAxis && rowNameIndex[xValue] === undefined) {
	          rowIndexValue[rowIdx] = xValue;
	          rowNameIndex[xValue] = rowIdx++;
	        }
	
	        if (yAxis && colNameIndex[yValue] === undefined) {
	          colIndexValue[colIdx] = yValue;
	          colNameIndex[yValue] = colIdx++;
	        }
	
	        if (!d3g[grpNameIndex[grpName]]) {
	          d3g[grpNameIndex[grpName]] = {
	            key: grpName,
	            values: []
	          };
	        }
	
	        // TODO remove epsilon jitter after bump to nvd3 > 1.8.5
	        var xval,
	            yval = 0;
	        if (xAxis) {
	          xval = (isNaN(xValue) ? rowNameIndex[xValue] : parseFloat(xValue)) + Math.random() * epsilon;
	        }
	        if (yAxis) {
	          yval = (isNaN(yValue) ? colNameIndex[yValue] : parseFloat(yValue)) + Math.random() * epsilon;
	        }
	
	        d3g[grpNameIndex[grpName]].values.push({
	          x: xval,
	          y: yval,
	          size: isNaN(parseFloat(sz)) ? 1 : parseFloat(sz)
	        });
	      }
	
	      // TODO remove sort and dedup after bump to nvd3 > 1.8.5
	      var d3gvalues = d3g[grpNameIndex[grpName]].values;
	      d3gvalues.sort(function (a, b) {
	        return a['x'] - b['x'] || a['y'] - b['y'];
	      });
	
	      for (var i = 0; i < d3gvalues.length - 1;) {
	        if (Math.abs(d3gvalues[i]['x'] - d3gvalues[i + 1]['x']) < epsilon && Math.abs(d3gvalues[i]['y'] - d3gvalues[i + 1]['y']) < epsilon) {
	          d3gvalues.splice(i + 1, 1);
	        } else {
	          i++;
	        }
	      }
	
	      return {
	        xLabels: rowIndexValue,
	        yLabels: colIndexValue,
	        d3g: d3g
	      };
	    }
	  }, {
	    key: 'setDiscreteScatterData',
	    value: function setDiscreteScatterData(data) {
	      var xAxis = this.config.xAxis;
	      var yAxis = this.config.yAxis;
	      var group = this.config.group;
	
	      var xValue;
	      var yValue;
	      var grp;
	
	      var rows = {};
	
	      for (var i = 0; i < data.rows.length; i++) {
	        var row = data.rows[i];
	        if (xAxis) {
	          xValue = row[xAxis.index];
	        }
	        if (yAxis) {
	          yValue = row[yAxis.index];
	        }
	        if (group) {
	          grp = row[group.index];
	        }
	
	        var key = xValue + ',' + yValue + ',' + grp;
	
	        if (!rows[key]) {
	          rows[key] = {
	            x: xValue,
	            y: yValue,
	            group: grp,
	            size: 1
	          };
	        } else {
	          rows[key].size++;
	        }
	      }
	
	      // change object into array
	      var newRows = [];
	      for (var r in rows) {
	        var newRow = [];
	        if (xAxis) {
	          newRow[xAxis.index] = rows[r].x;
	        }
	        if (yAxis) {
	          newRow[yAxis.index] = rows[r].y;
	        }
	        if (group) {
	          newRow[group.index] = rows[r].group;
	        }
	        newRow[data.rows[0].length] = rows[r].size;
	        newRows.push(newRow);
	      }
	      return newRows;
	    }
	  }, {
	    key: 'isDiscrete',
	    value: function isDiscrete(field) {
	      var getUnique = function getUnique(f) {
	        var uniqObj = {};
	        var uniqArr = [];
	        var j = 0;
	        for (var i = 0; i < f.length; i++) {
	          var item = f[i];
	          if (uniqObj[item] !== 1) {
	            uniqObj[item] = 1;
	            uniqArr[j++] = item;
	          }
	        }
	        return uniqArr;
	      };
	
	      for (var i = 0; i < field.length; i++) {
	        if (isNaN(parseFloat(field[i])) && (typeof field[i] === 'string' || field[i] instanceof String)) {
	          return true;
	        }
	      }
	
	      var threshold = 0.05;
	      var unique = getUnique(field);
	      if (unique.length / field.length < threshold) {
	        return true;
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: 'isValidSizeOption',
	    value: function isValidSizeOption(options) {
	      var xValues = [];
	      var yValues = [];
	      var rows = this.tableData.rows;
	
	      for (var i = 0; i < rows.length; i++) {
	        var row = rows[i];
	        var size = row[options.size.index];
	
	        //check if the field is numeric
	        if (isNaN(parseFloat(size)) || !isFinite(size)) {
	          return false;
	        }
	
	        if (options.xAxis) {
	          var x = row[options.xAxis.index];
	          xValues[i] = x;
	        }
	        if (options.yAxis) {
	          var y = row[options.yAxis.index];
	          yValues[i] = y;
	        }
	      }
	
	      //check if all existing fields are discrete
	      var isAllDiscrete = options.xAxis && options.yAxis && this.isDiscrete(xValues) && this.isDiscrete(yValues) || !options.xAxis && this.isDiscrete(yValues) || !options.yAxis && this.isDiscrete(xValues);
	
	      if (isAllDiscrete) {
	        return false;
	      }
	
	      return true;
	    }
	  }]);
	
	  return ScatterchartVisualization;
	}(_visualizationNvd3chart2.default);
	
	exports.default = ScatterchartVisualization;

/***/ },
/* 19 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').controller('JobmanagerCtrl', JobmanagerCtrl);
	
	JobmanagerCtrl.$inject = ['$scope', 'websocketMsgSrv', '$interval', 'ngToast', '$q', '$timeout', 'jobManagerFilter'];
	
	function JobmanagerCtrl($scope, websocketMsgSrv, $interval, ngToast, $q, $timeout, jobManagerFilter) {
	  ngToast.dismiss();
	  var asyncNotebookJobFilter = function asyncNotebookJobFilter(jobInfomations, filterConfig) {
	    return $q(function (resolve, reject) {
	      $scope.JobInfomationsByFilter = $scope.jobTypeFilter(jobInfomations, filterConfig);
	      resolve($scope.JobInfomationsByFilter);
	    });
	  };
	
	  $scope.doFiltering = function (jobInfomations, filterConfig) {
	    asyncNotebookJobFilter(jobInfomations, filterConfig).then(function () {
	      // success
	      $scope.isLoadingFilter = false;
	    }, function () {
	      // failed
	    });
	  };
	
	  $scope.filterValueToName = function (filterValue, maxStringLength) {
	    if ($scope.activeInterpreters === undefined) {
	      return;
	    }
	    var index = _.findIndex($scope.activeInterpreters, { value: filterValue });
	    if ($scope.activeInterpreters[index].name !== undefined) {
	      if (maxStringLength !== undefined && maxStringLength > $scope.activeInterpreters[index].name) {
	        return $scope.activeInterpreters[index].name.substr(0, maxStringLength - 3) + '...';
	      }
	      return $scope.activeInterpreters[index].name;
	    } else {
	      return 'Interpreter is not set';
	    }
	  };
	
	  $scope.setFilterValue = function (filterValue) {
	    $scope.filterConfig.filterValueInterpreter = filterValue;
	    $scope.doFiltering($scope.jobInfomations, $scope.filterConfig);
	  };
	
	  $scope.onChangeRunJobToAlwaysTopToggle = function () {
	    $scope.filterConfig.isRunningAlwaysTop = !$scope.filterConfig.isRunningAlwaysTop;
	    $scope.doFiltering($scope.jobInfomations, $scope.filterConfig);
	  };
	
	  $scope.onChangeSortAsc = function () {
	    $scope.filterConfig.isSortByAsc = !$scope.filterConfig.isSortByAsc;
	    $scope.doFiltering($scope.jobInfomations, $scope.filterConfig);
	  };
	
	  $scope.doFilterInputTyping = function (keyEvent, jobInfomations, filterConfig) {
	    var RETURN_KEY_CODE = 13;
	    $timeout.cancel($scope.dofilterTimeoutObject);
	    $scope.isActiveSearchTimer = true;
	    $scope.dofilterTimeoutObject = $timeout(function () {
	      $scope.doFiltering(jobInfomations, filterConfig);
	      $scope.isActiveSearchTimer = false;
	    }, 10000);
	    if (keyEvent.which === RETURN_KEY_CODE) {
	      $timeout.cancel($scope.dofilterTimeoutObject);
	      $scope.doFiltering(jobInfomations, filterConfig);
	      $scope.isActiveSearchTimer = false;
	    }
	  };
	
	  $scope.doForceFilterInputTyping = function (keyEvent, jobInfomations, filterConfig) {
	    $timeout.cancel($scope.dofilterTimeoutObject);
	    $scope.doFiltering(jobInfomations, filterConfig);
	    $scope.isActiveSearchTimer = false;
	  };
	
	  $scope.init = function () {
	    $scope.isLoadingFilter = true;
	    $scope.jobInfomations = [];
	    $scope.JobInfomationsByFilter = $scope.jobInfomations;
	    $scope.filterConfig = {
	      isRunningAlwaysTop: true,
	      filterValueNotebookName: '',
	      filterValueInterpreter: '*',
	      isSortByAsc: true
	    };
	    $scope.sortTooltipMsg = 'Switch to sort by desc';
	    $scope.jobTypeFilter = jobManagerFilter;
	
	    websocketMsgSrv.getNoteJobsList();
	
	    $scope.$watch('filterConfig.isSortByAsc', function (value) {
	      if (value) {
	        $scope.sortTooltipMsg = 'Switch to sort by desc';
	      } else {
	        $scope.sortTooltipMsg = 'Switch to sort by asc';
	      }
	    });
	
	    $scope.$on('$destroy', function () {
	      websocketMsgSrv.unsubscribeJobManager();
	    });
	  };
	
	  /*
	   ** $scope.$on functions below
	   */
	
	  $scope.$on('setNoteJobs', function (event, responseData) {
	    $scope.lastJobServerUnixTime = responseData.lastResponseUnixTime;
	    $scope.jobInfomations = responseData.jobs;
	    $scope.jobInfomationsIndexs = $scope.jobInfomations ? _.indexBy($scope.jobInfomations, 'noteId') : {};
	    $scope.jobTypeFilter($scope.jobInfomations, $scope.filterConfig);
	    $scope.activeInterpreters = [{
	      name: 'ALL',
	      value: '*'
	    }];
	    var interpreterLists = _.uniq(_.pluck($scope.jobInfomations, 'interpreter'), false);
	    for (var index = 0, length = interpreterLists.length; index < length; index++) {
	      $scope.activeInterpreters.push({
	        name: interpreterLists[index],
	        value: interpreterLists[index]
	      });
	    }
	    $scope.doFiltering($scope.jobInfomations, $scope.filterConfig);
	  });
	
	  $scope.$on('setUpdateNoteJobs', function (event, responseData) {
	    var jobInfomations = $scope.jobInfomations;
	    var indexStore = $scope.jobInfomationsIndexs;
	    $scope.lastJobServerUnixTime = responseData.lastResponseUnixTime;
	    var notes = responseData.jobs;
	    notes.map(function (changedItem) {
	      if (indexStore[changedItem.noteId] === undefined) {
	        var newItem = angular.copy(changedItem);
	        jobInfomations.push(newItem);
	        indexStore[changedItem.noteId] = newItem;
	      } else {
	        var changeOriginTarget = indexStore[changedItem.noteId];
	
	        if (changedItem.isRemoved !== undefined && changedItem.isRemoved === true) {
	
	          // remove Item.
	          var removeIndex = _.findIndex(indexStore, changedItem.noteId);
	          if (removeIndex > -1) {
	            indexStore.splice(removeIndex, 1);
	          }
	
	          removeIndex = _.findIndex(jobInfomations, { 'noteId': changedItem.noteId });
	          if (removeIndex) {
	            jobInfomations.splice(removeIndex, 1);
	          }
	        } else {
	          // change value for item.
	          changeOriginTarget.isRunningJob = changedItem.isRunningJob;
	          changeOriginTarget.noteName = changedItem.noteName;
	          changeOriginTarget.noteType = changedItem.noteType;
	          changeOriginTarget.interpreter = changedItem.interpreter;
	          changeOriginTarget.unixTimeLastRun = changedItem.unixTimeLastRun;
	          changeOriginTarget.paragraphs = changedItem.paragraphs;
	        }
	      }
	    });
	    $scope.doFiltering(jobInfomations, $scope.filterConfig);
	  });
	}

/***/ },
/* 20 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').controller('JobCtrl', JobCtrl);
	
	JobCtrl.$inject = ['$scope', '$http', 'baseUrlSrv'];
	
	function JobCtrl($scope, $http, baseUrlSrv) {
	  $scope.init = function (jobInformation) {
	    $scope.progressValue = 0;
	  };
	
	  $scope.getProgress = function () {
	    var statusList = _.pluck($scope.notebookJob.paragraphs, 'status');
	    var runningJob = _.countBy(statusList, function (status) {
	      if (status === 'FINISHED' || status === 'RUNNING') {
	        return 'matchCount';
	      } else {
	        return 'none';
	      }
	    });
	    var totalCount = statusList.length;
	    var runningJobCount = runningJob.matchCount;
	    var result = Math.ceil(runningJobCount / totalCount * 100);
	    return isNaN(result) ? 0 : result;
	  };
	
	  $scope.runNotebookJob = function (notebookId) {
	    BootstrapDialog.confirm({
	      closable: true,
	      title: '',
	      message: 'Run all paragraphs?',
	      callback: function callback(result) {
	        if (result) {
	          $http({
	            method: 'POST',
	            url: baseUrlSrv.getRestApiBase() + '/notebook/job/' + notebookId,
	            headers: {
	              'Content-Type': 'application/x-www-form-urlencoded'
	            }
	          }).then(function successCallback(response) {
	            // success
	          }, function errorCallback(errorResponse) {
	            var errorText = 'SERVER ERROR';
	            if (!!errorResponse.data.message) {
	              errorText = errorResponse.data.message;
	            }
	            BootstrapDialog.alert({
	              closable: true,
	              title: 'Execution Failure',
	              message: errorText
	            });
	          });
	        }
	      }
	    });
	  };
	
	  $scope.stopNotebookJob = function (notebookId) {
	    BootstrapDialog.confirm({
	      closable: true,
	      title: '',
	      message: 'Stop all paragraphs?',
	      callback: function callback(result) {
	        if (result) {
	          $http({
	            method: 'DELETE',
	            url: baseUrlSrv.getRestApiBase() + '/notebook/job/' + notebookId,
	            headers: {
	              'Content-Type': 'application/x-www-form-urlencoded'
	            }
	          }).then(function successCallback(response) {
	            // success
	          }, function errorCallback(errorResponse) {
	            var errorText = 'SERVER ERROR';
	            if (!!errorResponse.data.message) {
	
	              errorText = errorResponse.data.message;
	            }
	            BootstrapDialog.alert({
	              closable: true,
	              title: 'Stop Failure',
	              message: errorText
	            });
	          });
	        }
	      }
	    });
	  };
	
	  $scope.lastExecuteTime = function (unixtime) {
	    return moment.unix(unixtime / 1000).fromNow();
	  };
	}

/***/ },
/* 21 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').filter('jobManager', jobManagerFilter);
	
	function jobManagerFilter() {
	  function filterContext(jobItems, filterConfig) {
	    var filterValueInterpreter = filterConfig.filterValueInterpreter;
	    var filterValueNotebookName = filterConfig.filterValueNotebookName;
	    var isSortByAsc = filterConfig.isSortByAsc;
	    var filterItems = jobItems;
	
	    if (filterValueInterpreter === undefined) {
	      filterItems = _.filter(filterItems, function (jobItem) {
	        return jobItem.interpreter === undefined ? true : false;
	      });
	    } else if (filterValueInterpreter !== '*') {
	      filterItems = _.where(filterItems, { interpreter: filterValueInterpreter });
	    }
	
	    if (filterValueNotebookName !== '') {
	      filterItems = _.filter(filterItems, function (jobItem) {
	        var lowerFilterValue = filterValueNotebookName.toLocaleLowerCase();
	        var lowerNotebookName = jobItem.noteName.toLocaleLowerCase();
	        return lowerNotebookName.match(new RegExp('.*' + lowerFilterValue + '.*'));
	      });
	    }
	
	    filterItems = _.sortBy(filterItems, function (sortItem) {
	      return sortItem.noteName.toLowerCase();
	    });
	
	    return isSortByAsc ? filterItems : filterItems.reverse();
	  }
	  return filterContext;
	}

/***/ },
/* 22 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').controller('InterpreterCtrl', InterpreterCtrl);
	
	InterpreterCtrl.$inject = ['$rootScope', '$scope', '$http', 'baseUrlSrv', 'ngToast', '$timeout', '$route'];
	
	function InterpreterCtrl($rootScope, $scope, $http, baseUrlSrv, ngToast, $timeout, $route) {
	  var interpreterSettingsTmp = [];
	  $scope.interpreterSettings = [];
	  $scope.availableInterpreters = {};
	  $scope.showAddNewSetting = false;
	  $scope.showRepositoryInfo = false;
	  $scope.searchInterpreter = '';
	  $scope._ = _;
	  ngToast.dismiss();
	
	  $scope.openPermissions = function () {
	    $scope.showInterpreterAuth = true;
	  };
	
	  $scope.closePermissions = function () {
	    $scope.showInterpreterAuth = false;
	  };
	
	  var getSelectJson = function getSelectJson() {
	    var selectJson = {
	      tags: false,
	      multiple: true,
	      tokenSeparators: [',', ' '],
	      minimumInputLength: 2,
	      ajax: {
	        url: function url(params) {
	          if (!params.term) {
	            return false;
	          }
	          return baseUrlSrv.getRestApiBase() + '/security/userlist/' + params.term;
	        },
	        delay: 250,
	        processResults: function processResults(data, params) {
	          var users = [];
	          if (data.body.users.length !== 0) {
	            for (var i = 0; i < data.body.users.length; i++) {
	              users.push({
	                'id': data.body.users[i],
	                'text': data.body.users[i]
	              });
	            }
	          }
	          return {
	            results: users,
	            pagination: {
	              more: false
	            }
	          };
	        },
	        cache: false
	      }
	    };
	    return selectJson;
	  };
	
	  $scope.togglePermissions = function (intpName) {
	    angular.element('#' + intpName + 'Users').select2(getSelectJson());
	    if ($scope.showInterpreterAuth) {
	      $scope.closePermissions();
	    } else {
	      $scope.openPermissions();
	    }
	  };
	
	  $scope.$on('ngRenderFinished', function (event, data) {
	    for (var setting = 0; setting < $scope.interpreterSettings.length; setting++) {
	      angular.element('#' + $scope.interpreterSettings[setting].name + 'Users').select2(getSelectJson());
	    }
	  });
	
	  var getInterpreterSettings = function getInterpreterSettings() {
	    $http.get(baseUrlSrv.getRestApiBase() + '/interpreter/setting').success(function (data, status, headers, config) {
	      $scope.interpreterSettings = data.body;
	      checkDownloadingDependencies();
	    }).error(function (data, status, headers, config) {
	      if (status === 401) {
	        ngToast.danger({
	          content: 'You don\'t have permission on this page',
	          verticalPosition: 'bottom',
	          timeout: '3000'
	        });
	        setTimeout(function () {
	          window.location.replace('/');
	        }, 3000);
	      }
	      console.log('Error %o %o', status, data.message);
	    });
	  };
	
	  var checkDownloadingDependencies = function checkDownloadingDependencies() {
	    var isDownloading = false;
	    for (var index = 0; index < $scope.interpreterSettings.length; index++) {
	      var setting = $scope.interpreterSettings[index];
	      if (setting.status === 'DOWNLOADING_DEPENDENCIES') {
	        isDownloading = true;
	      }
	
	      if (setting.status === 'ERROR' || setting.errorReason) {
	        ngToast.danger({ content: 'Error setting properties for interpreter \'' + setting.group + '.' + setting.name + '\': ' + setting.errorReason,
	          verticalPosition: 'top', dismissOnTimeout: false });
	      }
	    }
	
	    if (isDownloading) {
	      $timeout(function () {
	        if ($route.current.$$route.originalPath === '/interpreter') {
	          getInterpreterSettings();
	        }
	      }, 2000);
	    }
	  };
	
	  var getAvailableInterpreters = function getAvailableInterpreters() {
	    $http.get(baseUrlSrv.getRestApiBase() + '/interpreter').success(function (data, status, headers, config) {
	      $scope.availableInterpreters = data.body;
	    }).error(function (data, status, headers, config) {
	      console.log('Error %o %o', status, data.message);
	    });
	  };
	
	  var emptyNewProperty = function emptyNewProperty(object) {
	    angular.extend(object, { propertyValue: '', propertyKey: '' });
	  };
	
	  var emptyNewDependency = function emptyNewDependency(object) {
	    angular.extend(object, { depArtifact: '', depExclude: '' });
	  };
	
	  var removeTMPSettings = function removeTMPSettings(index) {
	    interpreterSettingsTmp.splice(index, 1);
	  };
	
	  $scope.copyOriginInterpreterSettingProperties = function (settingId) {
	    var index = _.findIndex($scope.interpreterSettings, { 'id': settingId });
	    interpreterSettingsTmp[index] = angular.copy($scope.interpreterSettings[index]);
	  };
	
	  $scope.setPerNoteOption = function (settingId, sessionOption) {
	    var option;
	    if (settingId === undefined) {
	      option = $scope.newInterpreterSetting.option;
	    } else {
	      var index = _.findIndex($scope.interpreterSettings, { 'id': settingId });
	      var setting = $scope.interpreterSettings[index];
	      option = setting.option;
	    }
	
	    if (sessionOption === 'isolated') {
	      option.perNote = sessionOption;
	      option.session = false;
	      option.process = true;
	    } else if (sessionOption === 'scoped') {
	      option.perNote = sessionOption;
	      option.session = true;
	      option.process = false;
	    } else {
	      option.perNote = 'shared';
	      option.session = false;
	      option.process = false;
	    }
	  };
	
	  $scope.setPerUserOption = function (settingId, sessionOption) {
	    var option;
	    if (settingId === undefined) {
	      option = $scope.newInterpreterSetting.option;
	    } else {
	      var index = _.findIndex($scope.interpreterSettings, { 'id': settingId });
	      var setting = $scope.interpreterSettings[index];
	      option = setting.option;
	    }
	
	    if (sessionOption === 'isolated') {
	      option.perUser = sessionOption;
	      option.session = false;
	      option.process = true;
	    } else if (sessionOption === 'scoped') {
	      option.perUser = sessionOption;
	      option.session = true;
	      option.process = false;
	    } else {
	      option.perUser = 'shared';
	      option.session = false;
	      option.process = false;
	    }
	  };
	
	  $scope.getPerNoteOption = function (settingId) {
	    var option;
	    if (settingId === undefined) {
	      option = $scope.newInterpreterSetting.option;
	    } else {
	      var index = _.findIndex($scope.interpreterSettings, { 'id': settingId });
	      var setting = $scope.interpreterSettings[index];
	      option = setting.option;
	    }
	
	    if (option.perNote === 'scoped') {
	      return 'scoped';
	    } else if (option.perNote === 'isolated') {
	      return 'isolated';
	    } else {
	      return 'shared';
	    }
	  };
	
	  $scope.getPerUserOption = function (settingId) {
	    var option;
	    if (settingId === undefined) {
	      option = $scope.newInterpreterSetting.option;
	    } else {
	      var index = _.findIndex($scope.interpreterSettings, { 'id': settingId });
	      var setting = $scope.interpreterSettings[index];
	      option = setting.option;
	    }
	
	    if (option.perUser === 'scoped') {
	      return 'scoped';
	    } else if (option.perUser === 'isolated') {
	      return 'isolated';
	    } else {
	      return 'shared';
	    }
	  };
	
	  $scope.getInterpreterRunningOption = function (settingId) {
	    var sharedModeName = 'shared';
	
	    var globallyModeName = 'Globally';
	    var perNoteModeName = 'Per Note';
	    var perUserModeName = 'Per User';
	
	    var option;
	    if (settingId === undefined) {
	      option = $scope.newInterpreterSetting.option;
	    } else {
	      var index = _.findIndex($scope.interpreterSettings, { 'id': settingId });
	      var setting = $scope.interpreterSettings[index];
	      option = setting.option;
	    }
	
	    var perNote = option.perNote;
	    var perUser = option.perUser;
	
	    // Globally == shared_perNote + shared_perUser
	    if (perNote === sharedModeName && perUser === sharedModeName) {
	      return globallyModeName;
	    }
	
	    if ($rootScope.ticket.ticket === 'anonymous' && $rootScope.ticket.roles === '[]') {
	      if (perNote !== undefined && typeof perNote === 'string' && perNote !== '') {
	        return perNoteModeName;
	      }
	    } else if ($rootScope.ticket.ticket !== 'anonymous') {
	      if (perNote !== undefined && typeof perNote === 'string' && perNote !== '') {
	        if (perUser !== undefined && typeof perUser === 'string' && perUser !== '') {
	          return perUserModeName;
	        }
	        return perNoteModeName;
	      }
	    }
	
	    option.perNote = sharedModeName;
	    option.perUser = sharedModeName;
	    return globallyModeName;
	  };
	
	  $scope.setInterpreterRunningOption = function (settingId, isPerNoteMode, isPerUserMode) {
	    var option;
	    if (settingId === undefined) {
	      option = $scope.newInterpreterSetting.option;
	    } else {
	      var index = _.findIndex($scope.interpreterSettings, { 'id': settingId });
	      var setting = $scope.interpreterSettings[index];
	      option = setting.option;
	    }
	    option.perNote = isPerNoteMode;
	    option.perUser = isPerUserMode;
	  };
	
	  $scope.updateInterpreterSetting = function (form, settingId) {
	    var thisConfirm = BootstrapDialog.confirm({
	      closable: false,
	      closeByBackdrop: false,
	      closeByKeyboard: false,
	      title: '',
	      message: 'Do you want to update this interpreter and restart with new settings?',
	      callback: function callback(result) {
	        if (result) {
	          var index = _.findIndex($scope.interpreterSettings, { 'id': settingId });
	          var setting = $scope.interpreterSettings[index];
	          if (setting.propertyKey !== '' || setting.propertyKey) {
	            $scope.addNewInterpreterProperty(settingId);
	          }
	          if (setting.depArtifact !== '' || setting.depArtifact) {
	            $scope.addNewInterpreterDependency(settingId);
	          }
	          // add missing field of option
	          if (!setting.option) {
	            setting.option = {};
	          }
	          if (setting.option.isExistingProcess === undefined) {
	            setting.option.isExistingProcess = false;
	          }
	          if (setting.option.setPermission === undefined) {
	            setting.option.setPermission = false;
	          }
	          if (setting.option.isUserImpersonate === undefined) {
	            setting.option.isUserImpersonate = false;
	          }
	          if (!($scope.getInterpreterRunningOption(settingId) === 'Per User' && $scope.getPerUserOption(settingId) === 'isolated')) {
	            setting.option.isUserImpersonate = false;
	          }
	          if (setting.option.remote === undefined) {
	            // remote always true for now
	            setting.option.remote = true;
	          }
	          setting.option.users = angular.element('#' + setting.name + 'Users').val();
	
	          var request = {
	            option: angular.copy(setting.option),
	            properties: angular.copy(setting.properties),
	            dependencies: angular.copy(setting.dependencies)
	          };
	
	          thisConfirm.$modalFooter.find('button').addClass('disabled');
	          thisConfirm.$modalFooter.find('button:contains("OK")').html('<i class="fa fa-circle-o-notch fa-spin"></i> Saving Setting');
	
	          $http.put(baseUrlSrv.getRestApiBase() + '/interpreter/setting/' + settingId, request).success(function (data, status, headers, config) {
	            $scope.interpreterSettings[index] = data.body;
	            removeTMPSettings(index);
	            checkDownloadingDependencies();
	            thisConfirm.close();
	          }).error(function (data, status, headers, config) {
	            console.log('Error %o %o', status, data.message);
	            ngToast.danger({ content: data.message, verticalPosition: 'bottom' });
	            form.$show();
	            thisConfirm.close();
	          });
	          return false;
	        } else {
	          form.$show();
	        }
	      }
	    });
	  };
	
	  $scope.resetInterpreterSetting = function (settingId) {
	    var index = _.findIndex($scope.interpreterSettings, { 'id': settingId });
	
	    // Set the old settings back
	    $scope.interpreterSettings[index] = angular.copy(interpreterSettingsTmp[index]);
	    removeTMPSettings(index);
	  };
	
	  $scope.removeInterpreterSetting = function (settingId) {
	    BootstrapDialog.confirm({
	      closable: true,
	      title: '',
	      message: 'Do you want to delete this interpreter setting?',
	      callback: function callback(result) {
	        if (result) {
	          $http.delete(baseUrlSrv.getRestApiBase() + '/interpreter/setting/' + settingId).success(function (data, status, headers, config) {
	
	            var index = _.findIndex($scope.interpreterSettings, { 'id': settingId });
	            $scope.interpreterSettings.splice(index, 1);
	          }).error(function (data, status, headers, config) {
	            console.log('Error %o %o', status, data.message);
	          });
	        }
	      }
	    });
	  };
	
	  $scope.newInterpreterGroupChange = function () {
	    var el = _.pluck(_.filter($scope.availableInterpreters, { 'name': $scope.newInterpreterSetting.group }), 'properties');
	    var properties = {};
	    for (var i = 0; i < el.length; i++) {
	      var intpInfo = el[i];
	      for (var key in intpInfo) {
	        properties[key] = {
	          value: intpInfo[key].defaultValue,
	          description: intpInfo[key].description
	        };
	      }
	    }
	    $scope.newInterpreterSetting.properties = properties;
	  };
	
	  $scope.restartInterpreterSetting = function (settingId) {
	    BootstrapDialog.confirm({
	      closable: true,
	      title: '',
	      message: 'Do you want to restart this interpreter?',
	      callback: function callback(result) {
	        if (result) {
	          $http.put(baseUrlSrv.getRestApiBase() + '/interpreter/setting/restart/' + settingId).success(function (data, status, headers, config) {
	            var index = _.findIndex($scope.interpreterSettings, { 'id': settingId });
	            $scope.interpreterSettings[index] = data.body;
	            ngToast.info('Interpreter stopped. Will be lazily started on next run.');
	          }).error(function (data, status, headers, config) {
	            var errorMsg = data !== null ? data.message : 'Could not connect to server.';
	            console.log('Error %o %o', status, errorMsg);
	            ngToast.danger(errorMsg);
	          });
	        }
	      }
	    });
	  };
	
	  $scope.addNewInterpreterSetting = function () {
	    //user input validation on interpreter creation
	    if (!$scope.newInterpreterSetting.name || !$scope.newInterpreterSetting.name.trim() || !$scope.newInterpreterSetting.group) {
	      BootstrapDialog.alert({
	        closable: true,
	        title: 'Add interpreter',
	        message: 'Please fill in interpreter name and choose a group'
	      });
	      return;
	    }
	
	    if ($scope.newInterpreterSetting.name.indexOf('.') >= 0) {
	      BootstrapDialog.alert({
	        closable: true,
	        title: 'Add interpreter',
	        message: '\'.\' is invalid for interpreter name'
	      });
	      return;
	    }
	
	    if (_.findIndex($scope.interpreterSettings, { 'name': $scope.newInterpreterSetting.name }) >= 0) {
	      BootstrapDialog.alert({
	        closable: true,
	        title: 'Add interpreter',
	        message: 'Name ' + $scope.newInterpreterSetting.name + ' already exists'
	      });
	      return;
	    }
	
	    var newSetting = $scope.newInterpreterSetting;
	    if (newSetting.propertyKey !== '' || newSetting.propertyKey) {
	      $scope.addNewInterpreterProperty();
	    }
	    if (newSetting.depArtifact !== '' || newSetting.depArtifact) {
	      $scope.addNewInterpreterDependency();
	    }
	    if (newSetting.option.setPermission === undefined) {
	      newSetting.option.setPermission = false;
	    }
	    newSetting.option.users = angular.element('#newInterpreterUsers').val();
	
	    var request = angular.copy($scope.newInterpreterSetting);
	
	    // Change properties to proper request format
	    var newProperties = {};
	    for (var p in newSetting.properties) {
	      newProperties[p] = newSetting.properties[p].value;
	    }
	    request.properties = newProperties;
	
	    $http.post(baseUrlSrv.getRestApiBase() + '/interpreter/setting', request).success(function (data, status, headers, config) {
	      $scope.resetNewInterpreterSetting();
	      getInterpreterSettings();
	      $scope.showAddNewSetting = false;
	      checkDownloadingDependencies();
	    }).error(function (data, status, headers, config) {
	      console.log('Error %o %o', status, data.message);
	      ngToast.danger({ content: data.message, verticalPosition: 'bottom' });
	    });
	  };
	
	  $scope.cancelInterpreterSetting = function () {
	    $scope.showAddNewSetting = false;
	    $scope.resetNewInterpreterSetting();
	  };
	
	  $scope.resetNewInterpreterSetting = function () {
	    $scope.newInterpreterSetting = {
	      name: undefined,
	      group: undefined,
	      properties: {},
	      dependencies: [],
	      option: {
	        remote: true,
	        isExistingProcess: false,
	        setPermission: false,
	        session: false,
	        process: false
	
	      }
	    };
	    emptyNewProperty($scope.newInterpreterSetting);
	  };
	
	  $scope.removeInterpreterProperty = function (key, settingId) {
	    if (settingId === undefined) {
	      delete $scope.newInterpreterSetting.properties[key];
	    } else {
	      var index = _.findIndex($scope.interpreterSettings, { 'id': settingId });
	      delete $scope.interpreterSettings[index].properties[key];
	    }
	  };
	
	  $scope.removeInterpreterDependency = function (artifact, settingId) {
	    if (settingId === undefined) {
	      $scope.newInterpreterSetting.dependencies = _.reject($scope.newInterpreterSetting.dependencies, function (el) {
	        return el.groupArtifactVersion === artifact;
	      });
	    } else {
	      var index = _.findIndex($scope.interpreterSettings, { 'id': settingId });
	      $scope.interpreterSettings[index].dependencies = _.reject($scope.interpreterSettings[index].dependencies, function (el) {
	        return el.groupArtifactVersion === artifact;
	      });
	    }
	  };
	
	  $scope.addNewInterpreterProperty = function (settingId) {
	    if (settingId === undefined) {
	      // Add new property from create form
	      if (!$scope.newInterpreterSetting.propertyKey || $scope.newInterpreterSetting.propertyKey === '') {
	        return;
	      }
	
	      $scope.newInterpreterSetting.properties[$scope.newInterpreterSetting.propertyKey] = {
	        value: $scope.newInterpreterSetting.propertyValue
	      };
	      emptyNewProperty($scope.newInterpreterSetting);
	    } else {
	      // Add new property from edit form
	      var index = _.findIndex($scope.interpreterSettings, { 'id': settingId });
	      var setting = $scope.interpreterSettings[index];
	
	      if (!setting.propertyKey || setting.propertyKey === '') {
	        return;
	      }
	      setting.properties[setting.propertyKey] = setting.propertyValue;
	      emptyNewProperty(setting);
	    }
	  };
	
	  $scope.addNewInterpreterDependency = function (settingId) {
	    if (settingId === undefined) {
	      // Add new dependency from create form
	      if (!$scope.newInterpreterSetting.depArtifact || $scope.newInterpreterSetting.depArtifact === '') {
	        return;
	      }
	
	      // overwrite if artifact already exists
	      var newSetting = $scope.newInterpreterSetting;
	      for (var d in newSetting.dependencies) {
	        if (newSetting.dependencies[d].groupArtifactVersion === newSetting.depArtifact) {
	          newSetting.dependencies[d] = {
	            'groupArtifactVersion': newSetting.depArtifact,
	            'exclusions': newSetting.depExclude
	          };
	          newSetting.dependencies.splice(d, 1);
	        }
	      }
	
	      newSetting.dependencies.push({
	        'groupArtifactVersion': newSetting.depArtifact,
	        'exclusions': newSetting.depExclude === '' ? [] : newSetting.depExclude
	      });
	      emptyNewDependency(newSetting);
	    } else {
	      // Add new dependency from edit form
	      var index = _.findIndex($scope.interpreterSettings, { 'id': settingId });
	      var setting = $scope.interpreterSettings[index];
	      if (!setting.depArtifact || setting.depArtifact === '') {
	        return;
	      }
	
	      // overwrite if artifact already exists
	      for (var dep in setting.dependencies) {
	        if (setting.dependencies[dep].groupArtifactVersion === setting.depArtifact) {
	          setting.dependencies[dep] = {
	            'groupArtifactVersion': setting.depArtifact,
	            'exclusions': setting.depExclude
	          };
	          setting.dependencies.splice(dep, 1);
	        }
	      }
	
	      setting.dependencies.push({
	        'groupArtifactVersion': setting.depArtifact,
	        'exclusions': setting.depExclude === '' ? [] : setting.depExclude
	      });
	      emptyNewDependency(setting);
	    }
	  };
	
	  $scope.resetNewRepositorySetting = function () {
	    $scope.newRepoSetting = {
	      id: '',
	      url: '',
	      snapshot: false,
	      username: '',
	      password: '',
	      proxyProtocol: 'HTTP',
	      proxyHost: '',
	      proxyPort: null,
	      proxyLogin: '',
	      proxyPassword: ''
	    };
	  };
	
	  var getRepositories = function getRepositories() {
	    $http.get(baseUrlSrv.getRestApiBase() + '/interpreter/repository').success(function (data, status, headers, config) {
	      $scope.repositories = data.body;
	    }).error(function (data, status, headers, config) {
	      console.log('Error %o %o', status, data.message);
	    });
	  };
	
	  $scope.addNewRepository = function () {
	    var request = angular.copy($scope.newRepoSetting);
	
	    $http.post(baseUrlSrv.getRestApiBase() + '/interpreter/repository', request).success(function (data, status, headers, config) {
	      getRepositories();
	      $scope.resetNewRepositorySetting();
	      angular.element('#repoModal').modal('hide');
	    }).error(function (data, status, headers, config) {
	      console.log('Error %o %o', headers, config);
	    });
	  };
	
	  $scope.removeRepository = function (repoId) {
	    BootstrapDialog.confirm({
	      closable: true,
	      title: '',
	      message: 'Do you want to delete this repository?',
	      callback: function callback(result) {
	        if (result) {
	          $http.delete(baseUrlSrv.getRestApiBase() + '/interpreter/repository/' + repoId).success(function (data, status, headers, config) {
	            var index = _.findIndex($scope.repositories, { 'id': repoId });
	            $scope.repositories.splice(index, 1);
	          }).error(function (data, status, headers, config) {
	            console.log('Error %o %o', status, data.message);
	          });
	        }
	      }
	    });
	  };
	
	  $scope.isDefaultRepository = function (repoId) {
	    if (repoId === 'central' || repoId === 'local') {
	      return true;
	    } else {
	      return false;
	    }
	  };
	
	  $scope.showErrorMessage = function (setting) {
	    BootstrapDialog.show({
	      title: 'Error downloading dependencies',
	      message: setting.errorReason
	    });
	  };
	
	  var init = function init() {
	    $scope.resetNewInterpreterSetting();
	    $scope.resetNewRepositorySetting();
	
	    getInterpreterSettings();
	    getAvailableInterpreters();
	    getRepositories();
	  };
	
	  $scope.showSparkUI = function (settingId) {
	    $http.get(baseUrlSrv.getRestApiBase() + '/interpreter/getmetainfos/' + settingId + '?propName=url').success(function (data, status, headers, config) {
	      var url = data.body.url;
	      if (!url) {
	        BootstrapDialog.alert({
	          message: 'No spark application running'
	        });
	        return;
	      }
	      window.open(url, '_blank');
	    }).error(function (data, status, headers, config) {
	      console.log('Error %o %o', status, data.message);
	    });
	  };
	
	  init();
	}

/***/ },
/* 23 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').filter('sortByKey', sortByKey);
	
	function sortByKey() {
	  return function (properties) {
	    var sortedKeys = properties ? Object.keys(properties) : [];
	    return sortedKeys.sort();
	  };
	}

/***/ },
/* 24 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').controller('CredentialCtrl', CredentialCtrl);
	
	CredentialCtrl.$inject = ['$scope', '$rootScope', '$http', 'baseUrlSrv', 'ngToast'];
	
	function CredentialCtrl($scope, $rootScope, $http, baseUrlSrv, ngToast) {
	  $scope._ = _;
	  ngToast.dismiss();
	
	  $scope.credentialInfo = [];
	  $scope.showAddNewCredentialInfo = false;
	  $scope.availableInterpreters = [];
	
	  var getCredentialInfo = function getCredentialInfo() {
	    $http.get(baseUrlSrv.getRestApiBase() + '/credential').success(function (data, status, headers, config) {
	      $scope.credentialInfo = _.map(data.body.userCredentials, function (value, prop) {
	        return { entity: prop, password: value.password, username: value.username };
	      });
	      console.log('Success %o %o', status, $scope.credentialInfo);
	    }).error(function (data, status, headers, config) {
	      if (status === 401) {
	        ngToast.danger({
	          content: 'You don\'t have permission on this page',
	          verticalPosition: 'bottom',
	          timeout: '3000'
	        });
	        setTimeout(function () {
	          window.location.replace('/');
	        }, 3000);
	      }
	      console.log('Error %o %o', status, data.message);
	    });
	  };
	
	  $scope.addNewCredentialInfo = function () {
	    if ($scope.entity && _.isEmpty($scope.entity.trim()) && $scope.username && _.isEmpty($scope.username.trim())) {
	      ngToast.danger({
	        content: 'Username \\ Entity can not be empty.',
	        verticalPosition: 'bottom',
	        timeout: '3000'
	      });
	      return;
	    }
	
	    var newCredential = {
	      'entity': $scope.entity,
	      'username': $scope.username,
	      'password': $scope.password
	    };
	
	    $http.put(baseUrlSrv.getRestApiBase() + '/credential', newCredential).success(function (data, status, headers, config) {
	      ngToast.success({
	        content: 'Successfully saved credentials.',
	        verticalPosition: 'bottom',
	        timeout: '3000'
	      });
	      $scope.credentialInfo.push(newCredential);
	      resetCredentialInfo();
	      $scope.showAddNewCredentialInfo = false;
	      console.log('Success %o %o', status, data.message);
	    }).error(function (data, status, headers, config) {
	      ngToast.danger({
	        content: 'Error saving credentials',
	        verticalPosition: 'bottom',
	        timeout: '3000'
	      });
	      console.log('Error %o %o', status, data.message);
	    });
	  };
	
	  var getAvailableInterpreters = function getAvailableInterpreters() {
	    $http.get(baseUrlSrv.getRestApiBase() + '/interpreter/setting').success(function (data, status, headers, config) {
	      for (var setting = 0; setting < data.body.length; setting++) {
	        $scope.availableInterpreters.push(data.body[setting].group + '.' + data.body[setting].name);
	      }
	      angular.element('#entityname').autocomplete({
	        source: $scope.availableInterpreters,
	        select: function select(event, selected) {
	          $scope.entity = selected.item.value;
	          return false;
	        }
	      });
	    }).error(function (data, status, headers, config) {
	      console.log('Error %o %o', status, data.message);
	    });
	  };
	
	  $scope.toggleAddNewCredentialInfo = function () {
	    if ($scope.showAddNewCredentialInfo) {
	      $scope.showAddNewCredentialInfo = false;
	    } else {
	      $scope.showAddNewCredentialInfo = true;
	    }
	  };
	
	  $scope.cancelCredentialInfo = function () {
	    $scope.showAddNewCredentialInfo = false;
	    resetCredentialInfo();
	  };
	
	  var resetCredentialInfo = function resetCredentialInfo() {
	    $scope.entity = '';
	    $scope.username = '';
	    $scope.password = '';
	  };
	
	  $scope.copyOriginCredentialsInfo = function () {
	    ngToast.info({
	      content: 'Since entity is a unique key, you can edit only username & password',
	      verticalPosition: 'bottom',
	      timeout: '3000'
	    });
	  };
	
	  $scope.updateCredentialInfo = function (form, data, entity) {
	    var request = {
	      entity: entity,
	      username: data.username,
	      password: data.password
	    };
	
	    $http.put(baseUrlSrv.getRestApiBase() + '/credential/', request).success(function (data, status, headers, config) {
	      var index = _.findIndex($scope.credentialInfo, { 'entity': entity });
	      $scope.credentialInfo[index] = request;
	      return true;
	    }).error(function (data, status, headers, config) {
	      console.log('Error %o %o', status, data.message);
	      ngToast.danger({
	        content: 'We couldn\'t save the credential',
	        verticalPosition: 'bottom',
	        timeout: '3000'
	      });
	      form.$show();
	    });
	    return false;
	  };
	
	  $scope.removeCredentialInfo = function (entity) {
	    BootstrapDialog.confirm({
	      closable: false,
	      closeByBackdrop: false,
	      closeByKeyboard: false,
	      title: '',
	      message: 'Do you want to delete this credential information?',
	      callback: function callback(result) {
	        if (result) {
	          $http.delete(baseUrlSrv.getRestApiBase() + '/credential/' + entity).success(function (data, status, headers, config) {
	            var index = _.findIndex($scope.credentialInfo, { 'entity': entity });
	            $scope.credentialInfo.splice(index, 1);
	            console.log('Success %o %o', status, data.message);
	          }).error(function (data, status, headers, config) {
	            console.log('Error %o %o', status, data.message);
	          });
	        }
	      }
	    });
	  };
	
	  var init = function init() {
	    getAvailableInterpreters();
	    getCredentialInfo();
	  };
	
	  init();
	}

/***/ },
/* 25 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').controller('ConfigurationCtrl', ConfigurationCtrl);
	
	ConfigurationCtrl.$inject = ['$scope', '$rootScope', '$http', 'baseUrlSrv', 'ngToast'];
	
	function ConfigurationCtrl($scope, $rootScope, $http, baseUrlSrv, ngToast) {
	  $scope.configrations = [];
	  $scope._ = _;
	  ngToast.dismiss();
	
	  var getConfigurations = function getConfigurations() {
	    $http.get(baseUrlSrv.getRestApiBase() + '/configurations/all').success(function (data, status, headers, config) {
	      $scope.configurations = data.body;
	    }).error(function (data, status, headers, config) {
	      if (status === 401) {
	        ngToast.danger({
	          content: 'You don\'t have permission on this page',
	          verticalPosition: 'bottom',
	          timeout: '3000'
	        });
	        setTimeout(function () {
	          window.location.replace('/');
	        }, 3000);
	      }
	      console.log('Error %o %o', status, data.message);
	    });
	  };
	
	  var init = function init() {
	    getConfigurations();
	  };
	
	  init();
	}

/***/ },
/* 26 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').controller('ParagraphCtrl', ParagraphCtrl);
	
	ParagraphCtrl.$inject = ['$scope', '$rootScope', '$route', '$window', '$routeParams', '$location', '$timeout', '$compile', '$http', '$q', 'websocketMsgSrv', 'baseUrlSrv', 'ngToast', 'saveAsService', 'noteVarShareService'];
	
	function ParagraphCtrl($scope, $rootScope, $route, $window, $routeParams, $location, $timeout, $compile, $http, $q, websocketMsgSrv, baseUrlSrv, ngToast, saveAsService, noteVarShareService) {
	  var ANGULAR_FUNCTION_OBJECT_NAME_PREFIX = '_Z_ANGULAR_FUNC_';
	  $rootScope.keys = Object.keys;
	  $scope.parentNote = null;
	  $scope.paragraph = null;
	  $scope.originalText = '';
	  $scope.editor = null;
	
	  var editorSetting = {};
	  // flag that is used to set editor setting on paste percent sign
	  var pastePercentSign = false;
	  // flag that is used to set editor setting on save interpreter bindings
	  var setInterpreterBindings = false;
	  var paragraphScope = $rootScope.$new(true, $rootScope);
	
	  // to keep backward compatibility
	  $scope.compiledScope = paragraphScope;
	
	  paragraphScope.z = {
	    // z.runParagraph('20150213-231621_168813393')
	    runParagraph: function runParagraph(paragraphId) {
	      if (paragraphId) {
	        var filtered = $scope.parentNote.paragraphs.filter(function (x) {
	          return x.id === paragraphId;
	        });
	        if (filtered.length === 1) {
	          var paragraph = filtered[0];
	          websocketMsgSrv.runParagraph(paragraph.id, paragraph.title, paragraph.text, paragraph.config, paragraph.settings.params);
	        } else {
	          ngToast.danger({ content: 'Cannot find a paragraph with id \'' + paragraphId + '\'',
	            verticalPosition: 'top', dismissOnTimeout: false });
	        }
	      } else {
	        ngToast.danger({
	          content: 'Please provide a \'paragraphId\' when calling z.runParagraph(paragraphId)',
	          verticalPosition: 'top', dismissOnTimeout: false });
	      }
	    },
	
	    // Example: z.angularBind('my_var', 'Test Value', '20150213-231621_168813393')
	    angularBind: function angularBind(varName, value, paragraphId) {
	      // Only push to server if there paragraphId is defined
	      if (paragraphId) {
	        websocketMsgSrv.clientBindAngularObject($routeParams.noteId, varName, value, paragraphId);
	      } else {
	        ngToast.danger({
	          content: 'Please provide a \'paragraphId\' when calling ' + 'z.angularBind(varName, value, \'PUT_HERE_PARAGRAPH_ID\')',
	          verticalPosition: 'top', dismissOnTimeout: false });
	      }
	    },
	
	    // Example: z.angularUnBind('my_var', '20150213-231621_168813393')
	    angularUnbind: function angularUnbind(varName, paragraphId) {
	      // Only push to server if paragraphId is defined
	      if (paragraphId) {
	        websocketMsgSrv.clientUnbindAngularObject($routeParams.noteId, varName, paragraphId);
	      } else {
	        ngToast.danger({
	          content: 'Please provide a \'paragraphId\' when calling ' + 'z.angularUnbind(varName, \'PUT_HERE_PARAGRAPH_ID\')',
	          verticalPosition: 'top', dismissOnTimeout: false });
	      }
	    }
	  };
	
	  var angularObjectRegistry = {};
	
	  // Controller init
	  $scope.init = function (newParagraph, note) {
	    $scope.paragraph = newParagraph;
	    $scope.parentNote = note;
	    $scope.originalText = angular.copy(newParagraph.text);
	    $scope.chart = {};
	    $scope.baseMapOption = ['Streets', 'Satellite', 'Hybrid', 'Topo', 'Gray', 'Oceans', 'Terrain'];
	    $scope.colWidthOption = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
	    $scope.paragraphFocused = false;
	    if (newParagraph.focus) {
	      $scope.paragraphFocused = true;
	    }
	    if (!$scope.paragraph.config) {
	      $scope.paragraph.config = {};
	    }
	
	    noteVarShareService.put($scope.paragraph.id + '_paragraphScope', paragraphScope);
	
	    initializeDefault($scope.paragraph.config);
	  };
	
	  var initializeDefault = function initializeDefault(config) {
	    var forms = $scope.paragraph.settings.forms;
	
	    if (!config.colWidth) {
	      config.colWidth = 12;
	    }
	
	    if (config.enabled === undefined) {
	      config.enabled = true;
	    }
	
	    for (var idx in forms) {
	      if (forms[idx]) {
	        if (forms[idx].options) {
	          if (config.runOnSelectionChange === undefined) {
	            config.runOnSelectionChange = true;
	          }
	        }
	      }
	    }
	
	    if (!config.results) {
	      config.results = {};
	    }
	
	    if (!config.editorSetting) {
	      config.editorSetting = {};
	    } else if (config.editorSetting.editOnDblClick) {
	      editorSetting.isOutputHidden = config.editorSetting.editOnDblClick;
	    }
	  };
	
	  $scope.$on('updateParagraphOutput', function (event, data) {
	    if ($scope.paragraph.id === data.paragraphId) {
	      if (!$scope.paragraph.results) {
	        $scope.paragraph.results = {};
	      }
	      if (!$scope.paragraph.results.msg) {
	        $scope.paragraph.results.msg = [];
	      }
	
	      var update = $scope.paragraph.results.msg[data.index] ? true : false;
	
	      $scope.paragraph.results.msg[data.index] = {
	        data: data.data,
	        type: data.type
	      };
	
	      if (update) {
	        $rootScope.$broadcast('updateResult', $scope.paragraph.results.msg[data.index], $scope.paragraph.config.results[data.index], $scope.paragraph, data.index);
	      }
	    }
	  });
	
	  $scope.getIframeDimensions = function () {
	    if ($scope.asIframe) {
	      var paragraphid = '#' + $routeParams.paragraphId + '_container';
	      var height = angular.element(paragraphid).height();
	      return height;
	    }
	    return 0;
	  };
	
	  $scope.$watch($scope.getIframeDimensions, function (newValue, oldValue) {
	    if ($scope.asIframe && newValue) {
	      var message = {};
	      message.height = newValue;
	      message.url = $location.$$absUrl;
	      $window.parent.postMessage(angular.toJson(message), '*');
	    }
	  });
	
	  $scope.getEditor = function () {
	    return $scope.editor;
	  };
	
	  $scope.$watch($scope.getEditor, function (newValue, oldValue) {
	    if (!$scope.editor) {
	      return;
	    }
	    if (newValue === null || newValue === undefined) {
	      console.log('editor isnt loaded yet, returning');
	      return;
	    }
	    if ($scope.revisionView === true) {
	      $scope.editor.setReadOnly(true);
	    } else {
	      $scope.editor.setReadOnly(false);
	    }
	  });
	
	  var isEmpty = function isEmpty(object) {
	    return !object;
	  };
	
	  $scope.isRunning = function (paragraph) {
	    return paragraph.status === 'RUNNING' || paragraph.status === 'PENDING';
	  };
	
	  $scope.cancelParagraph = function (paragraph) {
	    console.log('Cancel %o', paragraph.id);
	    websocketMsgSrv.cancelParagraphRun(paragraph.id);
	  };
	
	  $scope.runParagraph = function (data) {
	    websocketMsgSrv.runParagraph($scope.paragraph.id, $scope.paragraph.title, data, $scope.paragraph.config, $scope.paragraph.settings.params);
	    $scope.originalText = angular.copy(data);
	    $scope.dirtyText = undefined;
	
	    if ($scope.paragraph.config.editorSetting.editOnDblClick) {
	      closeEditorAndOpenTable($scope.paragraph);
	    } else if (editorSetting.isOutputHidden && !$scope.paragraph.config.editorSetting.editOnDblClick) {
	      // %md/%angular repl make output to be hidden by default after running
	      // so should open output if repl changed from %md/%angular to another
	      openEditorAndOpenTable($scope.paragraph);
	    }
	    editorSetting.isOutputHidden = $scope.paragraph.config.editorSetting.editOnDblClick;
	  };
	
	  $scope.saveParagraph = function (paragraph) {
	    var dirtyText = paragraph.text;
	    if (dirtyText === undefined || dirtyText === $scope.originalText) {
	      return;
	    }
	    commitParagraph(paragraph);
	    $scope.originalText = dirtyText;
	    $scope.dirtyText = undefined;
	  };
	
	  $scope.toggleEnableDisable = function (paragraph) {
	    paragraph.config.enabled = !paragraph.config.enabled;
	    commitParagraph(paragraph);
	  };
	
	  $scope.run = function (paragraph, editorValue) {
	    if (editorValue && !$scope.isRunning(paragraph)) {
	      $scope.runParagraph(editorValue);
	    }
	  };
	
	  $scope.turnOnAutoRun = function (paragraph) {
	    paragraph.config.runOnSelectionChange = !paragraph.config.runOnSelectionChange;
	    commitParagraph(paragraph);
	  };
	
	  $scope.moveUp = function (paragraph) {
	    $scope.$emit('moveParagraphUp', paragraph);
	  };
	
	  $scope.moveDown = function (paragraph) {
	    $scope.$emit('moveParagraphDown', paragraph);
	  };
	
	  $scope.insertNew = function (position) {
	    $scope.$emit('insertParagraph', $scope.paragraph.id, position);
	  };
	
	  $scope.copyPara = function (position) {
	    var editorValue = $scope.getEditorValue();
	    if (editorValue) {
	      $scope.copyParagraph(editorValue, position);
	    }
	  };
	
	  $scope.copyParagraph = function (data, position) {
	    var newIndex = -1;
	    for (var i = 0; i < $scope.note.paragraphs.length; i++) {
	      if ($scope.note.paragraphs[i].id === $scope.paragraph.id) {
	        //determine position of where to add new paragraph; default is below
	        if (position === 'above') {
	          newIndex = i;
	        } else {
	          newIndex = i + 1;
	        }
	        break;
	      }
	    }
	
	    if (newIndex < 0 || newIndex > $scope.note.paragraphs.length) {
	      return;
	    }
	
	    var config = angular.copy($scope.paragraph.config);
	    config.editorHide = false;
	
	    websocketMsgSrv.copyParagraph(newIndex, $scope.paragraph.title, data, config, $scope.paragraph.settings.params);
	  };
	
	  $scope.removeParagraph = function (paragraph) {
	    var paragraphs = angular.element('div[id$="_paragraphColumn_main"]');
	    if (paragraphs[paragraphs.length - 1].id.indexOf(paragraph.id) === 0) {
	      BootstrapDialog.alert({
	        closable: true,
	        message: 'The last paragraph can\'t be deleted.',
	        callback: function callback(result) {
	          if (result) {
	            $scope.editor.focus();
	          }
	        }
	      });
	    } else {
	      BootstrapDialog.confirm({
	        closable: true,
	        title: '',
	        message: 'Do you want to delete this paragraph?',
	        callback: function callback(result) {
	          if (result) {
	            console.log('Remove paragraph');
	            websocketMsgSrv.removeParagraph(paragraph.id);
	            $scope.$emit('moveFocusToNextParagraph', $scope.paragraph.id);
	          }
	        }
	      });
	    }
	  };
	
	  $scope.clearParagraphOutput = function (paragraph) {
	    websocketMsgSrv.clearParagraphOutput(paragraph.id);
	  };
	
	  $scope.toggleEditor = function (paragraph) {
	    if (paragraph.config.editorHide) {
	      $scope.openEditor(paragraph);
	    } else {
	      $scope.closeEditor(paragraph);
	    }
	  };
	
	  $scope.closeEditor = function (paragraph) {
	    console.log('close the note');
	    paragraph.config.editorHide = true;
	    commitParagraph(paragraph);
	  };
	
	  $scope.openEditor = function (paragraph) {
	    console.log('open the note');
	    paragraph.config.editorHide = false;
	    commitParagraph(paragraph);
	  };
	
	  $scope.closeTable = function (paragraph) {
	    console.log('close the output');
	    paragraph.config.tableHide = true;
	    commitParagraph(paragraph);
	  };
	
	  $scope.openTable = function (paragraph) {
	    console.log('open the output');
	    paragraph.config.tableHide = false;
	    commitParagraph(paragraph);
	  };
	
	  var openEditorAndCloseTable = function openEditorAndCloseTable(paragraph) {
	    manageEditorAndTableState(paragraph, false, true);
	  };
	
	  var closeEditorAndOpenTable = function closeEditorAndOpenTable(paragraph) {
	    manageEditorAndTableState(paragraph, true, false);
	  };
	
	  var openEditorAndOpenTable = function openEditorAndOpenTable(paragraph) {
	    manageEditorAndTableState(paragraph, false, false);
	  };
	
	  var manageEditorAndTableState = function manageEditorAndTableState(paragraph, hideEditor, hideTable) {
	    paragraph.config.editorHide = hideEditor;
	    paragraph.config.tableHide = hideTable;
	    commitParagraph(paragraph);
	  };
	
	  $scope.showTitle = function (paragraph) {
	    paragraph.config.title = true;
	    commitParagraph(paragraph);
	  };
	
	  $scope.hideTitle = function (paragraph) {
	    paragraph.config.title = false;
	    commitParagraph(paragraph);
	  };
	
	  $scope.setTitle = function (paragraph) {
	    commitParagraph(paragraph);
	  };
	
	  $scope.showLineNumbers = function (paragraph) {
	    if ($scope.editor) {
	      paragraph.config.lineNumbers = true;
	      $scope.editor.renderer.setShowGutter(true);
	      commitParagraph(paragraph);
	    }
	  };
	
	  $scope.hideLineNumbers = function (paragraph) {
	    if ($scope.editor) {
	      paragraph.config.lineNumbers = false;
	      $scope.editor.renderer.setShowGutter(false);
	      commitParagraph(paragraph);
	    }
	  };
	
	  $scope.columnWidthClass = function (n) {
	    if ($scope.asIframe) {
	      return 'col-md-12';
	    } else {
	      return 'paragraph-col col-md-' + n;
	    }
	  };
	
	  $scope.changeColWidth = function (paragraph, width) {
	    angular.element('.navbar-right.open').removeClass('open');
	    paragraph.config.colWidth = width;
	    commitParagraph(paragraph);
	  };
	
	  $scope.toggleOutput = function (paragraph) {
	    paragraph.config.tableHide = !paragraph.config.tableHide;
	    commitParagraph(paragraph);
	  };
	
	  $scope.loadForm = function (formulaire, params) {
	    var value = formulaire.defaultValue;
	    if (params[formulaire.name]) {
	      value = params[formulaire.name];
	    }
	
	    $scope.paragraph.settings.params[formulaire.name] = value;
	  };
	
	  $scope.toggleCheckbox = function (formulaire, option) {
	    var idx = $scope.paragraph.settings.params[formulaire.name].indexOf(option.value);
	    if (idx > -1) {
	      $scope.paragraph.settings.params[formulaire.name].splice(idx, 1);
	    } else {
	      $scope.paragraph.settings.params[formulaire.name].push(option.value);
	    }
	  };
	
	  $scope.aceChanged = function (_, editor) {
	    var session = editor.getSession();
	    var dirtyText = session.getValue();
	    $scope.dirtyText = dirtyText;
	    $scope.$broadcast('startSaveTimer');
	    setParagraphMode(session, dirtyText, editor.getCursorPosition());
	  };
	
	  $scope.aceLoaded = function (_editor) {
	    var langTools = ace.require('ace/ext/language_tools');
	    var Range = ace.require('ace/range').Range;
	
	    _editor.$blockScrolling = Infinity;
	    $scope.editor = _editor;
	    $scope.editor.on('input', $scope.aceChanged);
	    if (_editor.container.id !== '{{paragraph.id}}_editor') {
	      $scope.editor.renderer.setShowGutter($scope.paragraph.config.lineNumbers);
	      $scope.editor.setShowFoldWidgets(false);
	      $scope.editor.setHighlightActiveLine(false);
	      $scope.editor.setHighlightGutterLine(false);
	      $scope.editor.getSession().setUseWrapMode(true);
	      $scope.editor.setTheme('ace/theme/chrome');
	      $scope.editor.setReadOnly($scope.isRunning($scope.paragraph));
	      if ($scope.paragraphFocused) {
	        $scope.editor.focus();
	        $scope.goToEnd($scope.editor);
	      }
	
	      autoAdjustEditorHeight(_editor);
	      angular.element(window).resize(function () {
	        autoAdjustEditorHeight(_editor);
	      });
	
	      if (navigator.appVersion.indexOf('Mac') !== -1) {
	        $scope.editor.setKeyboardHandler('ace/keyboard/emacs');
	        $rootScope.isMac = true;
	      } else if (navigator.appVersion.indexOf('Win') !== -1 || navigator.appVersion.indexOf('X11') !== -1 || navigator.appVersion.indexOf('Linux') !== -1) {
	        $rootScope.isMac = false;
	        // not applying emacs key binding while the binding override Ctrl-v. default behavior of paste text on windows.
	      }
	
	      var remoteCompleter = {
	        getCompletions: function getCompletions(editor, session, pos, prefix, callback) {
	          if (!editor.isFocused()) {
	            return;
	          }
	
	          pos = session.getTextRange(new Range(0, 0, pos.row, pos.column)).length;
	          var buf = session.getValue();
	
	          websocketMsgSrv.completion($scope.paragraph.id, buf, pos);
	
	          $scope.$on('completionList', function (event, data) {
	            if (data.completions) {
	              var completions = [];
	              for (var c in data.completions) {
	                var v = data.completions[c];
	                completions.push({
	                  name: v.name,
	                  value: v.value,
	                  score: 300
	                });
	              }
	              callback(null, completions);
	            }
	          });
	        }
	      };
	
	      langTools.setCompleters([remoteCompleter, langTools.keyWordCompleter, langTools.snippetCompleter, langTools.textCompleter]);
	
	      $scope.editor.setOptions({
	        enableBasicAutocompletion: true,
	        enableSnippets: false,
	        enableLiveAutocompletion: false
	      });
	
	      $scope.editor.on('focus', function () {
	        handleFocus(true);
	      });
	
	      $scope.editor.on('blur', function () {
	        handleFocus(false);
	      });
	
	      $scope.editor.on('paste', function (e) {
	        if (e.text.indexOf('%') === 0) {
	          pastePercentSign = true;
	        }
	      });
	
	      $scope.editor.getSession().on('change', function (e, editSession) {
	        autoAdjustEditorHeight(_editor);
	      });
	
	      setParagraphMode($scope.editor.getSession(), $scope.editor.getSession().getValue());
	
	      // autocomplete on '.'
	      /*
	       $scope.editor.commands.on("afterExec", function(e, t) {
	       if (e.command.name == "insertstring" && e.args == "." ) {
	       var all = e.editor.completers;
	       //e.editor.completers = [remoteCompleter];
	       e.editor.execCommand("startAutocomplete");
	       //e.editor.completers = all;
	       }
	       });
	       */
	
	      // remove binding
	      $scope.editor.commands.bindKey('ctrl-alt-n.', null);
	      $scope.editor.commands.removeCommand('showSettingsMenu');
	
	      $scope.editor.commands.bindKey('ctrl-alt-l', null);
	      $scope.editor.commands.bindKey('ctrl-alt-w', null);
	      $scope.editor.commands.bindKey('ctrl-alt-a', null);
	      $scope.editor.commands.bindKey('ctrl-alt-k', null);
	      $scope.editor.commands.bindKey('ctrl-alt-e', null);
	      $scope.editor.commands.bindKey('ctrl-alt-t', null);
	
	      // autocomplete on 'ctrl+.'
	      $scope.editor.commands.bindKey('ctrl-.', 'startAutocomplete');
	      $scope.editor.commands.bindKey('ctrl-space', null);
	
	      var keyBindingEditorFocusAction = function keyBindingEditorFocusAction(scrollValue) {
	        var numRows = $scope.editor.getSession().getLength();
	        var currentRow = $scope.editor.getCursorPosition().row;
	        if (currentRow === 0 && scrollValue <= 0) {
	          // move focus to previous paragraph
	          $scope.$emit('moveFocusToPreviousParagraph', $scope.paragraph.id);
	        } else if (currentRow === numRows - 1 && scrollValue >= 0) {
	          $scope.$emit('moveFocusToNextParagraph', $scope.paragraph.id);
	        } else {
	          $scope.scrollToCursor($scope.paragraph.id, scrollValue);
	        }
	      };
	
	      // handle cursor moves
	      $scope.editor.keyBinding.origOnCommandKey = $scope.editor.keyBinding.onCommandKey;
	      $scope.editor.keyBinding.onCommandKey = function (e, hashId, keyCode) {
	        if ($scope.editor.completer && $scope.editor.completer.activated) {// if autocompleter is active
	        } else {
	          // fix ace editor focus issue in chrome (textarea element goes to top: -1000px after focused by cursor move)
	          if (parseInt(angular.element('#' + $scope.paragraph.id + '_editor > textarea').css('top').replace('px', '')) < 0) {
	            var position = $scope.editor.getCursorPosition();
	            var cursorPos = $scope.editor.renderer.$cursorLayer.getPixelPosition(position, true);
	            angular.element('#' + $scope.paragraph.id + '_editor > textarea').css('top', cursorPos.top);
	          }
	
	          var ROW_UP = -1;
	          var ROW_DOWN = 1;
	
	          switch (keyCode) {
	            case 38:
	              keyBindingEditorFocusAction(ROW_UP);
	              break;
	            case 80:
	              if (e.ctrlKey && !e.altKey) {
	                keyBindingEditorFocusAction(ROW_UP);
	              }
	              break;
	            case 40:
	              keyBindingEditorFocusAction(ROW_DOWN);
	              break;
	            case 78:
	              if (e.ctrlKey && !e.altKey) {
	                keyBindingEditorFocusAction(ROW_DOWN);
	              }
	              break;
	          }
	        }
	        this.origOnCommandKey(e, hashId, keyCode);
	      };
	    }
	  };
	
	  var handleFocus = function handleFocus(value, isDigestPass) {
	    $scope.paragraphFocused = value;
	    if (isDigestPass === false || isDigestPass === undefined) {
	      // Protect against error in case digest is already running
	      $timeout(function () {
	        // Apply changes since they come from 3rd party library
	        $scope.$digest();
	      });
	    }
	  };
	
	  var getEditorSetting = function getEditorSetting(paragraph, interpreterName) {
	    var deferred = $q.defer();
	    websocketMsgSrv.getEditorSetting(paragraph.id, interpreterName);
	    $timeout($scope.$on('editorSetting', function (event, data) {
	      if (paragraph.id === data.paragraphId) {
	        deferred.resolve(data);
	      }
	    }), 1000);
	    return deferred.promise;
	  };
	
	  var setEditorLanguage = function setEditorLanguage(session, language) {
	    var mode = 'ace/mode/';
	    mode += language;
	    $scope.paragraph.config.editorMode = mode;
	    session.setMode(mode);
	  };
	
	  var setParagraphMode = function setParagraphMode(session, paragraphText, pos) {
	    // Evaluate the mode only if the the position is undefined
	    // or the first 30 characters of the paragraph have been modified
	    // or cursor position is at beginning of second line.(in case user hit enter after typing %magic)
	    if (typeof pos === 'undefined' || pos.row === 0 && pos.column < 30 || pos.row === 1 && pos.column === 0 || pastePercentSign) {
	      // If paragraph loading, use config value if exists
	      if (typeof pos === 'undefined' && $scope.paragraph.config.editorMode && !setInterpreterBindings) {
	        session.setMode($scope.paragraph.config.editorMode);
	      } else {
	        var magic = getInterpreterName(paragraphText);
	        if (editorSetting.magic !== magic) {
	          editorSetting.magic = magic;
	          getEditorSetting($scope.paragraph, magic).then(function (setting) {
	            setEditorLanguage(session, setting.editor.language);
	            _.merge($scope.paragraph.config.editorSetting, setting.editor);
	          });
	        }
	      }
	    }
	    pastePercentSign = false;
	    setInterpreterBindings = false;
	  };
	
	  var getInterpreterName = function getInterpreterName(paragraphText) {
	    var intpNameRegexp = /^\s*%(.+?)\s/g;
	    var match = intpNameRegexp.exec(paragraphText);
	    if (match) {
	      return match[1].trim();
	      // get default interpreter name if paragraph text doesn't start with '%'
	      // TODO(mina): dig into the cause what makes interpreterBindings to have no element
	    } else if ($scope.$parent.interpreterBindings && $scope.$parent.interpreterBindings.length !== 0) {
	      return $scope.$parent.interpreterBindings[0].name;
	    }
	    return '';
	  };
	
	  var autoAdjustEditorHeight = function autoAdjustEditorHeight(editor) {
	    var height = editor.getSession().getScreenLength() * editor.renderer.lineHeight + editor.renderer.scrollBar.getWidth();
	
	    angular.element('#' + editor.container.id).height(height.toString() + 'px');
	    editor.resize();
	  };
	
	  $rootScope.$on('scrollToCursor', function (event) {
	    // scroll on 'scrollToCursor' event only when cursor is in the last paragraph
	    var paragraphs = angular.element('div[id$="_paragraphColumn_main"]');
	    if (paragraphs[paragraphs.length - 1].id.indexOf($scope.paragraph.id) === 0) {
	      $scope.scrollToCursor($scope.paragraph.id, 0);
	    }
	  });
	
	  /** scrollToCursor if it is necessary
	   * when cursor touches scrollTriggerEdgeMargin from the top (or bottom) of the screen, it autoscroll to place cursor around 1/3 of screen height from the top (or bottom)
	   * paragraphId : paragraph that has active cursor
	   * lastCursorMove : 1(down), 0, -1(up) last cursor move event
	   **/
	  $scope.scrollToCursor = function (paragraphId, lastCursorMove) {
	    if (!$scope.editor || !$scope.editor.isFocused()) {
	      // only make sense when editor is focused
	      return;
	    }
	    var lineHeight = $scope.editor.renderer.lineHeight;
	    var headerHeight = 103; // menubar, notebook titlebar
	    var scrollTriggerEdgeMargin = 50;
	
	    var documentHeight = angular.element(document).height();
	    var windowHeight = angular.element(window).height(); // actual viewport height
	
	    var scrollPosition = angular.element(document).scrollTop();
	    var editorPosition = angular.element('#' + paragraphId + '_editor').offset();
	    var position = $scope.editor.getCursorPosition();
	    var lastCursorPosition = $scope.editor.renderer.$cursorLayer.getPixelPosition(position, true);
	
	    var calculatedCursorPosition = editorPosition.top + lastCursorPosition.top + lineHeight * lastCursorMove;
	
	    var scrollTargetPos;
	    if (calculatedCursorPosition < scrollPosition + headerHeight + scrollTriggerEdgeMargin) {
	      scrollTargetPos = calculatedCursorPosition - headerHeight - (windowHeight - headerHeight) / 3;
	      if (scrollTargetPos < 0) {
	        scrollTargetPos = 0;
	      }
	    } else if (calculatedCursorPosition > scrollPosition + scrollTriggerEdgeMargin + windowHeight - headerHeight) {
	      scrollTargetPos = calculatedCursorPosition - headerHeight - (windowHeight - headerHeight) * 2 / 3;
	
	      if (scrollTargetPos > documentHeight) {
	        scrollTargetPos = documentHeight;
	      }
	    }
	
	    // cancel previous scroll animation
	    var bodyEl = angular.element('body');
	    bodyEl.stop();
	    bodyEl.finish();
	
	    // scroll to scrollTargetPos
	    bodyEl.scrollTo(scrollTargetPos, { axis: 'y', interrupt: true, duration: 100 });
	  };
	
	  $scope.getEditorValue = function () {
	    return !$scope.editor ? $scope.paragraph.text : $scope.editor.getValue();
	  };
	
	  $scope.getProgress = function () {
	    return $scope.currentProgress || 0;
	  };
	
	  $scope.getExecutionTime = function (pdata) {
	    var timeMs = Date.parse(pdata.dateFinished) - Date.parse(pdata.dateStarted);
	    if (isNaN(timeMs) || timeMs < 0) {
	      if ($scope.isResultOutdated(pdata)) {
	        return 'outdated';
	      }
	      return '';
	    }
	    var user = pdata.user === undefined || pdata.user === null ? 'anonymous' : pdata.user;
	    var desc = 'Took ' + moment.duration(timeMs / 1000, 'seconds').format('h [hrs] m [min] s [sec]') + '. Last updated by ' + user + ' at ' + moment(pdata.dateFinished).format('MMMM DD YYYY, h:mm:ss A') + '.';
	    if ($scope.isResultOutdated(pdata)) {
	      desc += ' (outdated)';
	    }
	    return desc;
	  };
	
	  $scope.getElapsedTime = function (paragraph) {
	    return 'Started ' + moment(paragraph.dateStarted).fromNow() + '.';
	  };
	
	  $scope.isResultOutdated = function (pdata) {
	    if (pdata.dateUpdated !== undefined && Date.parse(pdata.dateUpdated) > Date.parse(pdata.dateStarted)) {
	      return true;
	    }
	    return false;
	  };
	
	  $scope.goToEnd = function (editor) {
	    editor.navigateFileEnd();
	  };
	
	  $scope.getResultType = function (paragraph) {
	    var pdata = paragraph ? paragraph : $scope.paragraph;
	    if (pdata.results && pdata.results.type) {
	      return pdata.results.type;
	    } else {
	      return 'TEXT';
	    }
	  };
	
	  $scope.parseTableCell = function (cell) {
	    if (!isNaN(cell)) {
	      if (cell.length === 0 || Number(cell) > Number.MAX_SAFE_INTEGER || Number(cell) < Number.MIN_SAFE_INTEGER) {
	        return cell;
	      } else {
	        return Number(cell);
	      }
	    }
	    var d = moment(cell);
	    if (d.isValid()) {
	      return d;
	    }
	    return cell;
	  };
	
	  var commitParagraph = function commitParagraph(paragraph) {
	    var id = paragraph.id,
	        title = paragraph.title,
	        text = paragraph.text,
	        config = paragraph.config,
	        params = paragraph.settings.params;
	
	
	    websocketMsgSrv.commitParagraph(id, title, text, config, params);
	  };
	
	  /** Utility function */
	  $scope.goToSingleParagraph = function () {
	    var noteId = $route.current.pathParams.noteId;
	    var redirectToUrl = location.protocol + '//' + location.host + location.pathname + '#/notebook/' + noteId + '/paragraph/' + $scope.paragraph.id + '?asIframe';
	    $window.open(redirectToUrl);
	  };
	
	  $scope.showScrollDownIcon = function (id) {
	    var doc = angular.element('#p' + id + '_text');
	    if (doc[0]) {
	      return doc[0].scrollHeight > doc.innerHeight();
	    }
	    return false;
	  };
	
	  $scope.scrollParagraphDown = function (id) {
	    var doc = angular.element('#p' + id + '_text');
	    doc.animate({ scrollTop: doc[0].scrollHeight }, 500);
	    $scope.keepScrollDown = true;
	  };
	
	  $scope.showScrollUpIcon = function (id) {
	    if (angular.element('#p' + id + '_text')[0]) {
	      return angular.element('#p' + id + '_text')[0].scrollTop !== 0;
	    }
	    return false;
	  };
	
	  $scope.scrollParagraphUp = function (id) {
	    var doc = angular.element('#p' + id + '_text');
	    doc.animate({ scrollTop: 0 }, 500);
	    $scope.keepScrollDown = false;
	  };
	
	  $scope.$on('angularObjectUpdate', function (event, data) {
	    var noteId = $route.current.pathParams.noteId;
	    if (!data.noteId || data.noteId === noteId) {
	      var scope;
	      var registry;
	
	      if (!data.paragraphId || data.paragraphId === $scope.paragraph.id) {
	        scope = paragraphScope;
	        registry = angularObjectRegistry;
	      } else {
	        return;
	      }
	      var varName = data.angularObject.name;
	
	      if (angular.equals(data.angularObject.object, scope[varName])) {
	        // return when update has no change
	        return;
	      }
	
	      if (!registry[varName]) {
	        registry[varName] = {
	          interpreterGroupId: data.interpreterGroupId,
	          noteId: data.noteId,
	          paragraphId: data.paragraphId
	        };
	      } else {
	        registry[varName].noteId = registry[varName].noteId || data.noteId;
	        registry[varName].paragraphId = registry[varName].paragraphId || data.paragraphId;
	      }
	
	      registry[varName].skipEmit = true;
	
	      if (!registry[varName].clearWatcher) {
	        registry[varName].clearWatcher = scope.$watch(varName, function (newValue, oldValue) {
	          console.log('angular object (paragraph) updated %o %o', varName, registry[varName]);
	          if (registry[varName].skipEmit) {
	            registry[varName].skipEmit = false;
	            return;
	          }
	          websocketMsgSrv.updateAngularObject(registry[varName].noteId, registry[varName].paragraphId, varName, newValue, registry[varName].interpreterGroupId);
	        });
	      }
	      console.log('angular object (paragraph) created %o', varName);
	      scope[varName] = data.angularObject.object;
	
	      // create proxy for AngularFunction
	      if (varName.indexOf(ANGULAR_FUNCTION_OBJECT_NAME_PREFIX) === 0) {
	        var funcName = varName.substring(ANGULAR_FUNCTION_OBJECT_NAME_PREFIX.length);
	        scope[funcName] = function () {
	          scope[varName] = arguments;
	          console.log('angular function (paragraph) invoked %o', arguments);
	        };
	
	        console.log('angular function (paragraph) created %o', scope[funcName]);
	      }
	    }
	  });
	
	  $scope.$on('angularObjectRemove', function (event, data) {
	    var noteId = $route.current.pathParams.noteId;
	    if (!data.noteId || data.noteId === noteId) {
	      var scope;
	      var registry;
	
	      if (!data.paragraphId || data.paragraphId === $scope.paragraph.id) {
	        scope = paragraphScope;
	        registry = angularObjectRegistry;
	      } else {
	        return;
	      }
	
	      var varName = data.name;
	
	      // clear watcher
	      if (registry[varName]) {
	        registry[varName].clearWatcher();
	        registry[varName] = undefined;
	      }
	
	      // remove scope variable
	      scope[varName] = undefined;
	
	      // remove proxy for AngularFunction
	      if (varName.indexOf(ANGULAR_FUNCTION_OBJECT_NAME_PREFIX) === 0) {
	        var funcName = varName.substring(ANGULAR_FUNCTION_OBJECT_NAME_PREFIX.length);
	        scope[funcName] = undefined;
	      }
	    }
	  });
	
	  $scope.$on('updateParagraph', function (event, data) {
	    if (data.paragraph.id === $scope.paragraph.id && (data.paragraph.dateCreated !== $scope.paragraph.dateCreated || data.paragraph.dateFinished !== $scope.paragraph.dateFinished || data.paragraph.dateStarted !== $scope.paragraph.dateStarted || data.paragraph.dateUpdated !== $scope.paragraph.dateUpdated || data.paragraph.status !== $scope.paragraph.status || data.paragraph.jobName !== $scope.paragraph.jobName || data.paragraph.title !== $scope.paragraph.title || isEmpty(data.paragraph.results) !== isEmpty($scope.paragraph.results) || data.paragraph.errorMessage !== $scope.paragraph.errorMessage || !angular.equals(data.paragraph.settings, $scope.paragraph.settings) || !angular.equals(data.paragraph.config, $scope.paragraph.config))) {
	      var statusChanged = data.paragraph.status !== $scope.paragraph.status;
	      var resultRefreshed = data.paragraph.dateFinished !== $scope.paragraph.dateFinished || isEmpty(data.paragraph.results) !== isEmpty($scope.paragraph.results) || data.paragraph.status === 'ERROR' || data.paragraph.status === 'FINISHED' && statusChanged;
	
	      if ($scope.paragraph.text !== data.paragraph.text) {
	        if ($scope.dirtyText) {
	          // check if editor has local update
	          if ($scope.dirtyText === data.paragraph.text) {
	            // when local update is the same from remote, clear local update
	            $scope.paragraph.text = data.paragraph.text;
	            $scope.dirtyText = undefined;
	            $scope.originalText = angular.copy(data.paragraph.text);
	          } else {
	            // if there're local update, keep it.
	            $scope.paragraph.text = data.paragraph.text;
	          }
	        } else {
	          $scope.paragraph.text = data.paragraph.text;
	          $scope.originalText = angular.copy(data.paragraph.text);
	        }
	      }
	
	      /** broadcast update to result controller **/
	      if (data.paragraph.results && data.paragraph.results.msg) {
	        for (var i in data.paragraph.results.msg) {
	          var newResult = data.paragraph.results.msg ? data.paragraph.results.msg[i] : {};
	          var oldResult = $scope.paragraph.results && $scope.paragraph.results.msg ? $scope.paragraph.results.msg[i] : {};
	          var newConfig = data.paragraph.config.results ? data.paragraph.config.results[i] : {};
	          var oldConfig = $scope.paragraph.config.results ? $scope.paragraph.config.results[i] : {};
	          if (!angular.equals(newResult, oldResult) || !angular.equals(newConfig, oldConfig)) {
	            $rootScope.$broadcast('updateResult', newResult, newConfig, data.paragraph, parseInt(i));
	          }
	        }
	      }
	
	      // resize col width
	      if ($scope.paragraph.config.colWidth !== data.paragraph.colWidth) {
	        $rootScope.$broadcast('paragraphResized', $scope.paragraph.id);
	      }
	
	      /** push the rest */
	      $scope.paragraph.aborted = data.paragraph.aborted;
	      $scope.paragraph.user = data.paragraph.user;
	      $scope.paragraph.dateUpdated = data.paragraph.dateUpdated;
	      $scope.paragraph.dateCreated = data.paragraph.dateCreated;
	      $scope.paragraph.dateFinished = data.paragraph.dateFinished;
	      $scope.paragraph.dateStarted = data.paragraph.dateStarted;
	      $scope.paragraph.errorMessage = data.paragraph.errorMessage;
	      $scope.paragraph.jobName = data.paragraph.jobName;
	      $scope.paragraph.title = data.paragraph.title;
	      $scope.paragraph.lineNumbers = data.paragraph.lineNumbers;
	      $scope.paragraph.status = data.paragraph.status;
	      if (data.paragraph.status !== 'RUNNING') {
	        $scope.paragraph.results = data.paragraph.results;
	      }
	      $scope.paragraph.settings = data.paragraph.settings;
	      if ($scope.editor) {
	        $scope.editor.setReadOnly($scope.isRunning(data.paragraph));
	      }
	
	      if (!$scope.asIframe) {
	        $scope.paragraph.config = data.paragraph.config;
	        initializeDefault(data.paragraph.config);
	      } else {
	        data.paragraph.config.editorHide = true;
	        data.paragraph.config.tableHide = false;
	        $scope.paragraph.config = data.paragraph.config;
	      }
	
	      if (statusChanged || resultRefreshed) {
	        // when last paragraph runs, zeppelin automatically appends new paragraph.
	        // this broadcast will focus to the newly inserted paragraph
	        var paragraphs = angular.element('div[id$="_paragraphColumn_main"]');
	        if (paragraphs.length >= 2 && paragraphs[paragraphs.length - 2].id.indexOf($scope.paragraph.id) === 0) {
	          // rendering output can took some time. So delay scrolling event firing for sometime.
	          setTimeout(function () {
	            $rootScope.$broadcast('scrollToCursor');
	          }, 500);
	        }
	      }
	    }
	  });
	
	  $scope.$on('updateProgress', function (event, data) {
	    if (data.id === $scope.paragraph.id) {
	      $scope.currentProgress = data.progress;
	    }
	  });
	
	  $scope.$on('keyEvent', function (event, keyEvent) {
	    if ($scope.paragraphFocused) {
	
	      var paragraphId = $scope.paragraph.id;
	      var keyCode = keyEvent.keyCode;
	      var noShortcutDefined = false;
	      var editorHide = $scope.paragraph.config.editorHide;
	
	      if (editorHide && (keyCode === 38 || keyCode === 80 && keyEvent.ctrlKey && !keyEvent.altKey)) {
	        // up
	        // move focus to previous paragraph
	        $scope.$emit('moveFocusToPreviousParagraph', paragraphId);
	      } else if (editorHide && (keyCode === 40 || keyCode === 78 && keyEvent.ctrlKey && !keyEvent.altKey)) {
	        // down
	        // move focus to next paragraph
	        $scope.$emit('moveFocusToNextParagraph', paragraphId);
	      } else if (keyEvent.shiftKey && keyCode === 13) {
	        // Shift + Enter
	        $scope.run($scope.paragraph, $scope.getEditorValue());
	      } else if (keyEvent.ctrlKey && keyEvent.altKey && keyCode === 67) {
	        // Ctrl + Alt + c
	        $scope.cancelParagraph($scope.paragraph);
	      } else if (keyEvent.ctrlKey && keyEvent.altKey && keyCode === 68) {
	        // Ctrl + Alt + d
	        $scope.removeParagraph($scope.paragraph);
	      } else if (keyEvent.ctrlKey && keyEvent.altKey && keyCode === 75) {
	        // Ctrl + Alt + k
	        $scope.moveUp($scope.paragraph);
	      } else if (keyEvent.ctrlKey && keyEvent.altKey && keyCode === 74) {
	        // Ctrl + Alt + j
	        $scope.moveDown($scope.paragraph);
	      } else if (keyEvent.ctrlKey && keyEvent.altKey && keyCode === 65) {
	        // Ctrl + Alt + a
	        $scope.insertNew('above');
	      } else if (keyEvent.ctrlKey && keyEvent.altKey && keyCode === 66) {
	        // Ctrl + Alt + b
	        $scope.insertNew('below');
	      } else if (keyEvent.ctrlKey && keyEvent.altKey && keyCode === 79) {
	        // Ctrl + Alt + o
	        $scope.toggleOutput($scope.paragraph);
	      } else if (keyEvent.ctrlKey && keyEvent.altKey && keyCode === 82) {
	        // Ctrl + Alt + r
	        $scope.toggleEnableDisable($scope.paragraph);
	      } else if (keyEvent.ctrlKey && keyEvent.altKey && keyCode === 69) {
	        // Ctrl + Alt + e
	        $scope.toggleEditor($scope.paragraph);
	      } else if (keyEvent.ctrlKey && keyEvent.altKey && keyCode === 77) {
	        // Ctrl + Alt + m
	        if ($scope.paragraph.config.lineNumbers) {
	          $scope.hideLineNumbers($scope.paragraph);
	        } else {
	          $scope.showLineNumbers($scope.paragraph);
	        }
	      } else if (keyEvent.ctrlKey && keyEvent.shiftKey && keyCode === 189) {
	        // Ctrl + Shift + -
	        $scope.changeColWidth($scope.paragraph, Math.max(1, $scope.paragraph.config.colWidth - 1));
	      } else if (keyEvent.ctrlKey && keyEvent.shiftKey && keyCode === 187) {
	        // Ctrl + Shift + =
	        $scope.changeColWidth($scope.paragraph, Math.min(12, $scope.paragraph.config.colWidth + 1));
	      } else if (keyEvent.ctrlKey && keyEvent.altKey && keyCode === 84) {
	        // Ctrl + Alt + t
	        if ($scope.paragraph.config.title) {
	          $scope.hideTitle($scope.paragraph);
	        } else {
	          $scope.showTitle($scope.paragraph);
	        }
	      } else if (keyEvent.ctrlKey && keyEvent.shiftKey && keyCode === 67) {
	        // Ctrl + Alt + c
	        $scope.copyPara('below');
	      } else if (keyEvent.ctrlKey && keyEvent.altKey && keyCode === 76) {
	        // Ctrl + Alt + l
	        $scope.clearParagraphOutput($scope.paragraph);
	      } else if (keyEvent.ctrlKey && keyEvent.altKey && keyCode === 87) {
	        // Ctrl + Alt + w
	        $scope.goToSingleParagraph();
	      } else {
	        noShortcutDefined = true;
	      }
	
	      if (!noShortcutDefined) {
	        keyEvent.preventDefault();
	      }
	    }
	  });
	
	  $scope.$on('focusParagraph', function (event, paragraphId, cursorPos, mouseEvent) {
	    if ($scope.paragraph.id === paragraphId) {
	      // focus editor
	      if (!$scope.paragraph.config.editorHide) {
	        if (!mouseEvent) {
	          $scope.editor.focus();
	          // move cursor to the first row (or the last row)
	          var row;
	          if (cursorPos >= 0) {
	            row = cursorPos;
	            $scope.editor.gotoLine(row, 0);
	          } else {
	            row = $scope.editor.session.getLength();
	            $scope.editor.gotoLine(row, 0);
	          }
	          $scope.scrollToCursor($scope.paragraph.id, 0);
	        }
	      }
	      handleFocus(true);
	    } else {
	      if ($scope.editor !== undefined && $scope.editor !== null) {
	        $scope.editor.blur();
	      }
	      var isDigestPass = true;
	      handleFocus(false, isDigestPass);
	    }
	  });
	
	  $scope.$on('saveInterpreterBindings', function (event, paragraphId) {
	    if ($scope.paragraph.id === paragraphId && $scope.editor) {
	      setInterpreterBindings = true;
	      setParagraphMode($scope.editor.getSession(), $scope.editor.getSession().getValue());
	    }
	  });
	
	  $scope.$on('doubleClickParagraph', function (event, paragraphId) {
	    if ($scope.paragraph.id === paragraphId && $scope.paragraph.config.editorHide && $scope.paragraph.config.editorSetting.editOnDblClick && $scope.revisionView !== true) {
	      var deferred = $q.defer();
	      openEditorAndCloseTable($scope.paragraph);
	      $timeout($scope.$on('updateParagraph', function (event, data) {
	        deferred.resolve(data);
	      }), 1000);
	
	      deferred.promise.then(function (data) {
	        if ($scope.editor) {
	          $scope.editor.focus();
	          $scope.goToEnd($scope.editor);
	        }
	      });
	    }
	  });
	
	  $scope.$on('openEditor', function (event) {
	    $scope.openEditor($scope.paragraph);
	  });
	
	  $scope.$on('closeEditor', function (event) {
	    $scope.closeEditor($scope.paragraph);
	  });
	
	  $scope.$on('openTable', function (event) {
	    $scope.openTable($scope.paragraph);
	  });
	
	  $scope.$on('closeTable', function (event) {
	    $scope.closeTable($scope.paragraph);
	  });
	}

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _tabledata = __webpack_require__(6);
	
	var _tabledata2 = _interopRequireDefault(_tabledata);
	
	var _visualizationTable = __webpack_require__(12);
	
	var _visualizationTable2 = _interopRequireDefault(_visualizationTable);
	
	var _visualizationBarchart = __webpack_require__(14);
	
	var _visualizationBarchart2 = _interopRequireDefault(_visualizationBarchart);
	
	var _visualizationPiechart = __webpack_require__(15);
	
	var _visualizationPiechart2 = _interopRequireDefault(_visualizationPiechart);
	
	var _visualizationAreachart = __webpack_require__(16);
	
	var _visualizationAreachart2 = _interopRequireDefault(_visualizationAreachart);
	
	var _visualizationLinechart = __webpack_require__(17);
	
	var _visualizationLinechart2 = _interopRequireDefault(_visualizationLinechart);
	
	var _visualizationScatterchart = __webpack_require__(18);
	
	var _visualizationScatterchart2 = _interopRequireDefault(_visualizationScatterchart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	angular.module('zeppelinWebApp').controller('ResultCtrl', ResultCtrl); /*
	                                                                        * Licensed under the Apache License, Version 2.0 (the "License");
	                                                                        * you may not use this file except in compliance with the License.
	                                                                        * You may obtain a copy of the License at
	                                                                        *
	                                                                        *     http://www.apache.org/licenses/LICENSE-2.0
	                                                                        *
	                                                                        * Unless required by applicable law or agreed to in writing, software
	                                                                        * distributed under the License is distributed on an "AS IS" BASIS,
	                                                                        * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	                                                                        * See the License for the specific language governing permissions and
	                                                                        * limitations under the License.
	                                                                        */
	
	ResultCtrl.$inject = ['$scope', '$rootScope', '$route', '$window', '$routeParams', '$location', '$timeout', '$compile', '$http', '$q', '$templateRequest', '$sce', 'websocketMsgSrv', 'baseUrlSrv', 'ngToast', 'saveAsService', 'noteVarShareService', 'heliumService'];
	
	function ResultCtrl($scope, $rootScope, $route, $window, $routeParams, $location, $timeout, $compile, $http, $q, $templateRequest, $sce, websocketMsgSrv, baseUrlSrv, ngToast, saveAsService, noteVarShareService, heliumService) {
	
	  /**
	   * Built-in visualizations
	   */
	  $scope.builtInTableDataVisualizationList = [{
	    id: 'table', // paragraph.config.graph.mode
	    name: 'Table', // human readable name. tooltip
	    icon: '<i class="fa fa-table"></i>'
	  }, {
	    id: 'multiBarChart',
	    name: 'Bar Chart',
	    icon: '<i class="fa fa-bar-chart"></i>',
	    transformation: 'pivot'
	  }, {
	    id: 'pieChart',
	    name: 'Pie Chart',
	    icon: '<i class="fa fa-pie-chart"></i>',
	    transformation: 'pivot'
	  }, {
	    id: 'stackedAreaChart',
	    name: 'Area Chart',
	    icon: '<i class="fa fa-area-chart"></i>',
	    transformation: 'pivot'
	  }, {
	    id: 'lineChart',
	    name: 'Line Chart',
	    icon: '<i class="fa fa-line-chart"></i>',
	    transformation: 'pivot'
	  }, {
	    id: 'scatterChart',
	    name: 'Scatter Chart',
	    icon: '<i class="cf cf-scatter-chart"></i>'
	  }];
	
	  /**
	   * Holds class and actual runtime instance and related infos of built-in visualizations
	   */
	  var builtInVisualizations = {
	    'table': {
	      class: _visualizationTable2.default,
	      instance: undefined // created from setGraphMode()
	    },
	    'multiBarChart': {
	      class: _visualizationBarchart2.default,
	      instance: undefined
	    },
	    'pieChart': {
	      class: _visualizationPiechart2.default,
	      instance: undefined
	    },
	    'stackedAreaChart': {
	      class: _visualizationAreachart2.default,
	      instance: undefined
	    },
	    'lineChart': {
	      class: _visualizationLinechart2.default,
	      instance: undefined
	    },
	    'scatterChart': {
	      class: _visualizationScatterchart2.default,
	      instance: undefined
	    }
	  };
	
	  // type
	  $scope.type;
	
	  // Data of the result
	  var data;
	
	  // config
	  $scope.config;
	
	  // resultId = paragraph.id + index
	  $scope.id;
	
	  // referece to paragraph
	  var paragraph;
	
	  // index of the result
	  var resultIndex;
	
	  // TableData instance
	  var tableData;
	
	  // available columns in tabledata
	  $scope.tableDataColumns = [];
	
	  // enable helium
	  var enableHelium = false;
	
	  // graphMode
	  $scope.graphMode;
	
	  // image data
	  $scope.imageData;
	
	  $scope.init = function (result, config, paragraph, index) {
	    console.log('result controller init %o %o %o', result, config, index);
	
	    // register helium plugin vis
	    var heliumVis = heliumService.get();
	    console.log('Helium visualizations %o', heliumVis);
	    heliumVis.forEach(function (vis) {
	      $scope.builtInTableDataVisualizationList.push({
	        id: vis.id,
	        name: vis.name,
	        icon: $sce.trustAsHtml(vis.icon)
	      });
	      builtInVisualizations[vis.id] = {
	        class: vis.class
	      };
	    });
	
	    updateData(result, config, paragraph, index);
	    renderResult($scope.type);
	  };
	
	  $scope.$on('updateResult', function (event, result, newConfig, paragraphRef, index) {
	    if (paragraph.id !== paragraphRef.id || index !== resultIndex) {
	      return;
	    }
	    console.log('updateResult %o %o %o %o', result, newConfig, paragraphRef, index);
	    var refresh = !angular.equals(newConfig, $scope.config) || !angular.equals(result.type, $scope.type) || !angular.equals(result.data, data);
	
	    updateData(result, newConfig, paragraph, resultIndex);
	    renderResult($scope.type, refresh);
	  });
	
	  $scope.$on('appendParagraphOutput', function (event, data) {
	    /* It has been observed that append events
	     * can be errorneously called even if paragraph
	     * execution has ended, and in that case, no append
	     * should be made. Also, it was observed that between PENDING
	     * and RUNNING states, append-events can be called and we can't
	     * miss those, else during the length of paragraph run, few
	     * initial output line/s will be missing.
	     */
	    if (paragraph.id === data.paragraphId && resultIndex === data.index && (paragraph.status === 'RUNNING' || paragraph.status === 'PENDING')) {
	      appendTextOutput(data.data);
	    }
	  });
	
	  $scope.$on('updateParagraphOutput', function (event, data) {
	    if (paragraph.id === data.paragraphId && resultIndex === data.index) {
	      clearTextOutput();
	      appendTextOutput(data.data);
	    }
	  });
	
	  var updateData = function updateData(result, config, paragraphRef, index) {
	    data = result.data;
	    paragraph = paragraphRef;
	    resultIndex = parseInt(index);
	
	    $scope.id = paragraph.id + '_' + index;
	    $scope.type = result.type;
	    config = config ? config : {};
	
	    // initialize default config values
	    if (!config.graph) {
	      config.graph = {};
	    }
	
	    if (!config.graph.mode) {
	      config.graph.mode = 'table';
	    }
	
	    if (!config.graph.height) {
	      config.graph.height = 300;
	    }
	
	    if (!config.graph.optionOpen) {
	      config.graph.optionOpen = false;
	    }
	
	    $scope.graphMode = config.graph.mode;
	    $scope.config = angular.copy(config);
	
	    // enable only when it is last result
	    enableHelium = index === paragraphRef.results.msg.length - 1;
	
	    if ($scope.type === 'TABLE') {
	      tableData = new _tabledata2.default();
	      tableData.loadParagraphResult({ type: $scope.type, msg: data });
	      $scope.tableDataColumns = tableData.columns;
	      $scope.tableDataComment = tableData.comment;
	    } else if ($scope.type === 'IMG') {
	      $scope.imageData = data;
	    }
	  };
	
	  var renderResult = function renderResult(type, refresh) {
	    var activeApp;
	    if (enableHelium) {
	      getSuggestions();
	      getApplicationStates();
	      activeApp = _.get($scope.config, 'helium.activeApp');
	    }
	
	    if (activeApp) {
	      var app = _.find($scope.apps, { id: activeApp });
	      renderApp(app);
	    } else {
	      if (type === 'TABLE') {
	        var retryRenderer = function retryRenderer() {
	          var elem = angular.element('#p' + $scope.id + '_graph');
	          if (elem.length) {
	            $scope.renderGraph($scope.graphMode, refresh);
	          } else {
	            $timeout(retryRenderer, 10);
	          }
	        };
	        $timeout(retryRenderer);
	      } else if (type === 'HTML') {
	        renderHtml();
	      } else if (type === 'ANGULAR') {
	        renderAngular();
	      } else if (type === 'TEXT') {
	        renderText();
	      }
	    }
	  };
	
	  var renderHtml = function renderHtml() {
	    var retryRenderer = function retryRenderer() {
	      var htmlEl = angular.element('#p' + $scope.id + '_html');
	      if (htmlEl.length) {
	        try {
	          htmlEl.html(data);
	
	          htmlEl.find('pre code').each(function (i, e) {
	            hljs.highlightBlock(e);
	          });
	          /*eslint new-cap: [2, {"capIsNewExceptions": ["MathJax.Hub.Queue"]}]*/
	          MathJax.Hub.Queue(['Typeset', MathJax.Hub, htmlEl[0]]);
	        } catch (err) {
	          console.log('HTML rendering error %o', err);
	        }
	      } else {
	        $timeout(retryRenderer, 10);
	      }
	    };
	    $timeout(retryRenderer);
	  };
	
	  var renderAngular = function renderAngular() {
	    var retryRenderer = function retryRenderer() {
	      if (angular.element('#p' + $scope.id + '_angular').length) {
	        try {
	          angular.element('#p' + $scope.id + '_angular').html(data);
	
	          var paragraphScope = noteVarShareService.get(paragraph.id + '_paragraphScope');
	          $compile(angular.element('#p' + $scope.id + '_angular').contents())(paragraphScope);
	        } catch (err) {
	          console.log('ANGULAR rendering error %o', err);
	        }
	      } else {
	        $timeout(retryRenderer, 10);
	      }
	    };
	    $timeout(retryRenderer);
	  };
	
	  var getTextEl = function getTextEl(paragraphId) {
	    return angular.element('#p' + $scope.id + '_text');
	  };
	
	  var textRendererInitialized = false;
	  var renderText = function renderText() {
	    var retryRenderer = function retryRenderer() {
	      var textEl = getTextEl($scope.id);
	      if (textEl.length) {
	        // clear all lines before render
	        clearTextOutput();
	        textRendererInitialized = true;
	
	        if (data) {
	          appendTextOutput(data);
	        } else {
	          flushAppendQueue();
	        }
	
	        getTextEl($scope.id).bind('mousewheel', function (e) {
	          $scope.keepScrollDown = false;
	        });
	      } else {
	        $timeout(retryRenderer, 10);
	      }
	    };
	    $timeout(retryRenderer);
	  };
	
	  var clearTextOutput = function clearTextOutput() {
	    var textEl = getTextEl($scope.id);
	    if (textEl.length) {
	      textEl.children().remove();
	    }
	  };
	
	  var textAppendQueueBeforeInitialize = [];
	
	  var flushAppendQueue = function flushAppendQueue() {
	    while (textAppendQueueBeforeInitialize.length > 0) {
	      appendTextOutput(textAppendQueueBeforeInitialize.pop());
	    }
	  };
	
	  var appendTextOutput = function appendTextOutput(msg) {
	    if (!textRendererInitialized) {
	      textAppendQueueBeforeInitialize.push(msg);
	    } else {
	      flushAppendQueue();
	      var textEl = getTextEl($scope.id);
	      if (textEl.length) {
	        var lines = msg.split('\n');
	        for (var i = 0; i < lines.length; i++) {
	          textEl.append(angular.element('<div></div>').text(lines[i]));
	        }
	      }
	      if ($scope.keepScrollDown) {
	        var doc = getTextEl($scope.id);
	        doc[0].scrollTop = doc[0].scrollHeight;
	      }
	    }
	  };
	
	  $scope.renderGraph = function (type, refresh) {
	    // set graph height
	    var height = $scope.config.graph.height;
	    var graphContainerEl = angular.element('#p' + $scope.id + '_graph');
	    graphContainerEl.height(height);
	
	    if (!type) {
	      type = 'table';
	    }
	
	    var builtInViz = builtInVisualizations[type];
	    if (builtInViz) {
	      // deactive previsouly active visualization
	      for (var t in builtInVisualizations) {
	        var v = builtInVisualizations[t].instance;
	
	        if (t !== type && v && v.isActive()) {
	          v.deactivate();
	          break;
	        }
	      }
	
	      if (!builtInViz.instance) {
	        // not instantiated yet
	        // render when targetEl is available
	        var retryRenderer = function retryRenderer() {
	          var targetEl = angular.element('#p' + $scope.id + '_' + type);
	          var transformationSettingTargetEl = angular.element('#trsetting' + $scope.id + '_' + type);
	          var visualizationSettingTargetEl = angular.element('#vizsetting' + $scope.id + '_' + type);
	          if (targetEl.length) {
	            try {
	              // set height
	              targetEl.height(height);
	
	              // instantiate visualization
	              var config = getVizConfig(type);
	              var Visualization = builtInViz.class;
	              builtInViz.instance = new Visualization(targetEl, config);
	
	              // inject emitter, $templateRequest
	              var emitter = function emitter(graphSetting) {
	                commitVizConfigChange(graphSetting, type);
	              };
	              builtInViz.instance._emitter = emitter;
	              builtInViz.instance._compile = $compile;
	              builtInViz.instance._createNewScope = createNewScope;
	              var transformation = builtInViz.instance.getTransformation();
	              transformation._emitter = emitter;
	              transformation._templateRequest = $templateRequest;
	              transformation._compile = $compile;
	              transformation._createNewScope = createNewScope;
	
	              // render
	              var transformed = transformation.transform(tableData);
	              transformation.renderSetting(transformationSettingTargetEl);
	              builtInViz.instance.render(transformed);
	              builtInViz.instance.renderSetting(visualizationSettingTargetEl);
	              builtInViz.instance.activate();
	              angular.element(window).resize(function () {
	                builtInViz.instance.resize();
	              });
	            } catch (err) {
	              console.error('Graph drawing error %o', err);
	            }
	          } else {
	            $timeout(retryRenderer, 10);
	          }
	        };
	        $timeout(retryRenderer);
	      } else if (refresh) {
	        console.log('Refresh data %o', tableData);
	        // when graph options or data are changed
	        var retryRenderer = function retryRenderer() {
	          var targetEl = angular.element('#p' + $scope.id + '_' + type);
	          var transformationSettingTargetEl = angular.element('#trsetting' + $scope.id + '_' + type);
	          var visualizationSettingTargetEl = angular.element('#trsetting' + $scope.id + '_' + type);
	          if (targetEl.length) {
	            var config = getVizConfig(type);
	            targetEl.height(height);
	            var transformation = builtInViz.instance.getTransformation();
	            transformation.setConfig(config);
	            var transformed = transformation.transform(tableData);
	            transformation.renderSetting(transformationSettingTargetEl);
	            builtInViz.instance.setConfig(config);
	            builtInViz.instance.render(transformed);
	            builtInViz.instance.renderSetting(visualizationSettingTargetEl);
	          } else {
	            $timeout(retryRenderer, 10);
	          }
	        };
	        $timeout(retryRenderer);
	      } else {
	        var retryRenderer = function retryRenderer() {
	          var targetEl = angular.element('#p' + $scope.id + '_' + type);
	          if (targetEl.length) {
	            targetEl.height(height);
	            builtInViz.instance.activate();
	          } else {
	            $timeout(retryRenderer, 10);
	          }
	        };
	        $timeout(retryRenderer);
	      }
	    }
	  };
	  $scope.switchViz = function (newMode) {
	    var newConfig = angular.copy($scope.config);
	    var newParams = angular.copy(paragraph.settings.params);
	
	    // graph options
	    newConfig.graph.mode = newMode;
	
	    // see switchApp()
	    _.set(newConfig, 'helium.activeApp', undefined);
	
	    commitParagraphResult(paragraph.title, paragraph.text, newConfig, newParams);
	  };
	
	  var createNewScope = function createNewScope() {
	    return $rootScope.$new(true);
	  };
	
	  var commitParagraphResult = function commitParagraphResult(title, text, config, params) {
	    var newParagraphConfig = angular.copy(paragraph.config);
	    newParagraphConfig.results = newParagraphConfig.results || [];
	    newParagraphConfig.results[resultIndex] = config;
	    if ($scope.revisionView === true) {
	      // local update without commit
	      updateData({
	        type: $scope.type,
	        data: data
	      }, newParagraphConfig.results[resultIndex], paragraph, resultIndex);
	      renderResult($scope.type, true);
	    } else {
	      websocketMsgSrv.commitParagraph(paragraph.id, title, text, newParagraphConfig, params);
	    }
	  };
	
	  $scope.toggleGraphSetting = function () {
	    var newConfig = angular.copy($scope.config);
	    if (newConfig.graph.optionOpen) {
	      newConfig.graph.optionOpen = false;
	    } else {
	      newConfig.graph.optionOpen = true;
	    }
	    var newParams = angular.copy(paragraph.settings.params);
	
	    commitParagraphResult(paragraph.title, paragraph.text, newConfig, newParams);
	  };
	
	  var getVizConfig = function getVizConfig(vizId) {
	    var config;
	    var graph = $scope.config.graph;
	    if (graph) {
	      // copy setting for vizId
	      if (graph.setting) {
	        config = angular.copy(graph.setting[vizId]);
	      }
	
	      if (!config) {
	        config = {};
	      }
	
	      // copy common setting
	      config.common = angular.copy(graph.commonSetting) || {};
	
	      // copy pivot setting
	      if (graph.keys) {
	        config.common.pivot = {
	          keys: angular.copy(graph.keys),
	          groups: angular.copy(graph.groups),
	          values: angular.copy(graph.values)
	        };
	      }
	    }
	    console.log('getVizConfig', config);
	    return config;
	  };
	
	  var commitVizConfigChange = function commitVizConfigChange(config, vizId) {
	    var newConfig = angular.copy($scope.config);
	    if (!newConfig.graph) {
	      newConfig.graph = {};
	    }
	
	    // copy setting for vizId
	    if (!newConfig.graph.setting) {
	      newConfig.graph.setting = {};
	    }
	    newConfig.graph.setting[vizId] = angular.copy(config);
	
	    // copy common setting
	    if (newConfig.graph.setting[vizId]) {
	      newConfig.graph.commonSetting = newConfig.graph.setting[vizId].common;
	      delete newConfig.graph.setting[vizId].common;
	    }
	
	    // copy pivot setting
	    if (newConfig.graph.commonSetting && newConfig.graph.commonSetting.pivot) {
	      newConfig.graph.keys = newConfig.graph.commonSetting.pivot.keys;
	      newConfig.graph.groups = newConfig.graph.commonSetting.pivot.groups;
	      newConfig.graph.values = newConfig.graph.commonSetting.pivot.values;
	      delete newConfig.graph.commonSetting.pivot;
	    }
	    console.log('committVizConfig', newConfig);
	    var newParams = angular.copy(paragraph.settings.params);
	    commitParagraphResult(paragraph.title, paragraph.text, newConfig, newParams);
	  };
	
	  $scope.$on('paragraphResized', function (event, paragraphId) {
	    // paragraph col width changed
	    if (paragraphId === paragraph.id) {
	      var builtInViz = builtInVisualizations[$scope.graphMode];
	      if (builtInViz && builtInViz.instance) {
	        builtInViz.instance.resize();
	      }
	    }
	  });
	
	  $scope.resize = function (width, height) {
	    $timeout(function () {
	      changeHeight(width, height);
	    }, 200);
	  };
	
	  var changeHeight = function changeHeight(width, height) {
	    var newParams = angular.copy(paragraph.settings.params);
	    var newConfig = angular.copy($scope.config);
	
	    newConfig.graph.height = height;
	    paragraph.config.colWidth = width;
	
	    commitParagraphResult(paragraph.title, paragraph.text, newConfig, newParams);
	  };
	
	  $scope.exportToDSV = function (delimiter) {
	    var dsv = '';
	    var dateFinished = moment(paragraph.dateFinished).format('YYYY-MM-DD hh:mm:ss A');
	    var exportedFileName = paragraph.title ? paragraph.title + '_' + dateFinished : 'data_' + dateFinished;
	
	    for (var titleIndex in tableData.columns) {
	      dsv += tableData.columns[titleIndex].name + delimiter;
	    }
	    dsv = dsv.substring(0, dsv.length - 1) + '\n';
	    for (var r in tableData.rows) {
	      var row = tableData.rows[r];
	      var dsvRow = '';
	      for (var index in row) {
	        var stringValue = row[index].toString();
	        if (stringValue.indexOf(delimiter) > -1) {
	          dsvRow += '"' + stringValue + '"' + delimiter;
	        } else {
	          dsvRow += row[index] + delimiter;
	        }
	      }
	      dsv += dsvRow.substring(0, dsvRow.length - 1) + '\n';
	    }
	    var extension = '';
	    if (delimiter === '\t') {
	      extension = 'tsv';
	    } else if (delimiter === ',') {
	      extension = 'csv';
	    }
	    saveAsService.saveAs(dsv, exportedFileName, extension);
	  };
	
	  $scope.getBase64ImageSrc = function (base64Data) {
	    return 'data:image/png;base64,' + base64Data;
	  };
	
	  // Helium ----------------
	  var ANGULAR_FUNCTION_OBJECT_NAME_PREFIX = '_Z_ANGULAR_FUNC_';
	
	  // app states
	  $scope.apps = [];
	
	  // suggested apps
	  $scope.suggestion = {};
	
	  $scope.switchApp = function (appId) {
	    var newConfig = angular.copy($scope.config);
	    var newParams = angular.copy(paragraph.settings.params);
	
	    // 'helium.activeApp' can be cleared by switchViz()
	    _.set(newConfig, 'helium.activeApp', appId);
	
	    commitConfig(newConfig, newParams);
	  };
	
	  $scope.loadApp = function (heliumPackage) {
	    var noteId = $route.current.pathParams.noteId;
	    $http.post(baseUrlSrv.getRestApiBase() + '/helium/load/' + noteId + '/' + paragraph.id, heliumPackage).success(function (data, status, headers, config) {
	      console.log('Load app %o', data);
	    }).error(function (err, status, headers, config) {
	      console.log('Error %o', err);
	    });
	  };
	
	  var commitConfig = function commitConfig(config, params) {
	    commitParagraphResult(paragraph.title, paragraph.text, config, params);
	  };
	
	  var getApplicationStates = function getApplicationStates() {
	    var appStates = [];
	
	    // Display ApplicationState
	    if (paragraph.apps) {
	      _.forEach(paragraph.apps, function (app) {
	        appStates.push({
	          id: app.id,
	          pkg: app.pkg,
	          status: app.status,
	          output: app.output
	        });
	      });
	    }
	
	    // update or remove app states no longer exists
	    _.forEach($scope.apps, function (currentAppState, idx) {
	      var newAppState = _.find(appStates, { id: currentAppState.id });
	      if (newAppState) {
	        angular.extend($scope.apps[idx], newAppState);
	      } else {
	        $scope.apps.splice(idx, 1);
	      }
	    });
	
	    // add new app states
	    _.forEach(appStates, function (app, idx) {
	      if ($scope.apps.length <= idx || $scope.apps[idx].id !== app.id) {
	        $scope.apps.splice(idx, 0, app);
	      }
	    });
	  };
	
	  var getSuggestions = function getSuggestions() {
	    // Get suggested apps
	    var noteId = $route.current.pathParams.noteId;
	    if (!noteId) {
	      return;
	    }
	    $http.get(baseUrlSrv.getRestApiBase() + '/helium/suggest/' + noteId + '/' + paragraph.id).success(function (data, status, headers, config) {
	      $scope.suggestion = data.body;
	    }).error(function (err, status, headers, config) {
	      console.log('Error %o', err);
	    });
	  };
	
	  var renderApp = function renderApp(appState) {
	    var retryRenderer = function retryRenderer() {
	      var targetEl = angular.element(document.getElementById('p' + appState.id));
	      console.log('retry renderApp %o', targetEl);
	      if (targetEl.length) {
	        try {
	          console.log('renderApp %o', appState);
	          targetEl.html(appState.output);
	          $compile(targetEl.contents())(getAppScope(appState));
	        } catch (err) {
	          console.log('App rendering error %o', err);
	        }
	      } else {
	        $timeout(retryRenderer, 1000);
	      }
	    };
	    $timeout(retryRenderer);
	  };
	
	  /*
	   ** $scope.$on functions below
	   */
	  $scope.$on('appendAppOutput', function (event, data) {
	    if (paragraph.id === data.paragraphId) {
	      var app = _.find($scope.apps, { id: data.appId });
	      if (app) {
	        app.output += data.data;
	
	        var paragraphAppState = _.find(paragraph.apps, { id: data.appId });
	        paragraphAppState.output = app.output;
	
	        var targetEl = angular.element(document.getElementById('p' + app.id));
	        targetEl.html(app.output);
	        $compile(targetEl.contents())(getAppScope(app));
	        console.log('append app output %o', $scope.apps);
	      }
	    }
	  });
	
	  $scope.$on('updateAppOutput', function (event, data) {
	    if (paragraph.id === data.paragraphId) {
	      var app = _.find($scope.apps, { id: data.appId });
	      if (app) {
	        app.output = data.data;
	
	        var paragraphAppState = _.find(paragraph.apps, { id: data.appId });
	        paragraphAppState.output = app.output;
	
	        var targetEl = angular.element(document.getElementById('p' + app.id));
	        targetEl.html(app.output);
	        $compile(targetEl.contents())(getAppScope(app));
	        console.log('append app output');
	      }
	    }
	  });
	
	  $scope.$on('appLoad', function (event, data) {
	    if (paragraph.id === data.paragraphId) {
	      var app = _.find($scope.apps, { id: data.appId });
	      if (!app) {
	        app = {
	          id: data.appId,
	          pkg: data.pkg,
	          status: 'UNLOADED',
	          output: ''
	        };
	
	        $scope.apps.push(app);
	        paragraph.apps.push(app);
	        $scope.switchApp(app.id);
	      }
	    }
	  });
	
	  $scope.$on('appStatusChange', function (event, data) {
	    if (paragraph.id === data.paragraphId) {
	      var app = _.find($scope.apps, { id: data.appId });
	      if (app) {
	        app.status = data.status;
	        var paragraphAppState = _.find(paragraph.apps, { id: data.appId });
	        paragraphAppState.status = app.status;
	      }
	    }
	  });
	
	  var getAppRegistry = function getAppRegistry(appState) {
	    if (!appState.registry) {
	      appState.registry = {};
	    }
	
	    return appState.registry;
	  };
	
	  var getAppScope = function getAppScope(appState) {
	    if (!appState.scope) {
	      appState.scope = $rootScope.$new(true, $rootScope);
	    }
	    return appState.scope;
	  };
	
	  $scope.$on('angularObjectUpdate', function (event, data) {
	    var noteId = $route.current.pathParams.noteId;
	    if (!data.noteId || data.noteId === noteId) {
	      var scope;
	      var registry;
	
	      var app = _.find($scope.apps, { id: data.paragraphId });
	      if (app) {
	        scope = getAppScope(app);
	        registry = getAppRegistry(app);
	      } else {
	        // no matching app in this paragraph
	        return;
	      }
	
	      var varName = data.angularObject.name;
	
	      if (angular.equals(data.angularObject.object, scope[varName])) {
	        // return when update has no change
	        return;
	      }
	
	      if (!registry[varName]) {
	        registry[varName] = {
	          interpreterGroupId: data.interpreterGroupId,
	          noteId: data.noteId,
	          paragraphId: data.paragraphId
	        };
	      } else {
	        registry[varName].noteId = registry[varName].noteId || data.noteId;
	        registry[varName].paragraphId = registry[varName].paragraphId || data.paragraphId;
	      }
	
	      registry[varName].skipEmit = true;
	
	      if (!registry[varName].clearWatcher) {
	        registry[varName].clearWatcher = scope.$watch(varName, function (newValue, oldValue) {
	          console.log('angular object (paragraph) updated %o %o', varName, registry[varName]);
	          if (registry[varName].skipEmit) {
	            registry[varName].skipEmit = false;
	            return;
	          }
	          websocketMsgSrv.updateAngularObject(registry[varName].noteId, registry[varName].paragraphId, varName, newValue, registry[varName].interpreterGroupId);
	        });
	      }
	      console.log('angular object (paragraph) created %o', varName);
	      scope[varName] = data.angularObject.object;
	
	      // create proxy for AngularFunction
	      if (varName.indexOf(ANGULAR_FUNCTION_OBJECT_NAME_PREFIX) === 0) {
	        var funcName = varName.substring(ANGULAR_FUNCTION_OBJECT_NAME_PREFIX.length);
	        scope[funcName] = function () {
	          scope[varName] = arguments;
	          console.log('angular function (paragraph) invoked %o', arguments);
	        };
	
	        console.log('angular function (paragraph) created %o', scope[funcName]);
	      }
	    }
	  });
	
	  $scope.$on('angularObjectRemove', function (event, data) {
	    var noteId = $route.current.pathParams.noteId;
	    if (!data.noteId || data.noteId === noteId) {
	      var scope;
	      var registry;
	
	      var app = _.find($scope.apps, { id: data.paragraphId });
	      if (app) {
	        scope = getAppScope(app);
	        registry = getAppRegistry(app);
	      } else {
	        // no matching app in this paragraph
	        return;
	      }
	
	      var varName = data.name;
	
	      // clear watcher
	      if (registry[varName]) {
	        registry[varName].clearWatcher();
	        registry[varName] = undefined;
	      }
	
	      // remove scope variable
	      scope[varName] = undefined;
	
	      // remove proxy for AngularFunction
	      if (varName.indexOf(ANGULAR_FUNCTION_OBJECT_NAME_PREFIX) === 0) {
	        var funcName = varName.substring(ANGULAR_FUNCTION_OBJECT_NAME_PREFIX.length);
	        scope[funcName] = undefined;
	      }
	    }
	  });
	};

/***/ },
/* 28 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the 'License');
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an 'AS IS' BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').controller('SearchResultCtrl', SearchResultCtrl);
	
	SearchResultCtrl.$inject = ['$scope', '$routeParams', 'searchService'];
	
	function SearchResultCtrl($scope, $routeParams, searchService) {
	  $scope.isResult = true;
	  $scope.searchTerm = $routeParams.searchTerm;
	  var results = searchService.search({ 'q': $routeParams.searchTerm }).query();
	
	  results.$promise.then(function (result) {
	    $scope.notes = result.body.map(function (note) {
	      // redirect to notebook when search result is a notebook itself,
	      // not a paragraph
	      if (!/\/paragraph\//.test(note.id)) {
	        return note;
	      }
	
	      note.id = note.id.replace('paragraph/', '?paragraph=') + '&term=' + $routeParams.searchTerm;
	
	      return note;
	    });
	    if ($scope.notes.length === 0) {
	      $scope.isResult = false;
	    } else {
	      $scope.isResult = true;
	    }
	
	    $scope.$on('$routeChangeStart', function (event, next, current) {
	      if (next.originalPath !== '/search/:searchTerm') {
	        searchService.searchTerm = '';
	      }
	    });
	  });
	
	  $scope.page = 0;
	  $scope.allResults = false;
	
	  $scope.highlightSearchResults = function (note) {
	    return function (_editor) {
	      function getEditorMode(text) {
	        var editorModes = {
	          'ace/mode/scala': /^%(\w*\.)?spark/,
	          'ace/mode/python': /^%(\w*\.)?(pyspark|python)/,
	          'ace/mode/r': /^%(\w*\.)?(r|sparkr|knitr)/,
	          'ace/mode/sql': /^%(\w*\.)?\wql/,
	          'ace/mode/markdown': /^%md/,
	          'ace/mode/sh': /^%sh/
	        };
	
	        return Object.keys(editorModes).reduce(function (res, mode) {
	          return editorModes[mode].test(text) ? mode : res;
	        }, 'ace/mode/scala');
	      }
	
	      var Range = ace.require('ace/range').Range;
	
	      _editor.setOption('highlightActiveLine', false);
	      _editor.$blockScrolling = Infinity;
	      _editor.setReadOnly(true);
	      _editor.renderer.setShowGutter(false);
	      _editor.setTheme('ace/theme/chrome');
	      _editor.getSession().setMode(getEditorMode(note.text));
	
	      function getIndeces(term) {
	        return function (str) {
	          var indeces = [];
	          var i = -1;
	          while ((i = str.indexOf(term, i + 1)) >= 0) {
	            indeces.push(i);
	          }
	          return indeces;
	        };
	      }
	
	      var result = '';
	      if (note.header !== '') {
	        result = note.header + '\n\n' + note.snippet;
	      } else {
	        result = note.snippet;
	      }
	
	      var lines = result.split('\n').map(function (line, row) {
	
	        var match = line.match(/<B>(.+?)<\/B>/);
	
	        // return early if nothing to highlight
	        if (!match) {
	          return line;
	        }
	
	        var term = match[1];
	        var __line = line.replace(/<B>/g, '').replace(/<\/B>/g, '');
	
	        var indeces = getIndeces(term)(__line);
	
	        indeces.forEach(function (start) {
	          var end = start + term.length;
	          if (note.header !== '' && row === 0) {
	            _editor.getSession().addMarker(new Range(row, 0, row, line.length), 'search-results-highlight-header', 'background');
	            _editor.getSession().addMarker(new Range(row, start, row, end), 'search-results-highlight', 'line');
	          } else {
	            _editor.getSession().addMarker(new Range(row, start, row, end), 'search-results-highlight', 'line');
	          }
	        });
	        return __line;
	      });
	
	      // resize editor based on content length
	      _editor.setOption('maxLines', lines.reduce(function (len, line) {
	        return len + line.length;
	      }, 0));
	
	      _editor.getSession().setValue(lines.join('\n'));
	    };
	  };
	}

/***/ },
/* 29 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').controller('NotebookReposCtrl', NotebookReposCtrl);
	
	NotebookReposCtrl.$inject = ['$http', 'baseUrlSrv', 'ngToast'];
	
	function NotebookReposCtrl($http, baseUrlSrv, ngToast) {
	  var vm = this;
	  vm.notebookRepos = [];
	  vm.showDropdownSelected = showDropdownSelected;
	  vm.saveNotebookRepo = saveNotebookRepo;
	
	  _init();
	
	  // Public functions
	
	  function saveNotebookRepo(valueform, repo, data) {
	    console.log('data %o', data);
	    $http.put(baseUrlSrv.getRestApiBase() + '/notebook-repositories', {
	      'name': repo.className,
	      'settings': data
	    }).success(function (data) {
	      var index = _.findIndex(vm.notebookRepos, { 'className': repo.className });
	      if (index >= 0) {
	        vm.notebookRepos[index] = data.body;
	        console.log('repos %o, data %o', vm.notebookRepos, data.body);
	      }
	      valueform.$show();
	    }).error(function () {
	      ngToast.danger({
	        content: 'We couldn\'t save that NotebookRepo\'s settings',
	        verticalPosition: 'bottom',
	        timeout: '3000'
	      });
	      valueform.$show();
	    });
	
	    return 'manual';
	  }
	
	  function showDropdownSelected(setting) {
	    var index = _.findIndex(setting.value, { 'value': setting.selected });
	    if (index < 0) {
	      return 'No value';
	    } else {
	      return setting.value[index].name;
	    }
	  }
	
	  // Private functions
	
	  function _getInterpreterSettings() {
	    $http.get(baseUrlSrv.getRestApiBase() + '/notebook-repositories').success(function (data, status, headers, config) {
	      vm.notebookRepos = data.body;
	      console.log('ya notebookRepos %o', vm.notebookRepos);
	    }).error(function (data, status, headers, config) {
	      if (status === 401) {
	        ngToast.danger({
	          content: 'You don\'t have permission on this page',
	          verticalPosition: 'bottom',
	          timeout: '3000'
	        });
	        setTimeout(function () {
	          window.location.replace('/');
	        }, 3000);
	      }
	      console.log('Error %o %o', status, data.message);
	    });
	  }
	
	  function _init() {
	    _getInterpreterSettings();
	  };
	}

/***/ },
/* 30 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	(function () {
	
	  angular.module('zeppelinWebApp').controller('HeliumCtrl', HeliumCtrl);
	
	  HeliumCtrl.$inject = ['$scope', '$rootScope', '$sce', 'baseUrlSrv', 'ngToast', 'heliumService'];
	
	  function HeliumCtrl($scope, $rootScope, $sce, baseUrlSrv, ngToast, heliumService) {
	    $scope.packageInfos = {};
	    $scope.defaultVersions = {};
	    $scope.showVersions = {};
	    $scope.visualizationOrder = [];
	    $scope.visualizationOrderChanged = false;
	
	    var buildDefaultVersionListToDisplay = function buildDefaultVersionListToDisplay(packageInfos) {
	      var defaultVersions = {};
	      // show enabled version if any version of package is enabled
	      for (var name in packageInfos) {
	        var pkgs = packageInfos[name];
	        for (var pkgIdx in pkgs) {
	          var pkg = pkgs[pkgIdx];
	          pkg.pkg.icon = $sce.trustAsHtml(pkg.pkg.icon);
	          if (pkg.enabled) {
	            defaultVersions[name] = pkg;
	            pkgs.splice(pkgIdx, 1);
	            break;
	          }
	        }
	
	        // show first available version if package is not enabled
	        if (!defaultVersions[name]) {
	          defaultVersions[name] = pkgs[0];
	          pkgs.splice(0, 1);
	        }
	      }
	      $scope.defaultVersions = defaultVersions;
	    };
	
	    var getAllPackageInfo = function getAllPackageInfo() {
	      heliumService.getAllPackageInfo().success(function (data, status) {
	        $scope.packageInfos = data.body;
	        buildDefaultVersionListToDisplay($scope.packageInfos);
	      }).error(function (data, status) {
	        console.log('Can not load package info %o %o', status, data);
	      });
	    };
	
	    var getVisualizationOrder = function getVisualizationOrder() {
	      heliumService.getVisualizationOrder().success(function (data, status) {
	        $scope.visualizationOrder = data.body;
	      }).error(function (data, status) {
	        console.log('Can not get visualization order %o %o', status, data);
	      });
	    };
	
	    $scope.visualizationOrderListeners = {
	      accept: function accept(sourceItemHandleScope, destSortableScope) {
	        return true;
	      },
	      itemMoved: function itemMoved(event) {},
	      orderChanged: function orderChanged(event) {
	        $scope.visualizationOrderChanged = true;
	      }
	    };
	
	    var init = function init() {
	      getAllPackageInfo();
	      getVisualizationOrder();
	      $scope.visualizationOrderChanged = false;
	    };
	
	    init();
	
	    $scope.saveVisualizationOrder = function () {
	      var confirm = BootstrapDialog.confirm({
	        closable: false,
	        closeByBackdrop: false,
	        closeByKeyboard: false,
	        title: '',
	        message: 'Save changes?',
	        callback: function callback(result) {
	          if (result) {
	            confirm.$modalFooter.find('button').addClass('disabled');
	            confirm.$modalFooter.find('button:contains("OK")').html('<i class="fa fa-circle-o-notch fa-spin"></i> Enabling');
	            heliumService.setVisualizationOrder($scope.visualizationOrder).success(function (data, status) {
	              init();
	              confirm.close();
	            }).error(function (data, status) {
	              confirm.close();
	              console.log('Failed to save order');
	              BootstrapDialog.show({
	                title: 'Error on saving order ',
	                message: data.message
	              });
	            });
	            return false;
	          }
	        }
	      });
	    };
	
	    var getLicense = function getLicense(name, artifact) {
	      var pkg = _.filter($scope.defaultVersions[name], function (p) {
	        return p.artifact === artifact;
	      });
	
	      var license;
	      if (pkg.length === 0) {
	        pkg = _.filter($scope.packageInfos[name], function (p) {
	          return p.pkg.artifact === artifact;
	        });
	
	        if (pkg.length > 0) {
	          license = pkg[0].pkg.license;
	        }
	      } else {
	        license = pkg[0].license;
	      }
	
	      if (!license) {
	        license = 'Unknown';
	      }
	      return license;
	    };
	
	    $scope.enable = function (name, artifact) {
	      var license = getLicense(name, artifact);
	
	      var confirm = BootstrapDialog.confirm({
	        closable: false,
	        closeByBackdrop: false,
	        closeByKeyboard: false,
	        title: '',
	        message: 'Do you want to enable ' + name + '?' + '<div style="color:gray">' + artifact + '</div>' + '<div style="border-top: 1px solid #efefef; margin-top: 10px; padding-top: 5px;">License</div>' + '<div style="color:gray">' + license + '</div>',
	        callback: function callback(result) {
	          if (result) {
	            confirm.$modalFooter.find('button').addClass('disabled');
	            confirm.$modalFooter.find('button:contains("OK")').html('<i class="fa fa-circle-o-notch fa-spin"></i> Enabling');
	            heliumService.enable(name, artifact).success(function (data, status) {
	              init();
	              confirm.close();
	            }).error(function (data, status) {
	              confirm.close();
	              console.log('Failed to enable package %o %o. %o', name, artifact, data);
	              BootstrapDialog.show({
	                title: 'Error on enabling ' + name,
	                message: data.message
	              });
	            });
	            return false;
	          }
	        }
	      });
	    };
	
	    $scope.disable = function (name) {
	      var confirm = BootstrapDialog.confirm({
	        closable: false,
	        closeByBackdrop: false,
	        closeByKeyboard: false,
	        title: '',
	        message: 'Do you want to disable ' + name + '?',
	        callback: function callback(result) {
	          if (result) {
	            confirm.$modalFooter.find('button').addClass('disabled');
	            confirm.$modalFooter.find('button:contains("OK")').html('<i class="fa fa-circle-o-notch fa-spin"></i> Disabling');
	            heliumService.disable(name).success(function (data, status) {
	              init();
	              confirm.close();
	            }).error(function (data, status) {
	              confirm.close();
	              console.log('Failed to disable package %o. %o', name, data);
	              BootstrapDialog.show({
	                title: 'Error on disabling ' + name,
	                message: data.message
	              });
	            });
	            return false;
	          }
	        }
	      });
	    };
	
	    $scope.toggleVersions = function (pkgName) {
	      if ($scope.showVersions[pkgName]) {
	        $scope.showVersions[pkgName] = false;
	      } else {
	        $scope.showVersions[pkgName] = true;
	      }
	    };
	  }
	})();

/***/ },
/* 31 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').service('arrayOrderingSrv', arrayOrderingSrv);
	
	arrayOrderingSrv.$inject = ['TRASH_FOLDER_ID'];
	
	function arrayOrderingSrv(TRASH_FOLDER_ID) {
	  var arrayOrderingSrv = this;
	
	  this.noteListOrdering = function (note) {
	    if (note.id === TRASH_FOLDER_ID) {
	      return '\uFFFF';
	    }
	    return arrayOrderingSrv.getNoteName(note);
	  };
	
	  this.getNoteName = function (note) {
	    if (note.name === undefined || note.name.trim() === '') {
	      return 'Note ' + note.id;
	    } else {
	      return note.name;
	    }
	  };
	}

/***/ },
/* 32 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	angular.module('zeppelinWebApp').controller('clipboardCtrl', clipboardCtrl);
	clipboardCtrl.$inject = ['$scope'];
	
	function clipboardCtrl($scope) {
	  $scope.complete = function (e) {
	    $scope.copied = true;
	    $scope.tooltip = 'Copied!';
	    setTimeout(function () {
	      $scope.tooltip = 'Copy to clipboard';
	    }, 400);
	  };
	  $scope.$watch('input', function () {
	    $scope.copied = false;
	    $scope.tooltip = 'Copy to clipboard';
	  });
	  $scope.clipError = function (e) {
	    console.log('Error: ' + e.name + ' - ' + e.message);
	    $scope.tooltip = 'Not supported browser';
	  };
	}

/***/ },
/* 33 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').controller('NavCtrl', NavCtrl);
	
	NavCtrl.$inject = ['$scope', '$rootScope', '$http', '$routeParams', '$location', 'noteListDataFactory', 'baseUrlSrv', 'websocketMsgSrv', 'arrayOrderingSrv', 'searchService', 'TRASH_FOLDER_ID'];
	
	function NavCtrl($scope, $rootScope, $http, $routeParams, $location, noteListDataFactory, baseUrlSrv, websocketMsgSrv, arrayOrderingSrv, searchService, TRASH_FOLDER_ID) {
	  var vm = this;
	  vm.arrayOrderingSrv = arrayOrderingSrv;
	  vm.connected = websocketMsgSrv.isConnected();
	  vm.isActive = isActive;
	  vm.logout = logout;
	  vm.notes = noteListDataFactory;
	  vm.search = search;
	  vm.searchForm = searchService;
	  vm.showLoginWindow = showLoginWindow;
	  vm.TRASH_FOLDER_ID = TRASH_FOLDER_ID;
	  vm.isFilterNote = isFilterNote;
	
	  $scope.query = { q: '' };
	
	  initController();
	
	  function getZeppelinVersion() {
	    $http.get(baseUrlSrv.getRestApiBase() + '/version').success(function (data, status, headers, config) {
	      $rootScope.zeppelinVersion = data.body;
	    }).error(function (data, status, headers, config) {
	      console.log('Error %o %o', status, data.message);
	    });
	  }
	
	  function initController() {
	    $scope.isDrawNavbarNoteList = false;
	    angular.element('#notebook-list').perfectScrollbar({ suppressScrollX: true });
	
	    angular.element(document).click(function () {
	      $scope.query.q = '';
	    });
	
	    getZeppelinVersion();
	    loadNotes();
	  }
	
	  function isFilterNote(note) {
	    if (!$scope.query.q) {
	      return true;
	    }
	
	    var noteName = note.name;
	    if (noteName.toLowerCase().indexOf($scope.query.q.toLowerCase()) > -1) {
	      return true;
	    }
	    return false;
	  }
	
	  function isActive(noteId) {
	    return $routeParams.noteId === noteId;
	  }
	
	  function listConfigurations() {
	    websocketMsgSrv.listConfigurations();
	  }
	
	  function loadNotes() {
	    websocketMsgSrv.getNoteList();
	  }
	
	  function getHomeNote() {
	    websocketMsgSrv.getHomeNote();
	  }
	
	  function logout() {
	    var logoutURL = baseUrlSrv.getRestApiBase() + '/login/logout';
	
	    //for firefox and safari
	    logoutURL = logoutURL.replace('//', '//false:false@');
	    $http.post(logoutURL).error(function () {
	      //force authcBasic (if configured) to logout
	      $http.post(logoutURL).error(function () {
	        $rootScope.userName = '';
	        $rootScope.ticket.principal = '';
	        $rootScope.ticket.ticket = '';
	        $rootScope.ticket.roles = '';
	        BootstrapDialog.show({
	          message: 'Logout Success'
	        });
	        setTimeout(function () {
	          window.location.replace('/');
	        }, 1000);
	      });
	    });
	  }
	
	  function search(searchTerm) {
	    $location.path('/search/' + searchTerm);
	  }
	
	  function showLoginWindow() {
	    setTimeout(function () {
	      angular.element('#userName').focus();
	    }, 500);
	  }
	
	  /*
	   ** $scope.$on functions below
	   */
	
	  $scope.$on('setNoteMenu', function (event, notes) {
	    noteListDataFactory.setNotes(notes);
	    initNotebookListEventListener();
	  });
	
	  $scope.$on('setConnectedStatus', function (event, param) {
	    vm.connected = param;
	  });
	
	  $scope.$on('loginSuccess', function (event, param) {
	    listConfigurations();
	    loadNotes();
	    getHomeNote();
	  });
	
	  /*
	   ** Performance optimization for Browser Render.
	   */
	  function initNotebookListEventListener() {
	    angular.element(document).ready(function () {
	      angular.element('.notebook-list-dropdown').on('show.bs.dropdown', function () {
	        $scope.isDrawNavbarNoteList = true;
	      });
	
	      angular.element('.notebook-list-dropdown').on('hide.bs.dropdown', function () {
	        $scope.isDrawNavbarNoteList = false;
	      });
	    });
	  }
	}

/***/ },
/* 34 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').directive('ngEscape', ngEscape);
	
	function ngEscape() {
	  return function (scope, element, attrs) {
	    element.bind('keydown keyup', function (event) {
	      if (event.which === 27) {
	        scope.$apply(function () {
	          scope.$eval(attrs.ngEscape);
	        });
	        event.preventDefault();
	      }
	    });
	  };
	}

/***/ },
/* 35 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').directive('interpreterDirective', interpreterDirective);
	
	interpreterDirective.$inject = ['$timeout'];
	
	function interpreterDirective($timeout) {
	  return {
	    restrict: 'A',
	    link: function link(scope, element, attr) {
	      if (scope.$last === true) {
	        $timeout(function () {
	          var id = 'ngRenderFinished';
	          scope.$emit(id);
	        });
	      }
	    }
	  };
	}

/***/ },
/* 36 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').directive('expandCollapse', expandCollapse);
	
	function expandCollapse() {
	  return {
	    restrict: 'EA',
	    link: function link(scope, element, attrs) {
	      angular.element(element).click(function (event) {
	        if (angular.element(element).find('.expandable:visible').length > 1) {
	          angular.element(element).find('.expandable:visible').slideUp('slow');
	          angular.element(element).find('i.icon-folder-alt').toggleClass('icon-folder icon-folder-alt');
	        } else {
	          angular.element(element).find('.expandable').first().slideToggle('200', function () {
	            // do not toggle trash folder
	            if (angular.element(element).find('.fa-trash-o').length === 0) {
	              angular.element(element).find('i').first().toggleClass('icon-folder icon-folder-alt');
	            }
	          });
	        }
	        event.stopPropagation();
	      });
	    }
	  };
	}

/***/ },
/* 37 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').controller('NotenameCtrl', NotenameCtrl);
	
	NotenameCtrl.$inject = ['$scope', 'noteListDataFactory', '$routeParams', 'websocketMsgSrv'];
	
	function NotenameCtrl($scope, noteListDataFactory, $routeParams, websocketMsgSrv) {
	  var vm = this;
	  vm.clone = false;
	  vm.notes = noteListDataFactory;
	  vm.websocketMsgSrv = websocketMsgSrv;
	  $scope.note = {};
	  $scope.interpreterSettings = {};
	  $scope.note.defaultInterpreter = null;
	
	  vm.createNote = function () {
	    if (!vm.clone) {
	      var defaultInterpreterId = '';
	      if ($scope.note.defaultInterpreter !== null) {
	        defaultInterpreterId = $scope.note.defaultInterpreter.id;
	      }
	      vm.websocketMsgSrv.createNotebook($scope.note.notename, defaultInterpreterId);
	      $scope.note.defaultInterpreter = $scope.interpreterSettings[0];
	    } else {
	      var noteId = $routeParams.noteId;
	      vm.websocketMsgSrv.cloneNote(noteId, $scope.note.notename);
	    }
	  };
	
	  vm.handleNameEnter = function () {
	    angular.element('#noteNameModal').modal('toggle');
	    vm.createNote();
	  };
	
	  vm.preVisible = function (clone, sourceNoteName) {
	    vm.clone = clone;
	    vm.sourceNoteName = sourceNoteName;
	    $scope.note.notename = vm.clone ? vm.cloneNoteName() : vm.newNoteName();
	    $scope.$apply();
	  };
	
	  vm.newNoteName = function () {
	    var newCount = 1;
	    angular.forEach(vm.notes.flatList, function (noteName) {
	      noteName = noteName.name;
	      if (noteName.match(/^Untitled Note [0-9]*$/)) {
	        var lastCount = noteName.substr(14) * 1;
	        if (newCount <= lastCount) {
	          newCount = lastCount + 1;
	        }
	      }
	    });
	    return 'Untitled Note ' + newCount;
	  };
	
	  vm.cloneNoteName = function () {
	    var copyCount = 1;
	    var newCloneName = '';
	    var lastIndex = vm.sourceNoteName.lastIndexOf(' ');
	    var endsWithNumber = !!vm.sourceNoteName.match('^.+?\\s\\d$');
	    var noteNamePrefix = endsWithNumber ? vm.sourceNoteName.substr(0, lastIndex) : vm.sourceNoteName;
	    var regexp = new RegExp('^' + noteNamePrefix + ' .+');
	
	    angular.forEach(vm.notes.flatList, function (noteName) {
	      noteName = noteName.name;
	      if (noteName.match(regexp)) {
	        var lastCopyCount = noteName.substr(lastIndex).trim();
	        newCloneName = noteNamePrefix;
	        lastCopyCount = parseInt(lastCopyCount);
	        if (copyCount <= lastCopyCount) {
	          copyCount = lastCopyCount + 1;
	        }
	      }
	    });
	
	    if (!newCloneName) {
	      newCloneName = vm.sourceNoteName;
	    }
	    return newCloneName + ' ' + copyCount;
	  };
	
	  vm.getInterpreterSettings = function () {
	    vm.websocketMsgSrv.getInterpreterSettings();
	  };
	
	  $scope.$on('interpreterSettings', function (event, data) {
	    $scope.interpreterSettings = data.interpreterSettings;
	
	    //initialize default interpreter with Spark interpreter
	    $scope.note.defaultInterpreter = data.interpreterSettings[0];
	  });
	}

/***/ },
/* 38 */
/***/ function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').controller('NoteImportCtrl', NoteImportCtrl);
	
	NoteImportCtrl.$inject = ['$scope', '$timeout', 'websocketMsgSrv'];
	
	function NoteImportCtrl($scope, $timeout, websocketMsgSrv) {
	  var vm = this;
	  $scope.note = {};
	  $scope.note.step1 = true;
	  $scope.note.step2 = false;
	  $scope.maxLimit = '';
	  var limit = 0;
	
	  websocketMsgSrv.listConfigurations();
	  $scope.$on('configurationsInfo', function (scope, event) {
	    limit = event.configurations['zeppelin.websocket.max.text.message.size'];
	    $scope.maxLimit = Math.round(limit / 1048576);
	  });
	
	  vm.resetFlags = function () {
	    $scope.note = {};
	    $scope.note.step1 = true;
	    $scope.note.step2 = false;
	    angular.element('#noteImportFile').val('');
	  };
	
	  $scope.uploadFile = function () {
	    angular.element('#noteImportFile').click();
	  };
	
	  $scope.importFile = function (element) {
	    $scope.note.errorText = '';
	    $scope.note.importFile = element.files[0];
	    var file = $scope.note.importFile;
	    var reader = new FileReader();
	
	    if (file.size > limit) {
	      $scope.note.errorText = 'File size limit Exceeded!';
	      $scope.$apply();
	      return;
	    }
	
	    reader.onloadend = function () {
	      vm.processImportJson(reader.result);
	    };
	
	    if (file) {
	      reader.readAsText(file);
	    }
	  };
	
	  $scope.uploadURL = function () {
	    $scope.note.errorText = '';
	    $scope.note.step1 = false;
	    $timeout(function () {
	      $scope.note.step2 = true;
	    }, 400);
	  };
	
	  vm.importBack = function () {
	    $scope.note.errorText = '';
	    $timeout(function () {
	      $scope.note.step1 = true;
	    }, 400);
	    $scope.note.step2 = false;
	  };
	
	  vm.importNote = function () {
	    $scope.note.errorText = '';
	    if ($scope.note.importUrl) {
	      jQuery.ajax({
	        url: $scope.note.importUrl,
	        type: 'GET',
	        dataType: 'json',
	        jsonp: false,
	        xhrFields: {
	          withCredentials: false
	        },
	        error: function error(xhr, ajaxOptions, thrownError) {
	          $scope.note.errorText = 'Unable to Fetch URL';
	          $scope.$apply();
	        } }).done(function (data) {
	        vm.processImportJson(data);
	      });
	    } else {
	      $scope.note.errorText = 'Enter URL';
	      $scope.$apply();
	    }
	  };
	
	  vm.processImportJson = function (result) {
	    if ((typeof result === 'undefined' ? 'undefined' : _typeof(result)) !== 'object') {
	      try {
	        result = JSON.parse(result);
	      } catch (e) {
	        $scope.note.errorText = 'JSON parse exception';
	        $scope.$apply();
	        return;
	      }
	    }
	    if (result.paragraphs && result.paragraphs.length > 0) {
	      if (!$scope.note.noteImportName) {
	        $scope.note.noteImportName = result.name;
	      } else {
	        result.name = $scope.note.noteImportName;
	      }
	      websocketMsgSrv.importNote(result);
	      //angular.element('#noteImportModal').modal('hide');
	    } else {
	      $scope.note.errorText = 'Invalid JSON';
	    }
	    $scope.$apply();
	  };
	
	  /*
	   ** $scope.$on functions below
	   */
	
	  $scope.$on('setNoteMenu', function (event, notes) {
	    vm.resetFlags();
	    angular.element('#noteImportModal').modal('hide');
	  });
	}

/***/ },
/* 39 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').directive('popoverHtmlUnsafe', popoverHtmlUnsafe);
	
	popoverHtmlUnsafe.$inject = ['$tooltip'];
	
	function popoverHtmlUnsafe($tooltip) {
	  return $tooltip('popoverHtmlUnsafe', 'popover', 'click');
	}

/***/ },
/* 40 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').directive('popoverHtmlUnsafePopup', popoverHtmlUnsafePopup);
	
	function popoverHtmlUnsafePopup() {
	  return {
	    restrict: 'EA',
	    replace: true,
	    scope: { title: '@', content: '@', placement: '@', animation: '&', isOpen: '&' },
	    templateUrl: 'components/popover-html-unsafe/popover-html-unsafe-popup.html'
	  };
	}

/***/ },
/* 41 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	codeEditor.$inject = ["$templateRequest", "$compile"];
	angular.module('zeppelinWebApp').directive('codeEditor', codeEditor);
	
	function codeEditor($templateRequest, $compile) {
	  return {
	    restrict: 'AE',
	    scope: {
	      paragraphId: '=paragraphId',
	      paragraph: '=paragraphContext',
	      dirtyText: '=dirtyText',
	      originalText: '=originalText',
	      onLoad: '=onLoad',
	      revisionView: '=revisionView'
	    },
	    link: function link(scope, element, attrs, controller) {
	      $templateRequest('components/editor/ace.editor.directive.html').then(function (editorHtml) {
	        var editor = angular.element(editorHtml);
	        editor.attr('id', scope.paragraphId + '_editor');
	        element.append(editor);
	        $compile(editor)(scope);
	        console.log('codeEditor directive revision view is ' + scope.revisionView);
	      });
	    }
	  };
	}

/***/ },
/* 42 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').directive('ngEnter', ngEnter);
	
	function ngEnter() {
	  return function (scope, element, attrs) {
	    element.bind('keydown keypress', function (event) {
	      if (event.which === 13) {
	        if (!event.shiftKey) {
	          scope.$apply(function () {
	            scope.$eval(attrs.ngEnter);
	          });
	        }
	        event.preventDefault();
	      }
	    });
	  };
	}

/***/ },
/* 43 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').directive('dropdownInput', dropdownInput);
	
	function dropdownInput() {
	  return {
	    restrict: 'A',
	    link: function link(scope, element) {
	      element.bind('click', function (event) {
	        event.stopPropagation();
	      });
	    }
	  };
	}

/***/ },
/* 44 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').directive('resizable', resizable);
	
	function resizable() {
	  var resizableConfig = {
	    autoHide: true,
	    handles: 'se',
	    helper: 'resizable-helper',
	    stop: function stop() {
	      angular.element(this).css({ 'width': '100%', 'height': '100%' });
	    }
	  };
	
	  return {
	    restrict: 'A',
	    scope: {
	      callback: '&onResize'
	    },
	    link: function postLink(scope, elem, attrs) {
	      attrs.$observe('resize', function (resize) {
	        var resetResize = function resetResize(elem, resize) {
	          var colStep = window.innerWidth / 12;
	          elem.off('resizestop');
	          var conf = angular.copy(resizableConfig);
	          if (resize.graphType === 'TABLE' || resize.graphType === 'TEXT') {
	            conf.grid = [colStep, 10];
	            conf.minHeight = 100;
	          } else {
	            conf.grid = [colStep, 10000];
	            conf.minHeight = 0;
	          }
	          conf.maxWidth = window.innerWidth;
	
	          elem.resizable(conf);
	          elem.on('resizestop', function () {
	            if (scope.callback) {
	              var height = elem.height();
	              if (height < 50) {
	                height = 300;
	              }
	              scope.callback({ width: Math.ceil(elem.width() / colStep), height: height });
	            }
	          });
	        };
	
	        resize = JSON.parse(resize);
	        if (resize.allowresize === 'true') {
	          resetResize(elem, resize);
	          angular.element(window).resize(function () {
	            resetResize(elem, resize);
	          });
	        }
	      });
	    }
	  };
	}

/***/ },
/* 45 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').directive('modalvisible', modalvisible);
	
	function modalvisible() {
	  return {
	    restrict: 'A',
	    scope: {
	      preVisibleCallback: '&previsiblecallback',
	      postVisibleCallback: '&postvisiblecallback',
	      targetinput: '@targetinput'
	    },
	    link: function link(scope, element, attrs) {
	      // Add some listeners
	      var previsibleMethod = scope.preVisibleCallback;
	      var postVisibleMethod = scope.postVisibleCallback;
	      element.on('show.bs.modal', function (e) {
	        var relatedTarget = angular.element(e.relatedTarget);
	        var clone = relatedTarget.data('clone');
	        var sourceNoteName = relatedTarget.data('source-note-name');
	        var cloneNote = clone ? true : false;
	        previsibleMethod()(cloneNote, sourceNoteName);
	      });
	      element.on('shown.bs.modal', function (e) {
	        if (scope.targetinput) {
	          angular.element(e.target).find('input#' + scope.targetinput).select();
	        }
	        postVisibleMethod();
	      });
	    }
	  };
	}

/***/ },
/* 46 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').service('websocketMsgSrv', websocketMsgSrv);
	
	websocketMsgSrv.$inject = ['$rootScope', 'websocketEvents'];
	
	function websocketMsgSrv($rootScope, websocketEvents) {
	  return {
	
	    getHomeNote: function getHomeNote() {
	      websocketEvents.sendNewEvent({ op: 'GET_HOME_NOTE' });
	    },
	
	    createNotebook: function createNotebook(noteName, defaultInterpreterId) {
	      websocketEvents.sendNewEvent({
	        op: 'NEW_NOTE',
	        data: {
	          name: noteName,
	          defaultInterpreterId: defaultInterpreterId
	        }
	      });
	    },
	
	    moveNoteToTrash: function moveNoteToTrash(noteId) {
	      websocketEvents.sendNewEvent({ op: 'MOVE_NOTE_TO_TRASH', data: { id: noteId } });
	    },
	
	    moveFolderToTrash: function moveFolderToTrash(folderId) {
	      websocketEvents.sendNewEvent({ op: 'MOVE_FOLDER_TO_TRASH', data: { id: folderId } });
	    },
	
	    restoreNote: function restoreNote(noteId) {
	      websocketEvents.sendNewEvent({ op: 'RESTORE_NOTE', data: { id: noteId } });
	    },
	
	    restoreFolder: function restoreFolder(folderId) {
	      websocketEvents.sendNewEvent({ op: 'RESTORE_FOLDER', data: { id: folderId } });
	    },
	
	    restoreAll: function restoreAll() {
	      websocketEvents.sendNewEvent({ op: 'RESTORE_ALL' });
	    },
	
	    deleteNote: function deleteNote(noteId) {
	      websocketEvents.sendNewEvent({ op: 'DEL_NOTE', data: { id: noteId } });
	    },
	
	    removeFolder: function removeFolder(folderId) {
	      websocketEvents.sendNewEvent({ op: 'REMOVE_FOLDER', data: { id: folderId } });
	    },
	
	    emptyTrash: function emptyTrash() {
	      websocketEvents.sendNewEvent({ op: 'EMPTY_TRASH' });
	    },
	
	    cloneNote: function cloneNote(noteIdToClone, newNoteName) {
	      websocketEvents.sendNewEvent({ op: 'CLONE_NOTE', data: { id: noteIdToClone, name: newNoteName } });
	    },
	
	    getNoteList: function getNoteList() {
	      websocketEvents.sendNewEvent({ op: 'LIST_NOTES' });
	    },
	
	    reloadAllNotesFromRepo: function reloadAllNotesFromRepo() {
	      websocketEvents.sendNewEvent({ op: 'RELOAD_NOTES_FROM_REPO' });
	    },
	
	    getNote: function getNote(noteId) {
	      websocketEvents.sendNewEvent({ op: 'GET_NOTE', data: { id: noteId } });
	    },
	
	    updateNote: function updateNote(noteId, noteName, noteConfig) {
	      websocketEvents.sendNewEvent({ op: 'NOTE_UPDATE', data: { id: noteId, name: noteName, config: noteConfig } });
	    },
	
	    updatePersonalizedMode: function updatePersonalizedMode(noteId, modeValue) {
	      websocketEvents.sendNewEvent({ op: 'UPDATE_PERSONALIZED_MODE', data: { id: noteId, personalized: modeValue } });
	    },
	
	    renameNote: function renameNote(noteId, noteName) {
	      websocketEvents.sendNewEvent({ op: 'NOTE_RENAME', data: { id: noteId, name: noteName } });
	    },
	
	    renameFolder: function renameFolder(folderId, folderName) {
	      websocketEvents.sendNewEvent({ op: 'FOLDER_RENAME', data: { id: folderId, name: folderName } });
	    },
	
	    moveParagraph: function moveParagraph(paragraphId, newIndex) {
	      websocketEvents.sendNewEvent({ op: 'MOVE_PARAGRAPH', data: { id: paragraphId, index: newIndex } });
	    },
	
	    insertParagraph: function insertParagraph(newIndex) {
	      websocketEvents.sendNewEvent({ op: 'INSERT_PARAGRAPH', data: { index: newIndex } });
	    },
	
	    copyParagraph: function copyParagraph(newIndex, paragraphTitle, paragraphData, paragraphConfig, paragraphParams) {
	      websocketEvents.sendNewEvent({
	        op: 'COPY_PARAGRAPH',
	        data: {
	          index: newIndex,
	          title: paragraphTitle,
	          paragraph: paragraphData,
	          config: paragraphConfig,
	          params: paragraphParams
	        }
	      });
	    },
	
	    updateAngularObject: function updateAngularObject(noteId, paragraphId, name, value, interpreterGroupId) {
	      websocketEvents.sendNewEvent({
	        op: 'ANGULAR_OBJECT_UPDATED',
	        data: {
	          noteId: noteId,
	          paragraphId: paragraphId,
	          name: name,
	          value: value,
	          interpreterGroupId: interpreterGroupId
	        }
	      });
	    },
	
	    clientBindAngularObject: function clientBindAngularObject(noteId, name, value, paragraphId) {
	      websocketEvents.sendNewEvent({
	        op: 'ANGULAR_OBJECT_CLIENT_BIND',
	        data: {
	          noteId: noteId,
	          name: name,
	          value: value,
	          paragraphId: paragraphId
	        }
	      });
	    },
	
	    clientUnbindAngularObject: function clientUnbindAngularObject(noteId, name, paragraphId) {
	      websocketEvents.sendNewEvent({
	        op: 'ANGULAR_OBJECT_CLIENT_UNBIND',
	        data: {
	          noteId: noteId,
	          name: name,
	          paragraphId: paragraphId
	        }
	      });
	    },
	
	    cancelParagraphRun: function cancelParagraphRun(paragraphId) {
	      websocketEvents.sendNewEvent({ op: 'CANCEL_PARAGRAPH', data: { id: paragraphId } });
	    },
	
	    runParagraph: function runParagraph(paragraphId, paragraphTitle, paragraphData, paragraphConfig, paragraphParams) {
	      websocketEvents.sendNewEvent({
	        op: 'RUN_PARAGRAPH',
	        data: {
	          id: paragraphId,
	          title: paragraphTitle,
	          paragraph: paragraphData,
	          config: paragraphConfig,
	          params: paragraphParams
	        }
	      });
	    },
	
	    runAllParagraphs: function runAllParagraphs(noteId, paragraphs) {
	      websocketEvents.sendNewEvent({
	        op: 'RUN_ALL_PARAGRAPHS',
	        data: {
	          noteId: noteId,
	          paragraphs: JSON.stringify(paragraphs)
	        }
	      });
	    },
	
	    removeParagraph: function removeParagraph(paragraphId) {
	      websocketEvents.sendNewEvent({ op: 'PARAGRAPH_REMOVE', data: { id: paragraphId } });
	    },
	
	    clearParagraphOutput: function clearParagraphOutput(paragraphId) {
	      websocketEvents.sendNewEvent({ op: 'PARAGRAPH_CLEAR_OUTPUT', data: { id: paragraphId } });
	    },
	
	    clearAllParagraphOutput: function clearAllParagraphOutput(noteId) {
	      websocketEvents.sendNewEvent({ op: 'PARAGRAPH_CLEAR_ALL_OUTPUT', data: { id: noteId } });
	    },
	
	    completion: function completion(paragraphId, buf, cursor) {
	      websocketEvents.sendNewEvent({
	        op: 'COMPLETION',
	        data: {
	          id: paragraphId,
	          buf: buf,
	          cursor: cursor
	        }
	      });
	    },
	
	    commitParagraph: function commitParagraph(paragraphId, paragraphTitle, paragraphData, paragraphConfig, paragraphParams) {
	      websocketEvents.sendNewEvent({
	        op: 'COMMIT_PARAGRAPH',
	        data: {
	          id: paragraphId,
	          title: paragraphTitle,
	          paragraph: paragraphData,
	          config: paragraphConfig,
	          params: paragraphParams
	        }
	      });
	    },
	
	    importNote: function importNote(note) {
	      websocketEvents.sendNewEvent({
	        op: 'IMPORT_NOTE',
	        data: {
	          note: note
	        }
	      });
	    },
	
	    checkpointNote: function checkpointNote(noteId, commitMessage) {
	      websocketEvents.sendNewEvent({
	        op: 'CHECKPOINT_NOTE',
	        data: {
	          noteId: noteId,
	          commitMessage: commitMessage
	        }
	      });
	    },
	
	    setNoteRevision: function setNoteRevision(noteId, revisionId) {
	      websocketEvents.sendNewEvent({
	        op: 'SET_NOTE_REVISION',
	        data: {
	          noteId: noteId,
	          revisionId: revisionId
	        }
	      });
	    },
	
	    listRevisionHistory: function listRevisionHistory(noteId) {
	      websocketEvents.sendNewEvent({
	        op: 'LIST_REVISION_HISTORY',
	        data: {
	          noteId: noteId
	        }
	      });
	    },
	
	    getNoteByRevision: function getNoteByRevision(noteId, revisionId) {
	      websocketEvents.sendNewEvent({
	        op: 'NOTE_REVISION',
	        data: {
	          noteId: noteId,
	          revisionId: revisionId
	        }
	      });
	    },
	
	    getEditorSetting: function getEditorSetting(paragraphId, replName) {
	      websocketEvents.sendNewEvent({
	        op: 'EDITOR_SETTING',
	        data: {
	          paragraphId: paragraphId,
	          magic: replName
	        }
	      });
	    },
	
	    isConnected: function isConnected() {
	      return websocketEvents.isConnected();
	    },
	
	    getNoteJobsList: function getNoteJobsList() {
	      websocketEvents.sendNewEvent({ op: 'LIST_NOTE_JOBS' });
	    },
	
	    getUpdateNoteJobsList: function getUpdateNoteJobsList(lastUpdateServerUnixTime) {
	      websocketEvents.sendNewEvent({ op: 'LIST_UPDATE_NOTE_JOBS', data: { lastUpdateUnixTime: lastUpdateServerUnixTime * 1 } });
	    },
	
	    unsubscribeJobManager: function unsubscribeJobManager() {
	      websocketEvents.sendNewEvent({ op: 'UNSUBSCRIBE_UPDATE_NOTE_JOBS' });
	    },
	
	    getInterpreterBindings: function getInterpreterBindings(noteId) {
	      websocketEvents.sendNewEvent({ op: 'GET_INTERPRETER_BINDINGS', data: { noteId: noteId } });
	    },
	
	    saveInterpreterBindings: function saveInterpreterBindings(noteId, selectedSettingIds) {
	      websocketEvents.sendNewEvent({ op: 'SAVE_INTERPRETER_BINDINGS',
	        data: { noteId: noteId, selectedSettingIds: selectedSettingIds } });
	    },
	
	    listConfigurations: function listConfigurations() {
	      websocketEvents.sendNewEvent({ op: 'LIST_CONFIGURATIONS' });
	    },
	
	    getInterpreterSettings: function getInterpreterSettings() {
	      websocketEvents.sendNewEvent({ op: 'GET_INTERPRETER_SETTINGS' });
	    }
	
	  };
	}

/***/ },
/* 47 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').factory('websocketEvents', websocketEvents);
	
	websocketEvents.$inject = ['$rootScope', '$websocket', '$location', 'baseUrlSrv'];
	
	function websocketEvents($rootScope, $websocket, $location, baseUrlSrv) {
	  var websocketCalls = {};
	  var pingIntervalId;
	
	  websocketCalls.ws = $websocket(baseUrlSrv.getWebsocketUrl());
	  websocketCalls.ws.reconnectIfNotNormalClose = true;
	
	  websocketCalls.ws.onOpen(function () {
	    console.log('Websocket created');
	    $rootScope.$broadcast('setConnectedStatus', true);
	    pingIntervalId = setInterval(function () {
	      websocketCalls.sendNewEvent({ op: 'PING' });
	    }, 10000);
	  });
	
	  websocketCalls.sendNewEvent = function (data) {
	    if ($rootScope.ticket !== undefined) {
	      data.principal = $rootScope.ticket.principal;
	      data.ticket = $rootScope.ticket.ticket;
	      data.roles = $rootScope.ticket.roles;
	    } else {
	      data.principal = '';
	      data.ticket = '';
	      data.roles = '';
	    }
	    console.log('Send >> %o, %o, %o, %o, %o', data.op, data.principal, data.ticket, data.roles, data);
	    websocketCalls.ws.send(JSON.stringify(data));
	  };
	
	  websocketCalls.isConnected = function () {
	    return websocketCalls.ws.socket.readyState === 1;
	  };
	
	  websocketCalls.ws.onMessage(function (event) {
	    var payload;
	    if (event.data) {
	      payload = angular.fromJson(event.data);
	    }
	    console.log('Receive << %o, %o', payload.op, payload);
	    var op = payload.op;
	    var data = payload.data;
	    if (op === 'NOTE') {
	      $rootScope.$broadcast('setNoteContent', data.note);
	    } else if (op === 'NEW_NOTE') {
	      $location.path('/notebook/' + data.note.id);
	    } else if (op === 'NOTES_INFO') {
	      $rootScope.$broadcast('setNoteMenu', data.notes);
	    } else if (op === 'LIST_NOTE_JOBS') {
	      $rootScope.$broadcast('setNoteJobs', data.noteJobs);
	    } else if (op === 'LIST_UPDATE_NOTE_JOBS') {
	      $rootScope.$broadcast('setUpdateNoteJobs', data.noteRunningJobs);
	    } else if (op === 'AUTH_INFO') {
	      var btn = [];
	      if ($rootScope.ticket.roles === '[]') {
	        btn = [{
	          label: 'Close',
	          action: function action(dialog) {
	            dialog.close();
	          }
	        }];
	      } else {
	        btn = [{
	          label: 'Login',
	          action: function action(dialog) {
	            dialog.close();
	            angular.element('#loginModal').modal({
	              show: 'true'
	            });
	          }
	        }, {
	          label: 'Cancel',
	          action: function action(dialog) {
	            dialog.close();
	            // using $rootScope.apply to trigger angular digest cycle
	            // changing $location.path inside bootstrap modal wont trigger digest
	            $rootScope.$apply(function () {
	              $location.path('/');
	            });
	          }
	        }];
	      }
	
	      BootstrapDialog.show({
	        closable: false,
	        closeByBackdrop: false,
	        closeByKeyboard: false,
	        title: 'Insufficient privileges',
	        message: data.info.toString(),
	        buttons: btn
	      });
	    } else if (op === 'PARAGRAPH') {
	      $rootScope.$broadcast('updateParagraph', data);
	    } else if (op === 'PARAGRAPH_APPEND_OUTPUT') {
	      $rootScope.$broadcast('appendParagraphOutput', data);
	    } else if (op === 'PARAGRAPH_UPDATE_OUTPUT') {
	      $rootScope.$broadcast('updateParagraphOutput', data);
	    } else if (op === 'PROGRESS') {
	      $rootScope.$broadcast('updateProgress', data);
	    } else if (op === 'COMPLETION_LIST') {
	      $rootScope.$broadcast('completionList', data);
	    } else if (op === 'EDITOR_SETTING') {
	      $rootScope.$broadcast('editorSetting', data);
	    } else if (op === 'ANGULAR_OBJECT_UPDATE') {
	      $rootScope.$broadcast('angularObjectUpdate', data);
	    } else if (op === 'ANGULAR_OBJECT_REMOVE') {
	      $rootScope.$broadcast('angularObjectRemove', data);
	    } else if (op === 'APP_APPEND_OUTPUT') {
	      $rootScope.$broadcast('appendAppOutput', data);
	    } else if (op === 'APP_UPDATE_OUTPUT') {
	      $rootScope.$broadcast('updateAppOutput', data);
	    } else if (op === 'APP_LOAD') {
	      $rootScope.$broadcast('appLoad', data);
	    } else if (op === 'APP_STATUS_CHANGE') {
	      $rootScope.$broadcast('appStatusChange', data);
	    } else if (op === 'LIST_REVISION_HISTORY') {
	      $rootScope.$broadcast('listRevisionHistory', data);
	    } else if (op === 'NOTE_REVISION') {
	      $rootScope.$broadcast('noteRevision', data);
	    } else if (op === 'INTERPRETER_BINDINGS') {
	      $rootScope.$broadcast('interpreterBindings', data);
	    } else if (op === 'ERROR_INFO') {
	      BootstrapDialog.show({
	        closable: false,
	        closeByBackdrop: false,
	        closeByKeyboard: false,
	        title: 'Details',
	        message: data.info.toString(),
	        buttons: [{
	          // close all the dialogs when there are error on running all paragraphs
	          label: 'Close',
	          action: function action() {
	            BootstrapDialog.closeAll();
	          }
	        }]
	      });
	    } else if (op === 'SESSION_LOGOUT') {
	      $rootScope.$broadcast('session_logout', data);
	    } else if (op === 'CONFIGURATIONS_INFO') {
	      $rootScope.$broadcast('configurationsInfo', data);
	    } else if (op === 'INTERPRETER_SETTINGS') {
	      $rootScope.$broadcast('interpreterSettings', data);
	    } else if (op === 'PARAGRAPH_ADDED') {
	      $rootScope.$broadcast('addParagraph', data.paragraph, data.index);
	    } else if (op === 'PARAGRAPH_REMOVED') {
	      $rootScope.$broadcast('removeParagraph', data.id);
	    } else if (op === 'PARAGRAPH_MOVED') {
	      $rootScope.$broadcast('moveParagraph', data.id, data.index);
	    } else if (op === 'NOTE_UPDATED') {
	      $rootScope.$broadcast('updateNote', data.name, data.config, data.info);
	    } else if (op === 'SET_NOTE_REVISION') {
	      $rootScope.$broadcast('setNoteRevisionResult', data);
	    }
	  });
	
	  websocketCalls.ws.onError(function (event) {
	    console.log('error message: ', event);
	    $rootScope.$broadcast('setConnectedStatus', false);
	  });
	
	  websocketCalls.ws.onClose(function (event) {
	    console.log('close message: ', event);
	    if (pingIntervalId !== undefined) {
	      clearInterval(pingIntervalId);
	      pingIntervalId = undefined;
	    }
	    $rootScope.$broadcast('setConnectedStatus', false);
	  });
	
	  return websocketCalls;
	}

/***/ },
/* 48 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').factory('noteListDataFactory', noteListDataFactory);
	
	noteListDataFactory.$inject = ['TRASH_FOLDER_ID'];
	
	function noteListDataFactory(TRASH_FOLDER_ID) {
	  var notes = {
	    root: { children: [] },
	    flatList: [],
	    flatFolderMap: {},
	
	    setNotes: function setNotes(notesList) {
	      // a flat list to boost searching
	      notes.flatList = _.map(notesList, function (note) {
	        note.isTrash = note.name ? note.name.split('/')[0] === TRASH_FOLDER_ID : false;
	        return note;
	      });
	
	      // construct the folder-based tree
	      notes.root = { children: [] };
	      notes.flatFolderMap = {};
	      _.reduce(notesList, function (root, note) {
	        var noteName = note.name || note.id;
	        var nodes = noteName.match(/([^\/][^\/]*)/g);
	
	        // recursively add nodes
	        addNode(root, nodes, note.id);
	
	        return root;
	      }, notes.root);
	    }
	  };
	
	  var addNode = function addNode(curDir, nodes, noteId) {
	    if (nodes.length === 1) {
	      // the leaf
	      curDir.children.push({
	        name: nodes[0],
	        id: noteId,
	        path: curDir.id ? curDir.id + '/' + nodes[0] : nodes[0],
	        isTrash: curDir.id ? curDir.id.split('/')[0] === TRASH_FOLDER_ID : false
	      });
	    } else {
	      // a folder node
	      var node = nodes.shift();
	      var dir = _.find(curDir.children, function (c) {
	        return c.name === node && c.children !== undefined;
	      });
	      if (dir !== undefined) {
	        // found an existing dir
	        addNode(dir, nodes, noteId);
	      } else {
	        var newDir = {
	          id: curDir.id ? curDir.id + '/' + node : node,
	          name: node,
	          hidden: true,
	          children: [],
	          isTrash: curDir.id ? curDir.id.split('/')[0] === TRASH_FOLDER_ID : false
	        };
	
	        // add the folder to flat folder map
	        notes.flatFolderMap[newDir.id] = newDir;
	
	        curDir.children.push(newDir);
	        addNode(newDir, nodes, noteId);
	      }
	    }
	  };
	
	  return notes;
	}

/***/ },
/* 49 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').service('baseUrlSrv', baseUrlSrv);
	
	function baseUrlSrv() {
	  this.getPort = function () {
	    var port = Number(location.port);
	    if (!port) {
	      port = 80;
	      if (location.protocol === 'https:') {
	        port = 443;
	      }
	    }
	    //Exception for when running locally via grunt
	    if (port === 3333 || port === 9000) {
	      port = 8080;
	    }
	    return port;
	  };
	
	  this.getWebsocketUrl = function () {
	    var wsProtocol = location.protocol === 'https:' ? 'wss:' : 'ws:';
	    return wsProtocol + '//' + location.hostname + ':' + this.getPort() + skipTrailingSlash(location.pathname) + '/ws';
	  };
	
	  this.getRestApiBase = function () {
	    return location.protocol + '//' + location.hostname + ':' + this.getPort() + skipTrailingSlash(location.pathname) + '/api';
	  };
	
	  var skipTrailingSlash = function skipTrailingSlash(path) {
	    return path.replace(/\/$/, '');
	  };
	}

/***/ },
/* 50 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').service('browserDetectService', browserDetectService);
	
	function browserDetectService() {
	  this.detectIE = function () {
	    var ua = window.navigator.userAgent;
	    var msie = ua.indexOf('MSIE ');
	    if (msie > 0) {
	      // IE 10 or older => return version number
	      return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
	    }
	    var trident = ua.indexOf('Trident/');
	    if (trident > 0) {
	      // IE 11 => return version number
	      var rv = ua.indexOf('rv:');
	      return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
	    }
	    var edge = ua.indexOf('Edge/');
	    if (edge > 0) {
	      // IE 12 (aka Edge) => return version number
	      return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
	    }
	    // other browser
	    return false;
	  };
	}

/***/ },
/* 51 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').service('saveAsService', saveAsService);
	
	saveAsService.$inject = ['browserDetectService'];
	
	function saveAsService(browserDetectService) {
	  this.saveAs = function (content, filename, extension) {
	    var BOM = '\uFEFF';
	    if (browserDetectService.detectIE()) {
	      angular.element('body').append('<iframe id="SaveAsId" style="display: none"></iframe>');
	      var frameSaveAs = angular.element('body > iframe#SaveAsId')[0].contentWindow;
	      content = BOM + content;
	      frameSaveAs.document.open('text/json', 'replace');
	      frameSaveAs.document.write(content);
	      frameSaveAs.document.close();
	      frameSaveAs.focus();
	      var t1 = Date.now();
	      frameSaveAs.document.execCommand('SaveAs', false, filename + '.' + extension);
	      var t2 = Date.now();
	
	      //This means, this version of IE dosen't support auto download of a file with extension provided in param
	      //falling back to ".txt"
	      if (t1 === t2) {
	        frameSaveAs.document.execCommand('SaveAs', true, filename + '.txt');
	      }
	      angular.element('body > iframe#SaveAsId').remove();
	    } else {
	      content = 'data:image/svg;charset=utf-8,' + BOM + encodeURIComponent(content);
	      angular.element('body').append('<a id="SaveAsId"></a>');
	      var saveAsElement = angular.element('body > a#SaveAsId');
	      saveAsElement.attr('href', content);
	      saveAsElement.attr('download', filename + '.' + extension);
	      saveAsElement.attr('target', '_blank');
	      saveAsElement[0].click();
	      saveAsElement.remove();
	    }
	  };
	}

/***/ },
/* 52 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').service('searchService', searchService);
	
	searchService.$inject = ['$resource', 'baseUrlSrv'];
	
	function searchService($resource, baseUrlSrv) {
	  this.search = function (term) {
	    this.searchTerm = term.q;
	    console.log('Searching for: %o', term.q);
	    if (!term.q) {
	      //TODO(bzz): empty string check
	      return;
	    }
	    var encQuery = window.encodeURIComponent(term.q);
	    return $resource(baseUrlSrv.getRestApiBase() + '/notebook/search?q=' + encQuery, {}, {
	      query: { method: 'GET' }
	    });
	  };
	
	  this.searchTerm = '';
	}

/***/ },
/* 53 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').controller('LoginCtrl', LoginCtrl);
	
	LoginCtrl.$inject = ['$scope', '$rootScope', '$http', '$httpParamSerializer', 'baseUrlSrv', '$location', '$timeout'];
	function LoginCtrl($scope, $rootScope, $http, $httpParamSerializer, baseUrlSrv, $location, $timeout) {
	
	  $scope.SigningIn = false;
	  $scope.loginParams = {};
	  $scope.login = function () {
	
	    $scope.SigningIn = true;
	    $http({
	      method: 'POST',
	      url: baseUrlSrv.getRestApiBase() + '/login',
	      headers: {
	        'Content-Type': 'application/x-www-form-urlencoded'
	      },
	      data: $httpParamSerializer({
	        'userName': $scope.loginParams.userName,
	        'password': $scope.loginParams.password
	      })
	    }).then(function successCallback(response) {
	      $rootScope.ticket = response.data.body;
	      angular.element('#loginModal').modal('toggle');
	      $rootScope.$broadcast('loginSuccess', true);
	      $rootScope.userName = $scope.loginParams.userName;
	      $scope.SigningIn = false;
	
	      //redirect to the page from where the user originally was
	      if ($location.search() && $location.search()['ref']) {
	        $timeout(function () {
	          var redirectLocation = $location.search()['ref'];
	          $location.$$search = {};
	          $location.path(redirectLocation);
	        }, 100);
	      }
	    }, function errorCallback(errorResponse) {
	      $scope.loginParams.errorText = 'The username and password that you entered don\'t match.';
	      $scope.SigningIn = false;
	    });
	  };
	
	  var initValues = function initValues() {
	    $scope.loginParams = {
	      userName: '',
	      password: ''
	    };
	  };
	
	  //handle session logout message received from WebSocket
	  $rootScope.$on('session_logout', function (event, data) {
	    if ($rootScope.userName !== '') {
	      $rootScope.userName = '';
	      $rootScope.ticket = undefined;
	
	      setTimeout(function () {
	        $scope.loginParams = {};
	        $scope.loginParams.errorText = data.info;
	        angular.element('.nav-login-btn').click();
	      }, 1000);
	      var locationPath = $location.path();
	      $location.path('/').search('ref', locationPath);
	    }
	  });
	
	  /*
	   ** $scope.$on functions below
	   */
	  $scope.$on('initLoginValues', function () {
	    initValues();
	  });
	}

/***/ },
/* 54 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').controller('ElasticInputCtrl', ElasticInputCtrl);
	
	function ElasticInputCtrl() {
	  var vm = this;
	  vm.showEditor = false;
	  vm.value = '';
	}

/***/ },
/* 55 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').service('noteActionSrv', noteActionSrv);
	
	noteActionSrv.$inject = ['websocketMsgSrv', '$location', 'renameSrv', 'noteListDataFactory'];
	
	function noteActionSrv(websocketMsgSrv, $location, renameSrv, noteListDataFactory) {
	  this.moveNoteToTrash = function (noteId, redirectToHome) {
	    BootstrapDialog.confirm({
	      closable: true,
	      title: 'Move this note to trash?',
	      message: 'This note will be moved to <strong>trash</strong>.',
	      callback: function callback(result) {
	        if (result) {
	          websocketMsgSrv.moveNoteToTrash(noteId);
	          if (redirectToHome) {
	            $location.path('/');
	          }
	        }
	      }
	    });
	  };
	
	  this.moveFolderToTrash = function (folderId) {
	    BootstrapDialog.confirm({
	      closable: true,
	      title: 'Move this folder to trash?',
	      message: 'This folder will be moved to <strong>trash</strong>.',
	      callback: function callback(result) {
	        if (result) {
	          websocketMsgSrv.moveFolderToTrash(folderId);
	        }
	      }
	    });
	  };
	
	  this.removeNote = function (noteId, redirectToHome) {
	    BootstrapDialog.confirm({
	      type: BootstrapDialog.TYPE_WARNING,
	      closable: true,
	      title: 'WARNING! This note will be removed permanently',
	      message: 'This cannot be undone. Are you sure?',
	      callback: function callback(result) {
	        if (result) {
	          websocketMsgSrv.deleteNote(noteId);
	          if (redirectToHome) {
	            $location.path('/');
	          }
	        }
	      }
	    });
	  };
	
	  this.removeFolder = function (folderId) {
	    BootstrapDialog.confirm({
	      type: BootstrapDialog.TYPE_WARNING,
	      closable: true,
	      title: 'WARNING! This folder will be removed permanently',
	      message: 'This cannot be undone. Are you sure?',
	      callback: function callback(result) {
	        if (result) {
	          websocketMsgSrv.removeFolder(folderId);
	        }
	      }
	    });
	  };
	
	  this.restoreAll = function () {
	    BootstrapDialog.confirm({
	      closable: true,
	      title: 'Are you sure want to restore all notes in the trash?',
	      message: 'Folders and notes in the trash will be ' + '<strong>merged</strong> into their original position.',
	      callback: function callback(result) {
	        if (result) {
	          websocketMsgSrv.restoreAll();
	        }
	      }
	    });
	  };
	
	  this.emptyTrash = function () {
	    BootstrapDialog.confirm({
	      type: BootstrapDialog.TYPE_WARNING,
	      closable: true,
	      title: 'WARNING! Notes under trash will be removed permanently',
	      message: 'This cannot be undone. Are you sure?',
	      callback: function callback(result) {
	        if (result) {
	          websocketMsgSrv.emptyTrash();
	        }
	      }
	    });
	  };
	
	  this.clearAllParagraphOutput = function (noteId) {
	    BootstrapDialog.confirm({
	      closable: true,
	      title: '',
	      message: 'Do you want to clear all output?',
	      callback: function callback(result) {
	        if (result) {
	          websocketMsgSrv.clearAllParagraphOutput(noteId);
	        }
	      }
	    });
	  };
	
	  this.renameNote = function (noteId, notePath) {
	    renameSrv.openRenameModal({
	      title: 'Rename note',
	      oldName: notePath,
	      callback: function callback(newName) {
	        websocketMsgSrv.renameNote(noteId, newName);
	      }
	    });
	  };
	
	  this.renameFolder = function (folderId) {
	    renameSrv.openRenameModal({
	      title: 'Rename folder',
	      oldName: folderId,
	      callback: function callback(newName) {
	        var newFolderId = normalizeFolderId(newName);
	        if (_.has(noteListDataFactory.flatFolderMap, newFolderId)) {
	          BootstrapDialog.confirm({
	            type: BootstrapDialog.TYPE_WARNING,
	            closable: true,
	            title: 'WARNING! The folder will be MERGED',
	            message: 'The folder will be merged into <strong>' + newFolderId + '</strong>. Are you sure?',
	            callback: function callback(result) {
	              if (result) {
	                websocketMsgSrv.renameFolder(folderId, newFolderId);
	              }
	            }
	          });
	        } else {
	          websocketMsgSrv.renameFolder(folderId, newFolderId);
	        }
	      }
	    });
	  };
	
	  function normalizeFolderId(folderId) {
	    folderId = folderId.trim();
	
	    while (folderId.indexOf('\\') > -1) {
	      folderId = folderId.replace('\\', '/');
	    }
	
	    while (folderId.indexOf('///') > -1) {
	      folderId = folderId.replace('///', '/');
	    }
	
	    folderId = folderId.replace('//', '/');
	
	    if (folderId === '/') {
	      return '/';
	    }
	
	    if (folderId[0] === '/') {
	      folderId = folderId.substring(1);
	    }
	
	    if (folderId.slice(-1) === '/') {
	      folderId = folderId.slice(0, -1);
	    }
	
	    return folderId;
	  }
	}

/***/ },
/* 56 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').service('noteVarShareService', noteVarShareService);
	
	noteVarShareService.$inject = [];
	
	function noteVarShareService() {
	  var store = {};
	
	  this.clear = function () {
	    store = {};
	  };
	
	  this.put = function (key, value) {
	    store[key] = value;
	  };
	
	  this.get = function (key) {
	    return store[key];
	  };
	
	  this.del = function (key) {
	    var v = store[key];
	    delete store[key];
	    return v;
	  };
	}

/***/ },
/* 57 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').controller('RenameCtrl', RenameCtrl);
	
	RenameCtrl.$inject = ['$scope'];
	
	function RenameCtrl($scope) {
	  var self = this;
	
	  $scope.params = { newName: '' };
	  $scope.isValid = true;
	
	  $scope.rename = function () {
	    angular.element('#renameModal').modal('hide');
	    self.callback($scope.params.newName);
	  };
	
	  $scope.$on('openRenameModal', function (event, options) {
	    self.validator = options.validator || defaultValidator;
	    self.callback = options.callback || function () {};
	
	    $scope.title = options.title || 'Rename';
	    $scope.params.newName = options.oldName || '';
	    $scope.validate = function () {
	      $scope.isValid = self.validator($scope.params.newName);
	    };
	
	    angular.element('#renameModal').modal('show');
	  });
	
	  function defaultValidator(str) {
	    return !!str.trim();
	  }
	}

/***/ },
/* 58 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	angular.module('zeppelinWebApp').service('renameSrv', renameSrv);
	
	renameSrv.$inject = ['$rootScope'];
	
	function renameSrv($rootScope) {
	  var self = this;
	
	  /**
	   * <options schema>
	   * title: string - Modal title
	   * oldName: string - name to initialize input
	   * callback: (newName: string)=>void - callback onButtonClick
	   * validator: (str: string)=>boolean - input validator
	   */
	  self.openRenameModal = function (options) {
	    $rootScope.$broadcast('openRenameModal', options);
	  };
	}

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *     http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	(function () {
	
	  angular.module('zeppelinWebApp').service('heliumService', heliumService);
	
	  heliumService.$inject = ['$http', 'baseUrlSrv', 'ngToast'];
	
	  function heliumService($http, baseUrlSrv, ngToast) {
	
	    var url = baseUrlSrv.getRestApiBase() + '/helium/visualizations/load';
	    if ((undefined)) {
	      url = url + '?refresh=true';
	    }
	    var visualizations = [];
	
	    // load should be promise
	    this.load = $http.get(url).success(function (response) {
	      if (response.substring(0, 'ERROR:'.length) !== 'ERROR:') {
	        eval(response);
	      } else {
	        console.error(response);
	      }
	    });
	
	    this.get = function () {
	      return visualizations;
	    };
	
	    this.getVisualizationOrder = function () {
	      return $http.get(baseUrlSrv.getRestApiBase() + '/helium/visualizationOrder');
	    };
	
	    this.setVisualizationOrder = function (list) {
	      return $http.post(baseUrlSrv.getRestApiBase() + '/helium/visualizationOrder', list);
	    };
	
	    this.getAllPackageInfo = function () {
	      return $http.get(baseUrlSrv.getRestApiBase() + '/helium/all');
	    };
	
	    this.enable = function (name, artifact) {
	      return $http.post(baseUrlSrv.getRestApiBase() + '/helium/enable/' + name, artifact);
	    };
	
	    this.disable = function (name) {
	      return $http.post(baseUrlSrv.getRestApiBase() + '/helium/disable/' + name);
	    };
	  };
	})();

/***/ }
/******/ ]);


// WEBPACK FOOTER //
// app.997e38abb8f8bc084cb1.js